//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAccountClient {
    /**
     * Register new Company (Owner user)
     * @param body (optional) 
     * @return OK
     */
    registerCompany(body: RegisterCompanyReqA | undefined): Promise<MessageResponseDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    confirmEmail(body: ConfirmEmailReq | undefined): Promise<MessageResponseDto>;
    /**
     * Sends a token to the email id of the user. 
    The token is used to confirm his email id.
     * @param body (optional) 
     * @return OK
     */
    sendConfirmEmailToken(body: SendConfirmEmailTokenReq | undefined): Promise<MessageResponseDto>;
    /**
     * Allows a logged in user to change the password. (Auth)
     * @param body (optional) 
     * @return OK
     */
    changePassword(body: ChangePasswordReq | undefined): Promise<MessageResponseDto>;
    /**
     * Generates a password reset token and sends it to the email id of the user, if he is registered and his email id is confirmed.
     * @param body (optional) 
     * @return OK
     */
    forgotPassword(body: ForgotPasswordReq | undefined): Promise<MessageResponseDto>;
    /**
     * Receives the password reset token generated by ForgotPassword API. 
    It resets the user's password with the newly specified password.
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body: ResetPasswordReq | undefined): Promise<MessageResponseDto>;
}

export class AccountClient implements IAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Register new Company (Owner user)
     * @param body (optional) 
     * @return OK
     */
    registerCompany(body: RegisterCompanyReqA | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Account/RegisterCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterCompany(_response);
        });
    }

    protected processRegisterCompany(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmEmail(body: ConfirmEmailReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Account/ConfirmEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Sends a token to the email id of the user. 
    The token is used to confirm his email id.
     * @param body (optional) 
     * @return OK
     */
    sendConfirmEmailToken(body: SendConfirmEmailTokenReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Account/SendConfirmEmailToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendConfirmEmailToken(_response);
        });
    }

    protected processSendConfirmEmailToken(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Allows a logged in user to change the password. (Auth)
     * @param body (optional) 
     * @return OK
     */
    changePassword(body: ChangePasswordReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Generates a password reset token and sends it to the email id of the user, if he is registered and his email id is confirmed.
     * @param body (optional) 
     * @return OK
     */
    forgotPassword(body: ForgotPasswordReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Receives the password reset token generated by ForgotPassword API. 
    It resets the user's password with the newly specified password.
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body: ResetPasswordReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface IBillingClient {
    /**
     * Gets all the Bills for the specified year and month (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    get(body: BillReq | undefined): Promise<MediaFileRes[]>;
}

export class BillingClient implements IBillingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets all the Bills for the specified year and month (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    get(body: BillReq | undefined, cancelToken?: CancelToken): Promise<MediaFileRes[]> {
        let url_ = this.baseUrl + "/api/Billing/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<MediaFileRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MediaFileRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MediaFileRes[]>(null as any);
    }
}

export interface ICheckinsClient {
    /**
     * Gets Checkins for recent Shifts for the company (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    pageRecentCheckins(body: PagedReq | undefined): Promise<CheckinResPage>;
}

export class CheckinsClient implements ICheckinsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets Checkins for recent Shifts for the company (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    pageRecentCheckins(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<CheckinResPage> {
        let url_ = this.baseUrl + "/api/Checkins/PageRecentCheckins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageRecentCheckins(_response);
        });
    }

    protected processPageRecentCheckins(response: AxiosResponse): Promise<CheckinResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CheckinResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckinResPage>(null as any);
    }
}

export interface ICompaniesAClient {
    /**
     * Gets Company details (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    get(companyId: number | undefined): Promise<CompanyRes>;
    /**
     * Returns a paged collection of Companies within the system (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined): Promise<CompanyAResPage>;
    /**
     * Gets all the Bills for the specified year and month and company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    getBill(body: BillAReq | undefined): Promise<MediaFileRes[]>;
    /**
     * (Auth roles: Admin)
     * @param timesheetSourceEmail (optional) 
     * @return OK
     */
    getByTimesheetSourceEmail(timesheetSourceEmail: string | undefined): Promise<CompanyARes>;
    /**
     * Pagination in descending order of creation for the specified company (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    pagePayrollPeriods(companyId: number | undefined, body: PagedReq | undefined): Promise<PayrollPeriodMinResAPage>;
    /**
     * Allows to Approve any pending Company whose Owner has confirmed his Email. (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    approve(companyId: number | undefined): Promise<CompanyARes>;
    /**
     * Allows to reject any Company that has not been approved already (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    reject(companyId: number | undefined): Promise<CompanyARes>;
    /**
     * Imports data for the Company using an Excel file. Note that all data will be added newly.
    Data supported: Vehicles (Sheet no. 3) (Auth roles: Admin)
     * @param companyId (optional) 
     * @param excelFile (optional) Max 40 MB file size
     * @return OK
     */
    import(companyId: number | undefined, excelFile: FileParameter | undefined): Promise<MessageResponseDto>;
    /**
     * Emails the Default Owner of the Company an Invoice (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    emailInvoice(body: EmailInvoiceReq | undefined): Promise<MessageResponseDto>;
    /**
     * Locks the specified Company. (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    lock(companyId: number | undefined): Promise<CompanyARes>;
    /**
     * Unlocks the specified Company. (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    unlock(companyId: number | undefined): Promise<CompanyARes>;
    /**
     * Allows to update certain Company fields (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(companyId: number | undefined, body: UpdateCompanyAReq | undefined): Promise<CompanyARes>;
}

export class CompaniesAClient implements ICompaniesAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets Company details (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    get(companyId: number | undefined, cancelToken?: CancelToken): Promise<CompanyRes> {
        let url_ = this.baseUrl + "/api/CompaniesA/Get?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CompanyRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyRes>(null as any);
    }

    /**
     * Returns a paged collection of Companies within the system (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<CompanyAResPage> {
        let url_ = this.baseUrl + "/api/CompaniesA/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<CompanyAResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyAResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyAResPage>(null as any);
    }

    /**
     * Gets all the Bills for the specified year and month and company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    getBill(body: BillAReq | undefined, cancelToken?: CancelToken): Promise<MediaFileRes[]> {
        let url_ = this.baseUrl + "/api/CompaniesA/GetBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBill(_response);
        });
    }

    protected processGetBill(response: AxiosResponse): Promise<MediaFileRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MediaFileRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MediaFileRes[]>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param timesheetSourceEmail (optional) 
     * @return OK
     */
    getByTimesheetSourceEmail(timesheetSourceEmail: string | undefined, cancelToken?: CancelToken): Promise<CompanyARes> {
        let url_ = this.baseUrl + "/api/CompaniesA/GetByTimesheetSourceEmail?";
        if (timesheetSourceEmail === null)
            throw new Error("The parameter 'timesheetSourceEmail' cannot be null.");
        else if (timesheetSourceEmail !== undefined)
            url_ += "timesheetSourceEmail=" + encodeURIComponent("" + timesheetSourceEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByTimesheetSourceEmail(_response);
        });
    }

    protected processGetByTimesheetSourceEmail(response: AxiosResponse): Promise<CompanyARes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyARes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyARes>(null as any);
    }

    /**
     * Pagination in descending order of creation for the specified company (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    pagePayrollPeriods(companyId: number | undefined, body: PagedReq | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodMinResAPage> {
        let url_ = this.baseUrl + "/api/CompaniesA/PagePayrollPeriods?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagePayrollPeriods(_response);
        });
    }

    protected processPagePayrollPeriods(response: AxiosResponse): Promise<PayrollPeriodMinResAPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodMinResAPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodMinResAPage>(null as any);
    }

    /**
     * Allows to Approve any pending Company whose Owner has confirmed his Email. (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    approve(companyId: number | undefined, cancelToken?: CancelToken): Promise<CompanyARes> {
        let url_ = this.baseUrl + "/api/CompaniesA/Approve?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: AxiosResponse): Promise<CompanyARes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyARes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyARes>(null as any);
    }

    /**
     * Allows to reject any Company that has not been approved already (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    reject(companyId: number | undefined, cancelToken?: CancelToken): Promise<CompanyARes> {
        let url_ = this.baseUrl + "/api/CompaniesA/Reject?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: AxiosResponse): Promise<CompanyARes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyARes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyARes>(null as any);
    }

    /**
     * Imports data for the Company using an Excel file. Note that all data will be added newly.
    Data supported: Vehicles (Sheet no. 3) (Auth roles: Admin)
     * @param companyId (optional) 
     * @param excelFile (optional) Max 40 MB file size
     * @return OK
     */
    import(companyId: number | undefined, excelFile: FileParameter | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/CompaniesA/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (excelFile === null || excelFile === undefined)
            throw new Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("ExcelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "ExcelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Emails the Default Owner of the Company an Invoice (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    emailInvoice(body: EmailInvoiceReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/CompaniesA/EmailInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailInvoice(_response);
        });
    }

    protected processEmailInvoice(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Locks the specified Company. (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    lock(companyId: number | undefined, cancelToken?: CancelToken): Promise<CompanyARes> {
        let url_ = this.baseUrl + "/api/CompaniesA/Lock?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLock(_response);
        });
    }

    protected processLock(response: AxiosResponse): Promise<CompanyARes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyARes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyARes>(null as any);
    }

    /**
     * Unlocks the specified Company. (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    unlock(companyId: number | undefined, cancelToken?: CancelToken): Promise<CompanyARes> {
        let url_ = this.baseUrl + "/api/CompaniesA/Unlock?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlock(_response);
        });
    }

    protected processUnlock(response: AxiosResponse): Promise<CompanyARes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyARes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyARes>(null as any);
    }

    /**
     * Allows to update certain Company fields (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(companyId: number | undefined, body: UpdateCompanyAReq | undefined, cancelToken?: CancelToken): Promise<CompanyARes> {
        let url_ = this.baseUrl + "/api/CompaniesA/Update?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CompanyARes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyARes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyARes>(null as any);
    }
}

export interface ICompanyClient {
    /**
     * Gets Company details (Auth roles: Owner)
     * @return OK
     */
    get(): Promise<CompanyRes>;
    /**
     * Allows Owner to update his Company details (Auth roles: Owner)
     * @param notificationEmail (optional) Email Id to which notifications such as Shift Start will be sent.
    In case this is not available, email the Owner's email id
     * @param timesheetSourceEmail (optional) Email Id from which we will receive Linfox Timesheet emails
    e.g. this is populated as Contractor email in jotform
     * @param timesheetSourceEmailNsw (optional) 
     * @param timesheetSourceEmailVic (optional) 
     * @param timesheetSourceEmailQld (optional) 
     * @param timesheetSourceEmailTas (optional) 
     * @param timesheetSourceEmailAct (optional) 
     * @param timesheetSourceEmailNt (optional) 
     * @param timesheetSourceEmailSa (optional) 
     * @param timesheetSourceEmailWa (optional) 
     * @param address_Street (optional) Free text
     * @param address_AreaCode (optional) Or Pincode
     * @param address_Suburb (optional) Or District
     * @param address_City (optional) Or Town
     * @param address_StateId (optional) Or Province
     * @param address_Latitude (optional) 
     * @param address_Longitude (optional) 
     * @param logoImageFile (optional) Max 1 MB file size
    Only png/jpeg files supported
     * @return OK
     */
    update(notificationEmail: string | undefined, timesheetSourceEmail: string | undefined, timesheetSourceEmailNsw: string | undefined, timesheetSourceEmailVic: string | undefined, timesheetSourceEmailQld: string | undefined, timesheetSourceEmailTas: string | undefined, timesheetSourceEmailAct: string | undefined, timesheetSourceEmailNt: string | undefined, timesheetSourceEmailSa: string | undefined, timesheetSourceEmailWa: string | undefined, address_Street: string | undefined, address_AreaCode: string | undefined, address_Suburb: string | undefined, address_City: string | undefined, address_StateId: number | undefined, address_Latitude: number | undefined, address_Longitude: number | undefined, logoImageFile: FileParameter | undefined): Promise<CompanyRes>;
    /**
     * Updates pay rates of all Valid Staff with specified Role (Auth roles: Owner)
     * @param body (optional) 
     * @return OK
     */
    updatePayRate(body: CompanyPayRatesReq | undefined): Promise<MessageResponseDto>;
    /**
     * (Auth roles: Owner)
     * @param body (optional) 
     * @return OK
     */
    updatePayFrequency(body: CompanyPayFrequencyReq | undefined): Promise<CompanyRes>;
    /**
     * Allows Owner to Create ExtCompany details (Auth roles: Owner)
     * @param body (optional) 
     * @return OK
     */
    createExtCompany(body: CreateExtCompanyReq | undefined): Promise<ExtCompanyRes>;
    /**
     * Allows Owner to update ExtCompany details (Auth roles: Owner)
     * @param extCompanyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    upateExtCompany(extCompanyId: number | undefined, body: UpdateExtCompanyReq | undefined): Promise<ExtCompanyRes>;
    /**
     * Allows Owner to delete ExtCompany details
    Note : This is a permanent operation, warn the user. (Auth roles: Owner)
     * @param extCompanyId (optional) 
     * @return OK
     */
    deleteExtCompany(extCompanyId: number | undefined): Promise<MessageResponseDto>;
    /**
     * Allows Owner to Create ExtForm (Auth roles: Owner)
     * @param extCompanyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createExtForm(extCompanyId: number | undefined, body: ExtFormReq | undefined): Promise<ExtFormRes>;
    /**
     * Allows Owner to update ExtForm details (Auth roles: Owner)
     * @param extFormId (optional) 
     * @param extCompanyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateExtForm(extFormId: number | undefined, extCompanyId: number | undefined, body: ExtFormReq | undefined): Promise<ExtFormRes>;
    /**
     * Allows Owner to Delete ExtForm 
    Note : This is a permanent operation, warn the user. (Auth roles: Owner)
     * @param extFormId (optional) 
     * @param extCompanyId (optional) 
     * @return OK
     */
    deleteExtForm(extFormId: number | undefined, extCompanyId: number | undefined): Promise<MessageResponseDto>;
    /**
     * (Auth roles: Owner)
     * @param extFormId (optional) 
     * @param extCompanyId (optional) 
     * @param mediaFile_Description (optional) 
     * @param mediaFile_File (optional) 
     * @return OK
     */
    uploadExtFormHtml(extFormId: number | undefined, extCompanyId: number | undefined, mediaFile_Description: string | undefined, mediaFile_File: FileParameter | undefined): Promise<ExtFormRes>;
    /**
     * (Auth roles: Owner)
     * @param extFormId (optional) 
     * @param extCompanyId (optional) 
     * @return OK
     */
    deleteExtFormHtml(extFormId: number | undefined, extCompanyId: number | undefined): Promise<MessageResponseDto>;
}

export class CompanyClient implements ICompanyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets Company details (Auth roles: Owner)
     * @return OK
     */
    get( cancelToken?: CancelToken): Promise<CompanyRes> {
        let url_ = this.baseUrl + "/api/Company/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CompanyRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyRes>(null as any);
    }

    /**
     * Allows Owner to update his Company details (Auth roles: Owner)
     * @param notificationEmail (optional) Email Id to which notifications such as Shift Start will be sent.
    In case this is not available, email the Owner's email id
     * @param timesheetSourceEmail (optional) Email Id from which we will receive Linfox Timesheet emails
    e.g. this is populated as Contractor email in jotform
     * @param timesheetSourceEmailNsw (optional) 
     * @param timesheetSourceEmailVic (optional) 
     * @param timesheetSourceEmailQld (optional) 
     * @param timesheetSourceEmailTas (optional) 
     * @param timesheetSourceEmailAct (optional) 
     * @param timesheetSourceEmailNt (optional) 
     * @param timesheetSourceEmailSa (optional) 
     * @param timesheetSourceEmailWa (optional) 
     * @param address_Street (optional) Free text
     * @param address_AreaCode (optional) Or Pincode
     * @param address_Suburb (optional) Or District
     * @param address_City (optional) Or Town
     * @param address_StateId (optional) Or Province
     * @param address_Latitude (optional) 
     * @param address_Longitude (optional) 
     * @param logoImageFile (optional) Max 1 MB file size
    Only png/jpeg files supported
     * @return OK
     */
    update(notificationEmail: string | undefined, timesheetSourceEmail: string | undefined, timesheetSourceEmailNsw: string | undefined, timesheetSourceEmailVic: string | undefined, timesheetSourceEmailQld: string | undefined, timesheetSourceEmailTas: string | undefined, timesheetSourceEmailAct: string | undefined, timesheetSourceEmailNt: string | undefined, timesheetSourceEmailSa: string | undefined, timesheetSourceEmailWa: string | undefined, address_Street: string | undefined, address_AreaCode: string | undefined, address_Suburb: string | undefined, address_City: string | undefined, address_StateId: number | undefined, address_Latitude: number | undefined, address_Longitude: number | undefined, logoImageFile: FileParameter | undefined, cancelToken?: CancelToken): Promise<CompanyRes> {
        let url_ = this.baseUrl + "/api/Company/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (notificationEmail === null || notificationEmail === undefined)
            throw new Error("The parameter 'notificationEmail' cannot be null.");
        else
            content_.append("NotificationEmail", notificationEmail.toString());
        if (timesheetSourceEmail === null || timesheetSourceEmail === undefined)
            throw new Error("The parameter 'timesheetSourceEmail' cannot be null.");
        else
            content_.append("TimesheetSourceEmail", timesheetSourceEmail.toString());
        if (timesheetSourceEmailNsw === null || timesheetSourceEmailNsw === undefined)
            throw new Error("The parameter 'timesheetSourceEmailNsw' cannot be null.");
        else
            content_.append("TimesheetSourceEmailNsw", timesheetSourceEmailNsw.toString());
        if (timesheetSourceEmailVic === null || timesheetSourceEmailVic === undefined)
            throw new Error("The parameter 'timesheetSourceEmailVic' cannot be null.");
        else
            content_.append("TimesheetSourceEmailVic", timesheetSourceEmailVic.toString());
        if (timesheetSourceEmailQld === null || timesheetSourceEmailQld === undefined)
            throw new Error("The parameter 'timesheetSourceEmailQld' cannot be null.");
        else
            content_.append("TimesheetSourceEmailQld", timesheetSourceEmailQld.toString());
        if (timesheetSourceEmailTas === null || timesheetSourceEmailTas === undefined)
            throw new Error("The parameter 'timesheetSourceEmailTas' cannot be null.");
        else
            content_.append("TimesheetSourceEmailTas", timesheetSourceEmailTas.toString());
        if (timesheetSourceEmailAct === null || timesheetSourceEmailAct === undefined)
            throw new Error("The parameter 'timesheetSourceEmailAct' cannot be null.");
        else
            content_.append("TimesheetSourceEmailAct", timesheetSourceEmailAct.toString());
        if (timesheetSourceEmailNt === null || timesheetSourceEmailNt === undefined)
            throw new Error("The parameter 'timesheetSourceEmailNt' cannot be null.");
        else
            content_.append("TimesheetSourceEmailNt", timesheetSourceEmailNt.toString());
        if (timesheetSourceEmailSa === null || timesheetSourceEmailSa === undefined)
            throw new Error("The parameter 'timesheetSourceEmailSa' cannot be null.");
        else
            content_.append("TimesheetSourceEmailSa", timesheetSourceEmailSa.toString());
        if (timesheetSourceEmailWa === null || timesheetSourceEmailWa === undefined)
            throw new Error("The parameter 'timesheetSourceEmailWa' cannot be null.");
        else
            content_.append("TimesheetSourceEmailWa", timesheetSourceEmailWa.toString());
        if (address_Street === null || address_Street === undefined)
            throw new Error("The parameter 'address_Street' cannot be null.");
        else
            content_.append("Address.Street", address_Street.toString());
        if (address_AreaCode === null || address_AreaCode === undefined)
            throw new Error("The parameter 'address_AreaCode' cannot be null.");
        else
            content_.append("Address.AreaCode", address_AreaCode.toString());
        if (address_Suburb === null || address_Suburb === undefined)
            throw new Error("The parameter 'address_Suburb' cannot be null.");
        else
            content_.append("Address.Suburb", address_Suburb.toString());
        if (address_City === null || address_City === undefined)
            throw new Error("The parameter 'address_City' cannot be null.");
        else
            content_.append("Address.City", address_City.toString());
        if (address_StateId === null || address_StateId === undefined)
            throw new Error("The parameter 'address_StateId' cannot be null.");
        else
            content_.append("Address.StateId", address_StateId.toString());
        if (address_Latitude === null || address_Latitude === undefined)
            throw new Error("The parameter 'address_Latitude' cannot be null.");
        else
            content_.append("Address.Latitude", address_Latitude.toString());
        if (address_Longitude === null || address_Longitude === undefined)
            throw new Error("The parameter 'address_Longitude' cannot be null.");
        else
            content_.append("Address.Longitude", address_Longitude.toString());
        if (logoImageFile === null || logoImageFile === undefined)
            throw new Error("The parameter 'logoImageFile' cannot be null.");
        else
            content_.append("LogoImageFile", logoImageFile.data, logoImageFile.fileName ? logoImageFile.fileName : "LogoImageFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CompanyRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyRes>(null as any);
    }

    /**
     * Updates pay rates of all Valid Staff with specified Role (Auth roles: Owner)
     * @param body (optional) 
     * @return OK
     */
    updatePayRate(body: CompanyPayRatesReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Company/UpdatePayRate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayRate(_response);
        });
    }

    protected processUpdatePayRate(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * (Auth roles: Owner)
     * @param body (optional) 
     * @return OK
     */
    updatePayFrequency(body: CompanyPayFrequencyReq | undefined, cancelToken?: CancelToken): Promise<CompanyRes> {
        let url_ = this.baseUrl + "/api/Company/UpdatePayFrequency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayFrequency(_response);
        });
    }

    protected processUpdatePayFrequency(response: AxiosResponse): Promise<CompanyRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyRes>(null as any);
    }

    /**
     * Allows Owner to Create ExtCompany details (Auth roles: Owner)
     * @param body (optional) 
     * @return OK
     */
    createExtCompany(body: CreateExtCompanyReq | undefined, cancelToken?: CancelToken): Promise<ExtCompanyRes> {
        let url_ = this.baseUrl + "/api/Company/CreateExtCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExtCompany(_response);
        });
    }

    protected processCreateExtCompany(response: AxiosResponse): Promise<ExtCompanyRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExtCompanyRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExtCompanyRes>(null as any);
    }

    /**
     * Allows Owner to update ExtCompany details (Auth roles: Owner)
     * @param extCompanyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    upateExtCompany(extCompanyId: number | undefined, body: UpdateExtCompanyReq | undefined, cancelToken?: CancelToken): Promise<ExtCompanyRes> {
        let url_ = this.baseUrl + "/api/Company/UpateExtCompany?";
        if (extCompanyId === null)
            throw new Error("The parameter 'extCompanyId' cannot be null.");
        else if (extCompanyId !== undefined)
            url_ += "extCompanyId=" + encodeURIComponent("" + extCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpateExtCompany(_response);
        });
    }

    protected processUpateExtCompany(response: AxiosResponse): Promise<ExtCompanyRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExtCompanyRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExtCompanyRes>(null as any);
    }

    /**
     * Allows Owner to delete ExtCompany details
    Note : This is a permanent operation, warn the user. (Auth roles: Owner)
     * @param extCompanyId (optional) 
     * @return OK
     */
    deleteExtCompany(extCompanyId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Company/DeleteExtCompany?";
        if (extCompanyId === null)
            throw new Error("The parameter 'extCompanyId' cannot be null.");
        else if (extCompanyId !== undefined)
            url_ += "extCompanyId=" + encodeURIComponent("" + extCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExtCompany(_response);
        });
    }

    protected processDeleteExtCompany(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Allows Owner to Create ExtForm (Auth roles: Owner)
     * @param extCompanyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createExtForm(extCompanyId: number | undefined, body: ExtFormReq | undefined, cancelToken?: CancelToken): Promise<ExtFormRes> {
        let url_ = this.baseUrl + "/api/Company/CreateExtForm?";
        if (extCompanyId === null)
            throw new Error("The parameter 'extCompanyId' cannot be null.");
        else if (extCompanyId !== undefined)
            url_ += "extCompanyId=" + encodeURIComponent("" + extCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExtForm(_response);
        });
    }

    protected processCreateExtForm(response: AxiosResponse): Promise<ExtFormRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExtFormRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExtFormRes>(null as any);
    }

    /**
     * Allows Owner to update ExtForm details (Auth roles: Owner)
     * @param extFormId (optional) 
     * @param extCompanyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateExtForm(extFormId: number | undefined, extCompanyId: number | undefined, body: ExtFormReq | undefined, cancelToken?: CancelToken): Promise<ExtFormRes> {
        let url_ = this.baseUrl + "/api/Company/UpdateExtForm?";
        if (extFormId === null)
            throw new Error("The parameter 'extFormId' cannot be null.");
        else if (extFormId !== undefined)
            url_ += "extFormId=" + encodeURIComponent("" + extFormId) + "&";
        if (extCompanyId === null)
            throw new Error("The parameter 'extCompanyId' cannot be null.");
        else if (extCompanyId !== undefined)
            url_ += "extCompanyId=" + encodeURIComponent("" + extCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExtForm(_response);
        });
    }

    protected processUpdateExtForm(response: AxiosResponse): Promise<ExtFormRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExtFormRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExtFormRes>(null as any);
    }

    /**
     * Allows Owner to Delete ExtForm 
    Note : This is a permanent operation, warn the user. (Auth roles: Owner)
     * @param extFormId (optional) 
     * @param extCompanyId (optional) 
     * @return OK
     */
    deleteExtForm(extFormId: number | undefined, extCompanyId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Company/DeleteExtForm?";
        if (extFormId === null)
            throw new Error("The parameter 'extFormId' cannot be null.");
        else if (extFormId !== undefined)
            url_ += "extFormId=" + encodeURIComponent("" + extFormId) + "&";
        if (extCompanyId === null)
            throw new Error("The parameter 'extCompanyId' cannot be null.");
        else if (extCompanyId !== undefined)
            url_ += "extCompanyId=" + encodeURIComponent("" + extCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExtForm(_response);
        });
    }

    protected processDeleteExtForm(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * (Auth roles: Owner)
     * @param extFormId (optional) 
     * @param extCompanyId (optional) 
     * @param mediaFile_Description (optional) 
     * @param mediaFile_File (optional) 
     * @return OK
     */
    uploadExtFormHtml(extFormId: number | undefined, extCompanyId: number | undefined, mediaFile_Description: string | undefined, mediaFile_File: FileParameter | undefined, cancelToken?: CancelToken): Promise<ExtFormRes> {
        let url_ = this.baseUrl + "/api/Company/UploadExtFormHtml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (extFormId === null || extFormId === undefined)
            throw new Error("The parameter 'extFormId' cannot be null.");
        else
            content_.append("ExtFormId", extFormId.toString());
        if (extCompanyId === null || extCompanyId === undefined)
            throw new Error("The parameter 'extCompanyId' cannot be null.");
        else
            content_.append("ExtCompanyId", extCompanyId.toString());
        if (mediaFile_Description === null || mediaFile_Description === undefined)
            throw new Error("The parameter 'mediaFile_Description' cannot be null.");
        else
            content_.append("MediaFile.Description", mediaFile_Description.toString());
        if (mediaFile_File === null || mediaFile_File === undefined)
            throw new Error("The parameter 'mediaFile_File' cannot be null.");
        else
            content_.append("MediaFile.File", mediaFile_File.data, mediaFile_File.fileName ? mediaFile_File.fileName : "MediaFile.File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadExtFormHtml(_response);
        });
    }

    protected processUploadExtFormHtml(response: AxiosResponse): Promise<ExtFormRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExtFormRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExtFormRes>(null as any);
    }

    /**
     * (Auth roles: Owner)
     * @param extFormId (optional) 
     * @param extCompanyId (optional) 
     * @return OK
     */
    deleteExtFormHtml(extFormId: number | undefined, extCompanyId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Company/DeleteExtFormHtml?";
        if (extFormId === null)
            throw new Error("The parameter 'extFormId' cannot be null.");
        else if (extFormId !== undefined)
            url_ += "extFormId=" + encodeURIComponent("" + extFormId) + "&";
        if (extCompanyId === null)
            throw new Error("The parameter 'extCompanyId' cannot be null.");
        else if (extCompanyId !== undefined)
            url_ += "extCompanyId=" + encodeURIComponent("" + extCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExtFormHtml(_response);
        });
    }

    protected processDeleteExtFormHtml(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface ICompanyDashboardFleetIoConfigsClient {
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @return OK
     */
    get(): Promise<CompanyDashboardFleetIoConfigRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    createOrUpdate(body: CompanyDashboardFleetIoConfigReq | undefined): Promise<CompanyDashboardFleetIoConfigRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @return OK
     */
    delete(): Promise<void>;
}

export class CompanyDashboardFleetIoConfigsClient implements ICompanyDashboardFleetIoConfigsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @return OK
     */
    get( cancelToken?: CancelToken): Promise<CompanyDashboardFleetIoConfigRes> {
        let url_ = this.baseUrl + "/api/CompanyDashboardFleetIoConfigs/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CompanyDashboardFleetIoConfigRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyDashboardFleetIoConfigRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyDashboardFleetIoConfigRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    createOrUpdate(body: CompanyDashboardFleetIoConfigReq | undefined, cancelToken?: CancelToken): Promise<CompanyDashboardFleetIoConfigRes> {
        let url_ = this.baseUrl + "/api/CompanyDashboardFleetIoConfigs/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<CompanyDashboardFleetIoConfigRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyDashboardFleetIoConfigRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyDashboardFleetIoConfigRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @return OK
     */
    delete( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CompanyDashboardFleetIoConfigs/Delete";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICompanyDocumentsClient {
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined): Promise<CompanyDocumentResPage>;
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param documentId (optional) 
     * @return OK
     */
    get(documentId: number | undefined): Promise<CompanyDocumentRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param title (optional) 
     * @param description (optional) 
     * @param companyDocumentType (optional) 
     * @param file (optional) PDF
     * @return OK
     */
    create(title: string | undefined, description: string | undefined, companyDocumentType: CompanyDocumentType | undefined, file: FileParameter | undefined): Promise<CompanyDocumentRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param documentId (optional) 
     * @param title (optional) 
     * @param description (optional) 
     * @param companyDocumentType (optional) 
     * @param file (optional) PDF
     * @return OK
     */
    update(documentId: number | undefined, title: string | undefined, description: string | undefined, companyDocumentType: CompanyDocumentType | undefined, file: FileParameter | undefined): Promise<CompanyDocumentRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param documentId (optional) 
     * @return OK
     */
    delete(documentId: number | undefined): Promise<void>;
}

export class CompanyDocumentsClient implements ICompanyDocumentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<CompanyDocumentResPage> {
        let url_ = this.baseUrl + "/api/CompanyDocuments/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<CompanyDocumentResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyDocumentResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyDocumentResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param documentId (optional) 
     * @return OK
     */
    get(documentId: number | undefined, cancelToken?: CancelToken): Promise<CompanyDocumentRes> {
        let url_ = this.baseUrl + "/api/CompanyDocuments/Get?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CompanyDocumentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyDocumentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyDocumentRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param title (optional) 
     * @param description (optional) 
     * @param companyDocumentType (optional) 
     * @param file (optional) PDF
     * @return OK
     */
    create(title: string | undefined, description: string | undefined, companyDocumentType: CompanyDocumentType | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<CompanyDocumentRes> {
        let url_ = this.baseUrl + "/api/CompanyDocuments/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("Title", title.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (companyDocumentType === null || companyDocumentType === undefined)
            throw new Error("The parameter 'companyDocumentType' cannot be null.");
        else
            content_.append("CompanyDocumentType", companyDocumentType.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CompanyDocumentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyDocumentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyDocumentRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param documentId (optional) 
     * @param title (optional) 
     * @param description (optional) 
     * @param companyDocumentType (optional) 
     * @param file (optional) PDF
     * @return OK
     */
    update(documentId: number | undefined, title: string | undefined, description: string | undefined, companyDocumentType: CompanyDocumentType | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<CompanyDocumentRes> {
        let url_ = this.baseUrl + "/api/CompanyDocuments/Update?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("Title", title.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (companyDocumentType === null || companyDocumentType === undefined)
            throw new Error("The parameter 'companyDocumentType' cannot be null.");
        else
            content_.append("CompanyDocumentType", companyDocumentType.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CompanyDocumentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyDocumentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyDocumentRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param documentId (optional) 
     * @return OK
     */
    delete(documentId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CompanyDocuments/Delete?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICompanyHtmlTemplateAClient {
    /**
     * Returns a paged collection of HtmlTemplates for the specified Company (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: PagedReq | undefined): Promise<CompanyHtmlTemplateResPage>;
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param templateId (optional) 
     * @return OK
     */
    get(companyId: number | undefined, templateId: number | undefined): Promise<CompanyHtmlTemplateRes>;
    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: CompanyHtmlTemplateReq | undefined): Promise<CompanyHtmlTemplateRes>;
    /**
     * (Auth roles: Admin)
     * @param templateId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(templateId: number | undefined, body: CompanyHtmlTemplateReq | undefined): Promise<CompanyHtmlTemplateRes>;
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param templateId (optional) 
     * @return OK
     */
    delete(companyId: number | undefined, templateId: number | undefined): Promise<void>;
}

export class CompanyHtmlTemplateAClient implements ICompanyHtmlTemplateAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns a paged collection of HtmlTemplates for the specified Company (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: PagedReq | undefined, cancelToken?: CancelToken): Promise<CompanyHtmlTemplateResPage> {
        let url_ = this.baseUrl + "/api/CompanyHtmlTemplateA/Page?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<CompanyHtmlTemplateResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyHtmlTemplateResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyHtmlTemplateResPage>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param templateId (optional) 
     * @return OK
     */
    get(companyId: number | undefined, templateId: number | undefined, cancelToken?: CancelToken): Promise<CompanyHtmlTemplateRes> {
        let url_ = this.baseUrl + "/api/CompanyHtmlTemplateA/Get?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CompanyHtmlTemplateRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyHtmlTemplateRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyHtmlTemplateRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: CompanyHtmlTemplateReq | undefined, cancelToken?: CancelToken): Promise<CompanyHtmlTemplateRes> {
        let url_ = this.baseUrl + "/api/CompanyHtmlTemplateA/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CompanyHtmlTemplateRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyHtmlTemplateRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyHtmlTemplateRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param templateId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(templateId: number | undefined, body: CompanyHtmlTemplateReq | undefined, cancelToken?: CancelToken): Promise<CompanyHtmlTemplateRes> {
        let url_ = this.baseUrl + "/api/CompanyHtmlTemplateA/Update?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CompanyHtmlTemplateRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CompanyHtmlTemplateRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyHtmlTemplateRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param templateId (optional) 
     * @return OK
     */
    delete(companyId: number | undefined, templateId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CompanyHtmlTemplateA/Delete?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDriverWeeklyAggregatesClient {
    /**
     * Gets DriverWeeklyAggregates whose StartTime is between the specified interval (Auth roles: Manager,Owner)
     * @param body (optional) 
     * @return OK
     */
    getStartTimeBetween(body: DateTimeIntervalUtc | undefined): Promise<DriverWeeklyAggregateRes[]>;
}

export class DriverWeeklyAggregatesClient implements IDriverWeeklyAggregatesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets DriverWeeklyAggregates whose StartTime is between the specified interval (Auth roles: Manager,Owner)
     * @param body (optional) 
     * @return OK
     */
    getStartTimeBetween(body: DateTimeIntervalUtc | undefined, cancelToken?: CancelToken): Promise<DriverWeeklyAggregateRes[]> {
        let url_ = this.baseUrl + "/api/DriverWeeklyAggregates/GetStartTimeBetween";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStartTimeBetween(_response);
        });
    }

    protected processGetStartTimeBetween(response: AxiosResponse): Promise<DriverWeeklyAggregateRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DriverWeeklyAggregateRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverWeeklyAggregateRes[]>(null as any);
    }
}

export interface IDriverWeeklyAggregatesAClient {
    /**
     * Gets DriverWeeklyAggregates whose StartTime is between the specified interval (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    getStartTimeBetween(body: DateTimeIntervalUtc | undefined): Promise<DriverWeeklyAggregateRes[]>;
    /**
     * Creates DriverWeeklyAggregates for the specified DateOnly and 7 days prior (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: DriverWeeklyAggregateReq | undefined): Promise<DriverWeeklyAggregateRes[]>;
    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    delete(body: IdsReq | undefined): Promise<MessageResponseDto>;
}

export class DriverWeeklyAggregatesAClient implements IDriverWeeklyAggregatesAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets DriverWeeklyAggregates whose StartTime is between the specified interval (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    getStartTimeBetween(body: DateTimeIntervalUtc | undefined, cancelToken?: CancelToken): Promise<DriverWeeklyAggregateRes[]> {
        let url_ = this.baseUrl + "/api/DriverWeeklyAggregatesA/GetStartTimeBetween";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStartTimeBetween(_response);
        });
    }

    protected processGetStartTimeBetween(response: AxiosResponse): Promise<DriverWeeklyAggregateRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DriverWeeklyAggregateRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverWeeklyAggregateRes[]>(null as any);
    }

    /**
     * Creates DriverWeeklyAggregates for the specified DateOnly and 7 days prior (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: DriverWeeklyAggregateReq | undefined, cancelToken?: CancelToken): Promise<DriverWeeklyAggregateRes[]> {
        let url_ = this.baseUrl + "/api/DriverWeeklyAggregatesA/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DriverWeeklyAggregateRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DriverWeeklyAggregateRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverWeeklyAggregateRes[]>(null as any);
    }

    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    delete(body: IdsReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/DriverWeeklyAggregatesA/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface IDummyDataAClient {
    /**
     * Register new Dummy Company with Staff (Driver, Manager, Owner) and Store (Auth roles: Admin)
     * @return OK
     */
    registerDummyCompany(): Promise<MessageResponseDto>;
    /**
     * Register new Test Company with Staff (Driver, Manager, Owner) and Store (Auth roles: Admin)
     * @return OK
     */
    registerTestCompany(): Promise<MessageResponseDto>;
    /**
     * (Auth roles: Admin)
     * @return OK
     */
    addDummyLogs(): Promise<void>;
    /**
     * (Auth roles: Admin)
     * @param from (optional) 
     * @param toPhoneNumber (optional) 
     * @param textBody (optional) 
     * @return OK
     */
    testSms(from: string | undefined, toPhoneNumber: string | undefined, textBody: string | undefined): Promise<void>;
}

export class DummyDataAClient implements IDummyDataAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Register new Dummy Company with Staff (Driver, Manager, Owner) and Store (Auth roles: Admin)
     * @return OK
     */
    registerDummyCompany( cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/DummyDataA/RegisterDummyCompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterDummyCompany(_response);
        });
    }

    protected processRegisterDummyCompany(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Register new Test Company with Staff (Driver, Manager, Owner) and Store (Auth roles: Admin)
     * @return OK
     */
    registerTestCompany( cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/DummyDataA/RegisterTestCompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterTestCompany(_response);
        });
    }

    protected processRegisterTestCompany(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @return OK
     */
    addDummyLogs( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/DummyDataA/AddDummyLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDummyLogs(_response);
        });
    }

    protected processAddDummyLogs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param from (optional) 
     * @param toPhoneNumber (optional) 
     * @param textBody (optional) 
     * @return OK
     */
    testSms(from: string | undefined, toPhoneNumber: string | undefined, textBody: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/DummyDataA/TestSms?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (toPhoneNumber === null)
            throw new Error("The parameter 'toPhoneNumber' cannot be null.");
        else if (toPhoneNumber !== undefined)
            url_ += "toPhoneNumber=" + encodeURIComponent("" + toPhoneNumber) + "&";
        if (textBody === null)
            throw new Error("The parameter 'textBody' cannot be null.");
        else if (textBody !== undefined)
            url_ += "textBody=" + encodeURIComponent("" + textBody) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSms(_response);
        });
    }

    protected processTestSms(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IExpensesClient {
    /**
     * Driver and Jockey can get only their expenses (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<ExpenseRes>;
    /**
     * Pagination in descending order of creation
    Driver can get expenses created by him alone (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined): Promise<ExpenseResPage>;
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    create(body: ExpenseReq | undefined): Promise<ExpenseRes>;
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: ExpenseReq | undefined): Promise<ExpenseRes>;
    /**
     * Once an Expense has been approved it cannot be edited. 
    Notify the approver accordingly. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    approve(body: ExpenseApproveReq | undefined): Promise<MessageResponseDto>;
    /**
     * Allows to delete any non-Approved Expense
    Warn the user that this is a pemanent operation (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Promise<void>;
}

export class ExpensesClient implements IExpensesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Driver and Jockey can get only their expenses (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<ExpenseRes> {
        let url_ = this.baseUrl + "/api/Expenses/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ExpenseRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExpenseRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExpenseRes>(null as any);
    }

    /**
     * Pagination in descending order of creation
    Driver can get expenses created by him alone (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<ExpenseResPage> {
        let url_ = this.baseUrl + "/api/Expenses/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ExpenseResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExpenseResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExpenseResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    create(body: ExpenseReq | undefined, cancelToken?: CancelToken): Promise<ExpenseRes> {
        let url_ = this.baseUrl + "/api/Expenses/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ExpenseRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExpenseRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExpenseRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: ExpenseReq | undefined, cancelToken?: CancelToken): Promise<ExpenseRes> {
        let url_ = this.baseUrl + "/api/Expenses/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ExpenseRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExpenseRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExpenseRes>(null as any);
    }

    /**
     * Once an Expense has been approved it cannot be edited. 
    Notify the approver accordingly. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    approve(body: ExpenseApproveReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Expenses/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Allows to delete any non-Approved Expense
    Warn the user that this is a pemanent operation (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Expenses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFleetIoClient {
    /**
     * Executes the specified query and returns Http response (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    execute(body: FleetIoExecuteQueryReq | undefined): Promise<void>;
    /**
     * Returns a json containg Policy, Signature and Path valid for 1 hour. 
    These 3 are required to upload a file to FleetIo's Storage provider.
    Ref: https://developer.fleetio.com/docs/overview/attaching-documents-and-images (Auth roles: Owner,Manager)
     * @param stateId (optional) 
     * @return OK
     */
    getDocumentUploadPolicyAndSignature(stateId: number | undefined): Promise<void>;
}

export class FleetIoClient implements IFleetIoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Executes the specified query and returns Http response (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    execute(body: FleetIoExecuteQueryReq | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api/FleetIo/Execute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecute(_response);
        });
    }

    protected processExecute(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns a json containg Policy, Signature and Path valid for 1 hour. 
    These 3 are required to upload a file to FleetIo's Storage provider.
    Ref: https://developer.fleetio.com/docs/overview/attaching-documents-and-images (Auth roles: Owner,Manager)
     * @param stateId (optional) 
     * @return OK
     */
    getDocumentUploadPolicyAndSignature(stateId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FleetIo/GetDocumentUploadPolicyAndSignature?";
        if (stateId === null)
            throw new Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentUploadPolicyAndSignature(_response);
        });
    }

    protected processGetDocumentUploadPolicyAndSignature(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFleetIoQueriesAClient {
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: PagedReq | undefined): Promise<FleetIoQueryResPage>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    get(id: number | undefined, companyId: number | undefined): Promise<FleetIoQueryRes>;
    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: FleetIoQueryReq | undefined): Promise<FleetIoQueryRes>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: FleetIoQueryReq | undefined): Promise<FleetIoQueryRes>;
    /**
     * Copies query and mappings.
    Existing query with same actionId and its mappings, if any, will get overwritten. (Auth roles: Admin)
     * @param id (optional) 
     * @param sourceCompanyId (optional) 
     * @param targetCompanyId (optional) 
     * @return OK
     */
    copy(id: number | undefined, sourceCompanyId: number | undefined, targetCompanyId: number | undefined): Promise<FleetIoQueryRes>;
    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    delete(id: number | undefined, companyId: number | undefined): Promise<MessageResponseDto>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param appRole (optional) 
     * @return OK
     */
    mapRole(id: number | undefined, appRole: string | undefined): Promise<void>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param appRole (optional) 
     * @return OK
     */
    unmapRole(id: number | undefined, appRole: string | undefined): Promise<void>;
}

export class FleetIoQueriesAClient implements IFleetIoQueriesAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: PagedReq | undefined, cancelToken?: CancelToken): Promise<FleetIoQueryResPage> {
        let url_ = this.baseUrl + "/api/FleetIoQueriesA/Page?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<FleetIoQueryResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FleetIoQueryResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetIoQueryResPage>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    get(id: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<FleetIoQueryRes> {
        let url_ = this.baseUrl + "/api/FleetIoQueriesA/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FleetIoQueryRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FleetIoQueryRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetIoQueryRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: FleetIoQueryReq | undefined, cancelToken?: CancelToken): Promise<FleetIoQueryRes> {
        let url_ = this.baseUrl + "/api/FleetIoQueriesA/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FleetIoQueryRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FleetIoQueryRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetIoQueryRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: FleetIoQueryReq | undefined, cancelToken?: CancelToken): Promise<FleetIoQueryRes> {
        let url_ = this.baseUrl + "/api/FleetIoQueriesA/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FleetIoQueryRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FleetIoQueryRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetIoQueryRes>(null as any);
    }

    /**
     * Copies query and mappings.
    Existing query with same actionId and its mappings, if any, will get overwritten. (Auth roles: Admin)
     * @param id (optional) 
     * @param sourceCompanyId (optional) 
     * @param targetCompanyId (optional) 
     * @return OK
     */
    copy(id: number | undefined, sourceCompanyId: number | undefined, targetCompanyId: number | undefined, cancelToken?: CancelToken): Promise<FleetIoQueryRes> {
        let url_ = this.baseUrl + "/api/FleetIoQueriesA/Copy?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (sourceCompanyId === null)
            throw new Error("The parameter 'sourceCompanyId' cannot be null.");
        else if (sourceCompanyId !== undefined)
            url_ += "sourceCompanyId=" + encodeURIComponent("" + sourceCompanyId) + "&";
        if (targetCompanyId === null)
            throw new Error("The parameter 'targetCompanyId' cannot be null.");
        else if (targetCompanyId !== undefined)
            url_ += "targetCompanyId=" + encodeURIComponent("" + targetCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<FleetIoQueryRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FleetIoQueryRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetIoQueryRes>(null as any);
    }

    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    delete(id: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/FleetIoQueriesA/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param appRole (optional) 
     * @return OK
     */
    mapRole(id: number | undefined, appRole: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FleetIoQueriesA/MapRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (appRole === null)
            throw new Error("The parameter 'appRole' cannot be null.");
        else if (appRole !== undefined)
            url_ += "appRole=" + encodeURIComponent("" + appRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMapRole(_response);
        });
    }

    protected processMapRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param appRole (optional) 
     * @return OK
     */
    unmapRole(id: number | undefined, appRole: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FleetIoQueriesA/UnmapRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (appRole === null)
            throw new Error("The parameter 'appRole' cannot be null.");
        else if (appRole !== undefined)
            url_ += "appRole=" + encodeURIComponent("" + appRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnmapRole(_response);
        });
    }

    protected processUnmapRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFormsClient {
    /**
     * Get a Form that can be accessed by user's Role. (Auth)
     * @param formId (optional) 
     * @return OK
     */
    getByRole(formId: number | undefined): Promise<FormRes>;
    /**
     * Gets all the Forms (non deleted) that current user's Role can access. (Auth)
     * @return OK
     */
    allByRole(): Promise<FormRes[]>;
    /**
     * Gets a Form. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @return OK
     */
    get(formId: number | undefined): Promise<FormRes>;
    /**
     * Gets all the Forms (non deleted). (Auth roles: Owner,Manager)
     * @return OK
     */
    all(): Promise<FormRes[]>;
    /**
     * If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: FormReq | undefined): Promise<FormRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(formId: number | undefined, body: FormReq | undefined): Promise<FormRes>;
    /**
     * Activate or Deactivate a form.
    Inactive forms can't be submitted. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param isActive (optional) 
     * @return OK
     */
    setIsActive(formId: number | undefined, isActive: boolean | undefined): Promise<FormRes>;
    /**
     * Allows to soft-delete a Form (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @return OK
     */
    softDelete(formId: number | undefined): Promise<void>;
    /**
     * If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addQuestion(formId: number | undefined, body: FormQuestionTextualReq | undefined): Promise<FormQuestionTextualRes>;
    /**
     * Used to replace/update question
    If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param questionId (optional) 
     * @param body (optional) 
     * @return OK
     */
    replaceQuestion(formId: number | undefined, questionId: string | undefined, body: FormQuestionTextualReq | undefined): Promise<FormQuestionTextualRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param questionId (optional) 
     * @return OK
     */
    deleteQuestion(formId: number | undefined, questionId: string | undefined): Promise<void>;
    /**
     * If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param parentQuestionId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addChildQuestion(formId: number | undefined, parentQuestionId: string | undefined, body: FormQuestionTextualReq | undefined): Promise<FormQuestionTextualRes>;
    /**
     * Used to replace/update question
    If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param childQuestionId (optional) 
     * @param parentQuestionId (optional) 
     * @param body (optional) 
     * @return OK
     */
    replaceChildQuestion(formId: number | undefined, childQuestionId: string | undefined, parentQuestionId: string | undefined, body: FormQuestionTextualReq | undefined): Promise<FormQuestionTextualRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param childQuestionId (optional) 
     * @param parentQuestionId (optional) 
     * @return OK
     */
    deleteChildQuestion(formId: number | undefined, childQuestionId: string | undefined, parentQuestionId: string | undefined): Promise<void>;
}

export class FormsClient implements IFormsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get a Form that can be accessed by user's Role. (Auth)
     * @param formId (optional) 
     * @return OK
     */
    getByRole(formId: number | undefined, cancelToken?: CancelToken): Promise<FormRes> {
        let url_ = this.baseUrl + "/api/Forms/GetByRole?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByRole(_response);
        });
    }

    protected processGetByRole(response: AxiosResponse): Promise<FormRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormRes>(null as any);
    }

    /**
     * Gets all the Forms (non deleted) that current user's Role can access. (Auth)
     * @return OK
     */
    allByRole( cancelToken?: CancelToken): Promise<FormRes[]> {
        let url_ = this.baseUrl + "/api/Forms/AllByRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllByRole(_response);
        });
    }

    protected processAllByRole(response: AxiosResponse): Promise<FormRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormRes[]>(null as any);
    }

    /**
     * Gets a Form. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @return OK
     */
    get(formId: number | undefined, cancelToken?: CancelToken): Promise<FormRes> {
        let url_ = this.baseUrl + "/api/Forms/Get?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FormRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormRes>(null as any);
    }

    /**
     * Gets all the Forms (non deleted). (Auth roles: Owner,Manager)
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<FormRes[]> {
        let url_ = this.baseUrl + "/api/Forms/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<FormRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormRes[]>(null as any);
    }

    /**
     * If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: FormReq | undefined, cancelToken?: CancelToken): Promise<FormRes> {
        let url_ = this.baseUrl + "/api/Forms/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FormRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormRes>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(formId: number | undefined, body: FormReq | undefined, cancelToken?: CancelToken): Promise<FormRes> {
        let url_ = this.baseUrl + "/api/Forms/Update?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FormRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormRes>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormRes>(null as any);
    }

    /**
     * Activate or Deactivate a form.
    Inactive forms can't be submitted. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param isActive (optional) 
     * @return OK
     */
    setIsActive(formId: number | undefined, isActive: boolean | undefined, cancelToken?: CancelToken): Promise<FormRes> {
        let url_ = this.baseUrl + "/api/Forms/SetIsActive?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsActive(_response);
        });
    }

    protected processSetIsActive(response: AxiosResponse): Promise<FormRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormRes>(null as any);
    }

    /**
     * Allows to soft-delete a Form (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @return OK
     */
    softDelete(formId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Forms/SoftDelete?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSoftDelete(_response);
        });
    }

    protected processSoftDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addQuestion(formId: number | undefined, body: FormQuestionTextualReq | undefined, cancelToken?: CancelToken): Promise<FormQuestionTextualRes> {
        let url_ = this.baseUrl + "/api/Forms/AddQuestion?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddQuestion(_response);
        });
    }

    protected processAddQuestion(response: AxiosResponse): Promise<FormQuestionTextualRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormQuestionTextualRes>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormQuestionTextualRes>(null as any);
    }

    /**
     * Used to replace/update question
    If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param questionId (optional) 
     * @param body (optional) 
     * @return OK
     */
    replaceQuestion(formId: number | undefined, questionId: string | undefined, body: FormQuestionTextualReq | undefined, cancelToken?: CancelToken): Promise<FormQuestionTextualRes> {
        let url_ = this.baseUrl + "/api/Forms/ReplaceQuestion?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplaceQuestion(_response);
        });
    }

    protected processReplaceQuestion(response: AxiosResponse): Promise<FormQuestionTextualRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormQuestionTextualRes>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormQuestionTextualRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param questionId (optional) 
     * @return OK
     */
    deleteQuestion(formId: number | undefined, questionId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Forms/DeleteQuestion?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestion(_response);
        });
    }

    protected processDeleteQuestion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param parentQuestionId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addChildQuestion(formId: number | undefined, parentQuestionId: string | undefined, body: FormQuestionTextualReq | undefined, cancelToken?: CancelToken): Promise<FormQuestionTextualRes> {
        let url_ = this.baseUrl + "/api/Forms/AddChildQuestion?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (parentQuestionId === null)
            throw new Error("The parameter 'parentQuestionId' cannot be null.");
        else if (parentQuestionId !== undefined)
            url_ += "parentQuestionId=" + encodeURIComponent("" + parentQuestionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddChildQuestion(_response);
        });
    }

    protected processAddChildQuestion(response: AxiosResponse): Promise<FormQuestionTextualRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormQuestionTextualRes>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormQuestionTextualRes>(null as any);
    }

    /**
     * Used to replace/update question
    If this returns BadRequest then check the response body for errors. (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param childQuestionId (optional) 
     * @param parentQuestionId (optional) 
     * @param body (optional) 
     * @return OK
     */
    replaceChildQuestion(formId: number | undefined, childQuestionId: string | undefined, parentQuestionId: string | undefined, body: FormQuestionTextualReq | undefined, cancelToken?: CancelToken): Promise<FormQuestionTextualRes> {
        let url_ = this.baseUrl + "/api/Forms/ReplaceChildQuestion?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (childQuestionId === null)
            throw new Error("The parameter 'childQuestionId' cannot be null.");
        else if (childQuestionId !== undefined)
            url_ += "childQuestionId=" + encodeURIComponent("" + childQuestionId) + "&";
        if (parentQuestionId === null)
            throw new Error("The parameter 'parentQuestionId' cannot be null.");
        else if (parentQuestionId !== undefined)
            url_ += "parentQuestionId=" + encodeURIComponent("" + parentQuestionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplaceChildQuestion(_response);
        });
    }

    protected processReplaceChildQuestion(response: AxiosResponse): Promise<FormQuestionTextualRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormQuestionTextualRes>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormQuestionTextualRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param formId (optional) 
     * @param childQuestionId (optional) 
     * @param parentQuestionId (optional) 
     * @return OK
     */
    deleteChildQuestion(formId: number | undefined, childQuestionId: string | undefined, parentQuestionId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Forms/DeleteChildQuestion?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (childQuestionId === null)
            throw new Error("The parameter 'childQuestionId' cannot be null.");
        else if (childQuestionId !== undefined)
            url_ += "childQuestionId=" + encodeURIComponent("" + childQuestionId) + "&";
        if (parentQuestionId === null)
            throw new Error("The parameter 'parentQuestionId' cannot be null.");
        else if (parentQuestionId !== undefined)
            url_ += "parentQuestionId=" + encodeURIComponent("" + parentQuestionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteChildQuestion(_response);
        });
    }

    protected processDeleteChildQuestion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFormSubmissionsClient {
    /**
     * Allows to a User to get his FormSubmission (Auth)
     * @param formSubmissionId (optional) 
     * @return OK
     */
    getByUser(formSubmissionId: number | undefined): Promise<FormSubmissionRes>;
    /**
     * Allows to a User to get his latest FormSubmission (Auth)
     * @param formId (optional) 
     * @return OK
     */
    getLatestByUser(formId: number | undefined): Promise<FormSubmissionRes>;
    /**
     * Allows to a User to get his FormSubmissions (Auth)
     * @param body (optional) 
     * @return OK
     */
    betweenByUser(body: GetFormSubmissionsReq | undefined): Promise<FormSubmissionRes[]>;
    /**
     * (Auth roles: Owner,Manager)
     * @param formSubmissionId (optional) 
     * @return OK
     */
    get(formSubmissionId: number | undefined): Promise<FormSubmissionRes>;
    /**
     * Gets all the FormSubmissions (non deleted) (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    between(body: GetFormSubmissionsReq | undefined): Promise<FormSubmissionRes[]>;
    /**
     * Completes/Submits a FormSubmission.
    Only a user who owns the FormSubmissionc an complete/submit it. (Auth)
     * @param formSubmissionId (optional) 
     * @return OK
     */
    submit(formSubmissionId: number | undefined): Promise<MessageResponseDto>;
    /**
     * Associates a Shift with the FormSubmission.
    Note: Shift must have User assigned
          FormSubmission must have the same User as the Shift.
          FormSubmission must not be submitted. (Auth)
     * @param formSubmissionId (optional) 
     * @param shiftId (optional) 
     * @return OK
     */
    associateShift(formSubmissionId: number | undefined, shiftId: number | undefined): Promise<FormSubmissionRes>;
    /**
     * Adds an answer (or childAnswer)
    If FormSubmission does not exists or has an already submitted one, then it will create one.
    If a FormSubmission exists then it will reuse one.
    Thus, user can only have one ongoing FormSubmission for a given Form. (Auth)
     * @param body (optional) Answer
     * @return OK
     */
    answer(body: FormAnswerBaseReq | undefined): Promise<FormAnswerBaseRes>;
    /**
     * Uploads a Photo for the specified FormSubmission and returns the filename that needs to be used in the Answers.
    If a FormSubmission does not exist then it creates one.
    Note: This may cause stray photos to be uplaoded to Blobs.
          We delete such photos as part of M:Api.Controllers.FormSubmissionsController.DeleteStrayBlobs(Api.Data.Models.Forms.FormSubmission,System.Collections.Generic.List{Api.Poco.Dtos.FormQuestion.JsonModels.FormQuestionBase},System.Collections.Generic.List{Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerBase})
          and also M:Api.Controllers.FormSubmissionsController.AddOrReplaceAnswer(System.Int64,System.Int64,Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerBase,System.Collections.Generic.List{Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerBase}) (Auth)
     * @param formId (optional) 
     * @param formQuestionId (optional) 
     * @param mediaFile_Description (optional) 
     * @param mediaFile_File (optional) 
     * @return OK
     */
    uploadPhoto(formId: number | undefined, formQuestionId: string | undefined, mediaFile_Description: string | undefined, mediaFile_File: FileParameter | undefined): Promise<FormSubmissionMediaFileRes>;
    /**
     * Deletes a Photo for the specified FormSubmission and returns the filename that needs to be removed from the Answers. (Auth)
     * @param body (optional) 
     * @return OK
     */
    deletePhoto(body: FormSubmissionDeleteMediaFileReq | undefined): Promise<FormSubmissionDeleteMediaFileRes>;
    /**
     * Allows to a User to soft-delete his FormSubmission (Auth)
     * @param formSubmissionId (optional) 
     * @return OK
     */
    softDelete(formSubmissionId: number | undefined): Promise<void>;
}

export class FormSubmissionsClient implements IFormSubmissionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Allows to a User to get his FormSubmission (Auth)
     * @param formSubmissionId (optional) 
     * @return OK
     */
    getByUser(formSubmissionId: number | undefined, cancelToken?: CancelToken): Promise<FormSubmissionRes> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetByUser?";
        if (formSubmissionId === null)
            throw new Error("The parameter 'formSubmissionId' cannot be null.");
        else if (formSubmissionId !== undefined)
            url_ += "formSubmissionId=" + encodeURIComponent("" + formSubmissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByUser(_response);
        });
    }

    protected processGetByUser(response: AxiosResponse): Promise<FormSubmissionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormSubmissionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionRes>(null as any);
    }

    /**
     * Allows to a User to get his latest FormSubmission (Auth)
     * @param formId (optional) 
     * @return OK
     */
    getLatestByUser(formId: number | undefined, cancelToken?: CancelToken): Promise<FormSubmissionRes> {
        let url_ = this.baseUrl + "/api/FormSubmissions/GetLatestByUser?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestByUser(_response);
        });
    }

    protected processGetLatestByUser(response: AxiosResponse): Promise<FormSubmissionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormSubmissionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionRes>(null as any);
    }

    /**
     * Allows to a User to get his FormSubmissions (Auth)
     * @param body (optional) 
     * @return OK
     */
    betweenByUser(body: GetFormSubmissionsReq | undefined, cancelToken?: CancelToken): Promise<FormSubmissionRes[]> {
        let url_ = this.baseUrl + "/api/FormSubmissions/BetweenByUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBetweenByUser(_response);
        });
    }

    protected processBetweenByUser(response: AxiosResponse): Promise<FormSubmissionRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormSubmissionRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionRes[]>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param formSubmissionId (optional) 
     * @return OK
     */
    get(formSubmissionId: number | undefined, cancelToken?: CancelToken): Promise<FormSubmissionRes> {
        let url_ = this.baseUrl + "/api/FormSubmissions/Get?";
        if (formSubmissionId === null)
            throw new Error("The parameter 'formSubmissionId' cannot be null.");
        else if (formSubmissionId !== undefined)
            url_ += "formSubmissionId=" + encodeURIComponent("" + formSubmissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FormSubmissionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormSubmissionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionRes>(null as any);
    }

    /**
     * Gets all the FormSubmissions (non deleted) (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    between(body: GetFormSubmissionsReq | undefined, cancelToken?: CancelToken): Promise<FormSubmissionRes[]> {
        let url_ = this.baseUrl + "/api/FormSubmissions/Between";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBetween(_response);
        });
    }

    protected processBetween(response: AxiosResponse): Promise<FormSubmissionRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormSubmissionRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionRes[]>(null as any);
    }

    /**
     * Completes/Submits a FormSubmission.
    Only a user who owns the FormSubmissionc an complete/submit it. (Auth)
     * @param formSubmissionId (optional) 
     * @return OK
     */
    submit(formSubmissionId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/FormSubmissions/Submit?";
        if (formSubmissionId === null)
            throw new Error("The parameter 'formSubmissionId' cannot be null.");
        else if (formSubmissionId !== undefined)
            url_ += "formSubmissionId=" + encodeURIComponent("" + formSubmissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Associates a Shift with the FormSubmission.
    Note: Shift must have User assigned
          FormSubmission must have the same User as the Shift.
          FormSubmission must not be submitted. (Auth)
     * @param formSubmissionId (optional) 
     * @param shiftId (optional) 
     * @return OK
     */
    associateShift(formSubmissionId: number | undefined, shiftId: number | undefined, cancelToken?: CancelToken): Promise<FormSubmissionRes> {
        let url_ = this.baseUrl + "/api/FormSubmissions/AssociateShift?";
        if (formSubmissionId === null)
            throw new Error("The parameter 'formSubmissionId' cannot be null.");
        else if (formSubmissionId !== undefined)
            url_ += "formSubmissionId=" + encodeURIComponent("" + formSubmissionId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssociateShift(_response);
        });
    }

    protected processAssociateShift(response: AxiosResponse): Promise<FormSubmissionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormSubmissionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionRes>(null as any);
    }

    /**
     * Adds an answer (or childAnswer)
    If FormSubmission does not exists or has an already submitted one, then it will create one.
    If a FormSubmission exists then it will reuse one.
    Thus, user can only have one ongoing FormSubmission for a given Form. (Auth)
     * @param body (optional) Answer
     * @return OK
     */
    answer(body: FormAnswerBaseReq | undefined, cancelToken?: CancelToken): Promise<FormAnswerBaseRes> {
        let url_ = this.baseUrl + "/api/FormSubmissions/Answer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnswer(_response);
        });
    }

    protected processAnswer(response: AxiosResponse): Promise<FormAnswerBaseRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormAnswerBaseRes>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormAnswerBaseRes>(null as any);
    }

    /**
     * Uploads a Photo for the specified FormSubmission and returns the filename that needs to be used in the Answers.
    If a FormSubmission does not exist then it creates one.
    Note: This may cause stray photos to be uplaoded to Blobs.
          We delete such photos as part of M:Api.Controllers.FormSubmissionsController.DeleteStrayBlobs(Api.Data.Models.Forms.FormSubmission,System.Collections.Generic.List{Api.Poco.Dtos.FormQuestion.JsonModels.FormQuestionBase},System.Collections.Generic.List{Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerBase})
          and also M:Api.Controllers.FormSubmissionsController.AddOrReplaceAnswer(System.Int64,System.Int64,Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerBase,System.Collections.Generic.List{Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerBase}) (Auth)
     * @param formId (optional) 
     * @param formQuestionId (optional) 
     * @param mediaFile_Description (optional) 
     * @param mediaFile_File (optional) 
     * @return OK
     */
    uploadPhoto(formId: number | undefined, formQuestionId: string | undefined, mediaFile_Description: string | undefined, mediaFile_File: FileParameter | undefined, cancelToken?: CancelToken): Promise<FormSubmissionMediaFileRes> {
        let url_ = this.baseUrl + "/api/FormSubmissions/UploadPhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formId === null || formId === undefined)
            throw new Error("The parameter 'formId' cannot be null.");
        else
            content_.append("FormId", formId.toString());
        if (formQuestionId === null || formQuestionId === undefined)
            throw new Error("The parameter 'formQuestionId' cannot be null.");
        else
            content_.append("FormQuestionId", formQuestionId.toString());
        if (mediaFile_Description === null || mediaFile_Description === undefined)
            throw new Error("The parameter 'mediaFile_Description' cannot be null.");
        else
            content_.append("MediaFile.Description", mediaFile_Description.toString());
        if (mediaFile_File === null || mediaFile_File === undefined)
            throw new Error("The parameter 'mediaFile_File' cannot be null.");
        else
            content_.append("MediaFile.File", mediaFile_File.data, mediaFile_File.fileName ? mediaFile_File.fileName : "MediaFile.File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadPhoto(_response);
        });
    }

    protected processUploadPhoto(response: AxiosResponse): Promise<FormSubmissionMediaFileRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormSubmissionMediaFileRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionMediaFileRes>(null as any);
    }

    /**
     * Deletes a Photo for the specified FormSubmission and returns the filename that needs to be removed from the Answers. (Auth)
     * @param body (optional) 
     * @return OK
     */
    deletePhoto(body: FormSubmissionDeleteMediaFileReq | undefined, cancelToken?: CancelToken): Promise<FormSubmissionDeleteMediaFileRes> {
        let url_ = this.baseUrl + "/api/FormSubmissions/DeletePhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePhoto(_response);
        });
    }

    protected processDeletePhoto(response: AxiosResponse): Promise<FormSubmissionDeleteMediaFileRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormSubmissionDeleteMediaFileRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSubmissionDeleteMediaFileRes>(null as any);
    }

    /**
     * Allows to a User to soft-delete his FormSubmission (Auth)
     * @param formSubmissionId (optional) 
     * @return OK
     */
    softDelete(formSubmissionId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FormSubmissions/SoftDelete?";
        if (formSubmissionId === null)
            throw new Error("The parameter 'formSubmissionId' cannot be null.");
        else if (formSubmissionId !== undefined)
            url_ += "formSubmissionId=" + encodeURIComponent("" + formSubmissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSoftDelete(_response);
        });
    }

    protected processSoftDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IGoogleSheetsClient {
    /**
     * (Auth roles: Owner,Manager)
     * @param googlesheetId (optional) 
     * @return OK
     */
    get(googlesheetId: number | undefined): Promise<GoogleSheetRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined): Promise<GoogleSheetResPage>;
    /**
     * Downloads a GoogleSheet or GoogleDrive file that we have access to (Auth roles: Owner,Manager)
     * @param googlesheetId (optional) 
     * @param fileNameWithExtension (optional) 
     * @return OK
     */
    download(googlesheetId: number | undefined, fileNameWithExtension: string | undefined): Promise<FileResponse>;
    /**
     * Fetches the specified sheet from google sheet as json. (Auth roles: Owner,Manager)
     * @param googlesheetId (optional) 
     * @param rangeInA1Notation (optional) e.g. WTD Scorecard'!A1:D121 For enitre sheet just specify the sheet title. e.g. WTD Scorecard
     * @return OK
     */
    getSheetAsJson(googlesheetId: number | undefined, rangeInA1Notation: string | undefined): Promise<ReadResponse>;
    /**
     * All GoogleSheetHtmlTemplates for a specific types of GoogleSheets (OtdMaster and RoutePerformance) (Auth roles: Owner,Manager)
     * @return OK
     */
    allGoogleSheetHtmlTemplates(): Promise<GoogleSheetHtmlTemplatePageRes[]>;
    /**
     * (Auth roles: Owner,Manager)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param googlesheetId (optional) 
     * @return OK
     */
    getGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, googlesheetId: number | undefined): Promise<GoogleSheetHtmlTemplateRes>;
    /**
     * Downloads the HTML template for a specific GoogleSheetHtmlTemplate after injecting the bearer token for authentication (Auth roles: Owner,Manager)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param googlesheetId (optional) 
     * @return OK
     */
    downloadGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, googlesheetId: number | undefined): Promise<FileResponse>;
}

export class GoogleSheetsClient implements IGoogleSheetsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager)
     * @param googlesheetId (optional) 
     * @return OK
     */
    get(googlesheetId: number | undefined, cancelToken?: CancelToken): Promise<GoogleSheetRes> {
        let url_ = this.baseUrl + "/api/GoogleSheets/Get?";
        if (googlesheetId === null)
            throw new Error("The parameter 'googlesheetId' cannot be null.");
        else if (googlesheetId !== undefined)
            url_ += "googlesheetId=" + encodeURIComponent("" + googlesheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<GoogleSheetRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<GoogleSheetResPage> {
        let url_ = this.baseUrl + "/api/GoogleSheets/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<GoogleSheetResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetResPage>(null as any);
    }

    /**
     * Downloads a GoogleSheet or GoogleDrive file that we have access to (Auth roles: Owner,Manager)
     * @param googlesheetId (optional) 
     * @param fileNameWithExtension (optional) 
     * @return OK
     */
    download(googlesheetId: number | undefined, fileNameWithExtension: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GoogleSheets/Download?";
        if (googlesheetId === null)
            throw new Error("The parameter 'googlesheetId' cannot be null.");
        else if (googlesheetId !== undefined)
            url_ += "googlesheetId=" + encodeURIComponent("" + googlesheetId) + "&";
        if (fileNameWithExtension === null)
            throw new Error("The parameter 'fileNameWithExtension' cannot be null.");
        else if (fileNameWithExtension !== undefined)
            url_ += "fileNameWithExtension=" + encodeURIComponent("" + fileNameWithExtension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Fetches the specified sheet from google sheet as json. (Auth roles: Owner,Manager)
     * @param googlesheetId (optional) 
     * @param rangeInA1Notation (optional) e.g. WTD Scorecard'!A1:D121 For enitre sheet just specify the sheet title. e.g. WTD Scorecard
     * @return OK
     */
    getSheetAsJson(googlesheetId: number | undefined, rangeInA1Notation: string | undefined, cancelToken?: CancelToken): Promise<ReadResponse> {
        let url_ = this.baseUrl + "/api/GoogleSheets/GetSheetAsJson?";
        if (googlesheetId === null)
            throw new Error("The parameter 'googlesheetId' cannot be null.");
        else if (googlesheetId !== undefined)
            url_ += "googlesheetId=" + encodeURIComponent("" + googlesheetId) + "&";
        if (rangeInA1Notation === null)
            throw new Error("The parameter 'rangeInA1Notation' cannot be null.");
        else if (rangeInA1Notation !== undefined)
            url_ += "rangeInA1Notation=" + encodeURIComponent("" + rangeInA1Notation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSheetAsJson(_response);
        });
    }

    protected processGetSheetAsJson(response: AxiosResponse): Promise<ReadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ReadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReadResponse>(null as any);
    }

    /**
     * All GoogleSheetHtmlTemplates for a specific types of GoogleSheets (OtdMaster and RoutePerformance) (Auth roles: Owner,Manager)
     * @return OK
     */
    allGoogleSheetHtmlTemplates( cancelToken?: CancelToken): Promise<GoogleSheetHtmlTemplatePageRes[]> {
        let url_ = this.baseUrl + "/api/GoogleSheets/AllGoogleSheetHtmlTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllGoogleSheetHtmlTemplates(_response);
        });
    }

    protected processAllGoogleSheetHtmlTemplates(response: AxiosResponse): Promise<GoogleSheetHtmlTemplatePageRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetHtmlTemplatePageRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetHtmlTemplatePageRes[]>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param googlesheetId (optional) 
     * @return OK
     */
    getGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, googlesheetId: number | undefined, cancelToken?: CancelToken): Promise<GoogleSheetHtmlTemplateRes> {
        let url_ = this.baseUrl + "/api/GoogleSheets/GetGoogleSheetHtmlTemplate?";
        if (googleSheetHtmlTemplateId === null)
            throw new Error("The parameter 'googleSheetHtmlTemplateId' cannot be null.");
        else if (googleSheetHtmlTemplateId !== undefined)
            url_ += "googleSheetHtmlTemplateId=" + encodeURIComponent("" + googleSheetHtmlTemplateId) + "&";
        if (googlesheetId === null)
            throw new Error("The parameter 'googlesheetId' cannot be null.");
        else if (googlesheetId !== undefined)
            url_ += "googlesheetId=" + encodeURIComponent("" + googlesheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleSheetHtmlTemplate(_response);
        });
    }

    protected processGetGoogleSheetHtmlTemplate(response: AxiosResponse): Promise<GoogleSheetHtmlTemplateRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetHtmlTemplateRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetHtmlTemplateRes>(null as any);
    }

    /**
     * Downloads the HTML template for a specific GoogleSheetHtmlTemplate after injecting the bearer token for authentication (Auth roles: Owner,Manager)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param googlesheetId (optional) 
     * @return OK
     */
    downloadGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, googlesheetId: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GoogleSheets/DownloadGoogleSheetHtmlTemplate?";
        if (googleSheetHtmlTemplateId === null)
            throw new Error("The parameter 'googleSheetHtmlTemplateId' cannot be null.");
        else if (googleSheetHtmlTemplateId !== undefined)
            url_ += "googleSheetHtmlTemplateId=" + encodeURIComponent("" + googleSheetHtmlTemplateId) + "&";
        if (googlesheetId === null)
            throw new Error("The parameter 'googlesheetId' cannot be null.");
        else if (googlesheetId !== undefined)
            url_ += "googlesheetId=" + encodeURIComponent("" + googlesheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadGoogleSheetHtmlTemplate(_response);
        });
    }

    protected processDownloadGoogleSheetHtmlTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IGoogleSheetsAClient {
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    get(id: number | undefined, companyId: number | undefined): Promise<GoogleSheetRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: PagedReq | undefined): Promise<GoogleSheetResPage>;
    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: GoogleSheetReq | undefined): Promise<GoogleSheetRes>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: GoogleSheetReq | undefined): Promise<GoogleSheetRes>;
    /**
     * Permenantly delete a GoogleSheet (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    delete(id: number | undefined, companyId: number | undefined): Promise<void>;
    /**
     * Downloads a GoogleSheet or GoogleDrive file.
    If it is private our service account (trucksightgooglesheetaccess@trucksight-39771.iam.gserviceaccount.com) will need readonly access to it (Auth roles: Admin)
     * @param googleSheetUrl (optional) 
     * @param fileNameWithExtension (optional) 
     * @return OK
     */
    download(googleSheetUrl: string | undefined, fileNameWithExtension: string | undefined): Promise<FileResponse>;
    /**
     * Fetches the specified sheet from google sheet as json. (Auth roles: Admin)
     * @param googleSheetUrl (optional) Any url that contains the spreadsheet id
     * @param rangeInA1Notation (optional) e.g. WTD Scorecard'!A1:D121 For enitre sheet just specify the sheet title. e.g. WTD Scorecard
     * @return OK
     */
    getSheetAsJson(googleSheetUrl: string | undefined, rangeInA1Notation: string | undefined): Promise<ReadResponse>;
    /**
     * (Auth roles: Admin)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param googlesheetId (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    getGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, googlesheetId: number | undefined, companyId: number | undefined): Promise<GoogleSheetHtmlTemplateRes>;
    /**
     * All GoogleSheetHtmlTemplates for a specified GoogleSheet (Auth roles: Admin)
     * @param googlesheetId (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    allGoogleSheetHtmlTemplates(googlesheetId: number | undefined, companyId: number | undefined): Promise<GoogleSheetHtmlTemplateRes[]>;
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createGoogleSheetHtmlTemplate(companyId: number | undefined, body: GoogleSheetHtmlTemplateReq | undefined): Promise<GoogleSheetHtmlTemplateRes>;
    /**
     * (Auth roles: Admin)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, companyId: number | undefined, body: GoogleSheetHtmlTemplateReq | undefined): Promise<GoogleSheetHtmlTemplateRes>;
    /**
     * Permenantly deletes a GoogleSheetHtmlTemplate (Auth roles: Admin)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param googleSheetId (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    deleteGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, googleSheetId: number | undefined, companyId: number | undefined): Promise<void>;
}

export class GoogleSheetsAClient implements IGoogleSheetsAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    get(id: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<GoogleSheetRes> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<GoogleSheetRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: PagedReq | undefined, cancelToken?: CancelToken): Promise<GoogleSheetResPage> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/Page?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<GoogleSheetResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetResPage>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: GoogleSheetReq | undefined, cancelToken?: CancelToken): Promise<GoogleSheetRes> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<GoogleSheetRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: GoogleSheetReq | undefined, cancelToken?: CancelToken): Promise<GoogleSheetRes> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<GoogleSheetRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetRes>(null as any);
    }

    /**
     * Permenantly delete a GoogleSheet (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    delete(id: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Downloads a GoogleSheet or GoogleDrive file.
    If it is private our service account (trucksightgooglesheetaccess@trucksight-39771.iam.gserviceaccount.com) will need readonly access to it (Auth roles: Admin)
     * @param googleSheetUrl (optional) 
     * @param fileNameWithExtension (optional) 
     * @return OK
     */
    download(googleSheetUrl: string | undefined, fileNameWithExtension: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/Download?";
        if (googleSheetUrl === null)
            throw new Error("The parameter 'googleSheetUrl' cannot be null.");
        else if (googleSheetUrl !== undefined)
            url_ += "googleSheetUrl=" + encodeURIComponent("" + googleSheetUrl) + "&";
        if (fileNameWithExtension === null)
            throw new Error("The parameter 'fileNameWithExtension' cannot be null.");
        else if (fileNameWithExtension !== undefined)
            url_ += "fileNameWithExtension=" + encodeURIComponent("" + fileNameWithExtension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Fetches the specified sheet from google sheet as json. (Auth roles: Admin)
     * @param googleSheetUrl (optional) Any url that contains the spreadsheet id
     * @param rangeInA1Notation (optional) e.g. WTD Scorecard'!A1:D121 For enitre sheet just specify the sheet title. e.g. WTD Scorecard
     * @return OK
     */
    getSheetAsJson(googleSheetUrl: string | undefined, rangeInA1Notation: string | undefined, cancelToken?: CancelToken): Promise<ReadResponse> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/GetSheetAsJson?";
        if (googleSheetUrl === null)
            throw new Error("The parameter 'googleSheetUrl' cannot be null.");
        else if (googleSheetUrl !== undefined)
            url_ += "googleSheetUrl=" + encodeURIComponent("" + googleSheetUrl) + "&";
        if (rangeInA1Notation === null)
            throw new Error("The parameter 'rangeInA1Notation' cannot be null.");
        else if (rangeInA1Notation !== undefined)
            url_ += "rangeInA1Notation=" + encodeURIComponent("" + rangeInA1Notation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSheetAsJson(_response);
        });
    }

    protected processGetSheetAsJson(response: AxiosResponse): Promise<ReadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ReadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReadResponse>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param googlesheetId (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    getGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, googlesheetId: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<GoogleSheetHtmlTemplateRes> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/GetGoogleSheetHtmlTemplate?";
        if (googleSheetHtmlTemplateId === null)
            throw new Error("The parameter 'googleSheetHtmlTemplateId' cannot be null.");
        else if (googleSheetHtmlTemplateId !== undefined)
            url_ += "googleSheetHtmlTemplateId=" + encodeURIComponent("" + googleSheetHtmlTemplateId) + "&";
        if (googlesheetId === null)
            throw new Error("The parameter 'googlesheetId' cannot be null.");
        else if (googlesheetId !== undefined)
            url_ += "googlesheetId=" + encodeURIComponent("" + googlesheetId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleSheetHtmlTemplate(_response);
        });
    }

    protected processGetGoogleSheetHtmlTemplate(response: AxiosResponse): Promise<GoogleSheetHtmlTemplateRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetHtmlTemplateRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetHtmlTemplateRes>(null as any);
    }

    /**
     * All GoogleSheetHtmlTemplates for a specified GoogleSheet (Auth roles: Admin)
     * @param googlesheetId (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    allGoogleSheetHtmlTemplates(googlesheetId: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<GoogleSheetHtmlTemplateRes[]> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/AllGoogleSheetHtmlTemplates?";
        if (googlesheetId === null)
            throw new Error("The parameter 'googlesheetId' cannot be null.");
        else if (googlesheetId !== undefined)
            url_ += "googlesheetId=" + encodeURIComponent("" + googlesheetId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllGoogleSheetHtmlTemplates(_response);
        });
    }

    protected processAllGoogleSheetHtmlTemplates(response: AxiosResponse): Promise<GoogleSheetHtmlTemplateRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetHtmlTemplateRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetHtmlTemplateRes[]>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createGoogleSheetHtmlTemplate(companyId: number | undefined, body: GoogleSheetHtmlTemplateReq | undefined, cancelToken?: CancelToken): Promise<GoogleSheetHtmlTemplateRes> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/CreateGoogleSheetHtmlTemplate?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGoogleSheetHtmlTemplate(_response);
        });
    }

    protected processCreateGoogleSheetHtmlTemplate(response: AxiosResponse): Promise<GoogleSheetHtmlTemplateRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetHtmlTemplateRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetHtmlTemplateRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, companyId: number | undefined, body: GoogleSheetHtmlTemplateReq | undefined, cancelToken?: CancelToken): Promise<GoogleSheetHtmlTemplateRes> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/UpdateGoogleSheetHtmlTemplate?";
        if (googleSheetHtmlTemplateId === null)
            throw new Error("The parameter 'googleSheetHtmlTemplateId' cannot be null.");
        else if (googleSheetHtmlTemplateId !== undefined)
            url_ += "googleSheetHtmlTemplateId=" + encodeURIComponent("" + googleSheetHtmlTemplateId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGoogleSheetHtmlTemplate(_response);
        });
    }

    protected processUpdateGoogleSheetHtmlTemplate(response: AxiosResponse): Promise<GoogleSheetHtmlTemplateRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GoogleSheetHtmlTemplateRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleSheetHtmlTemplateRes>(null as any);
    }

    /**
     * Permenantly deletes a GoogleSheetHtmlTemplate (Auth roles: Admin)
     * @param googleSheetHtmlTemplateId (optional) 
     * @param googleSheetId (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    deleteGoogleSheetHtmlTemplate(googleSheetHtmlTemplateId: number | undefined, googleSheetId: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GoogleSheetsA/DeleteGoogleSheetHtmlTemplate?";
        if (googleSheetHtmlTemplateId === null)
            throw new Error("The parameter 'googleSheetHtmlTemplateId' cannot be null.");
        else if (googleSheetHtmlTemplateId !== undefined)
            url_ += "googleSheetHtmlTemplateId=" + encodeURIComponent("" + googleSheetHtmlTemplateId) + "&";
        if (googleSheetId === null)
            throw new Error("The parameter 'googleSheetId' cannot be null.");
        else if (googleSheetId !== undefined)
            url_ += "googleSheetId=" + encodeURIComponent("" + googleSheetId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGoogleSheetHtmlTemplate(_response);
        });
    }

    protected processDeleteGoogleSheetHtmlTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IHtmlToPdfAClient {
    /**
     * Allows an html file to be converted to PDF
     * @param masterPassword (optional) 
     * @param password (optional) 
     * @param htmlFile (optional) Max 40 MB file size
     * @param pdfServiceType (optional) 
     * @return OK
     */
    toPdf(masterPassword: string | undefined, password: string | undefined, htmlFile: FileParameter | undefined, pdfServiceType: PdfServiceType | undefined): Promise<FileResponse>;
    /**
     * Allows an html file to be converted to PDF
     * @param body (optional) 
     * @return OK
     */
    htmlStringToPdf(body: HtmlStringToPdfReq | undefined): Promise<FileResponse>;
}

export class HtmlToPdfAClient implements IHtmlToPdfAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Allows an html file to be converted to PDF
     * @param masterPassword (optional) 
     * @param password (optional) 
     * @param htmlFile (optional) Max 40 MB file size
     * @param pdfServiceType (optional) 
     * @return OK
     */
    toPdf(masterPassword: string | undefined, password: string | undefined, htmlFile: FileParameter | undefined, pdfServiceType: PdfServiceType | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/HtmlToPdfA/ToPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (masterPassword === null || masterPassword === undefined)
            throw new Error("The parameter 'masterPassword' cannot be null.");
        else
            content_.append("MasterPassword", masterPassword.toString());
        if (password === null || password === undefined)
            throw new Error("The parameter 'password' cannot be null.");
        else
            content_.append("Password", password.toString());
        if (htmlFile === null || htmlFile === undefined)
            throw new Error("The parameter 'htmlFile' cannot be null.");
        else
            content_.append("HtmlFile", htmlFile.data, htmlFile.fileName ? htmlFile.fileName : "HtmlFile");
        if (pdfServiceType === null || pdfServiceType === undefined)
            throw new Error("The parameter 'pdfServiceType' cannot be null.");
        else
            content_.append("PdfServiceType", pdfServiceType.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToPdf(_response);
        });
    }

    protected processToPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Allows an html file to be converted to PDF
     * @param body (optional) 
     * @return OK
     */
    htmlStringToPdf(body: HtmlStringToPdfReq | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/HtmlToPdfA/HtmlStringToPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHtmlStringToPdf(_response);
        });
    }

    protected processHtmlStringToPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IHttpIntegrationsClient {
    /**
     * Executes the specified query for the specifed ExternalProvider and returns Http response (Auth roles: Owner,Manager,Driver)
     * @param externalApiProviderType (optional) 
     * @param body (optional) 
     * @return OK
     */
    execute(externalApiProviderType: ExternalApiProviderType | undefined, body: HttpExecuteQueryReq | undefined): Promise<void>;
}

export class HttpIntegrationsClient implements IHttpIntegrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Executes the specified query for the specifed ExternalProvider and returns Http response (Auth roles: Owner,Manager,Driver)
     * @param externalApiProviderType (optional) 
     * @param body (optional) 
     * @return OK
     */
    execute(externalApiProviderType: ExternalApiProviderType | undefined, body: HttpExecuteQueryReq | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api/HttpIntegrations/Execute?";
        if (externalApiProviderType === null)
            throw new Error("The parameter 'externalApiProviderType' cannot be null.");
        else if (externalApiProviderType !== undefined)
            url_ += "externalApiProviderType=" + encodeURIComponent("" + externalApiProviderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecute(_response);
        });
    }

    protected processExecute(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IHttpQueriesAClient {
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: PagedReq | undefined): Promise<HttpQueryResPage>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    get(id: number | undefined, companyId: number | undefined): Promise<HttpQueryRes>;
    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: HttpQueryReq | undefined): Promise<HttpQueryRes>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: HttpQueryReq | undefined): Promise<HttpQueryRes>;
    /**
     * Copies query and mappings.
    Existing query with same actionId and its mappings, if any, will get overwritten. (Auth roles: Admin)
     * @param id (optional) 
     * @param sourceCompanyId (optional) 
     * @param targetCompanyId (optional) 
     * @return OK
     */
    copy(id: number | undefined, sourceCompanyId: number | undefined, targetCompanyId: number | undefined): Promise<HttpQueryRes>;
    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    delete(id: number | undefined, companyId: number | undefined): Promise<MessageResponseDto>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param appRole (optional) 
     * @return OK
     */
    mapRole(id: number | undefined, appRole: string | undefined): Promise<void>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param appRole (optional) 
     * @return OK
     */
    unmapRole(id: number | undefined, appRole: string | undefined): Promise<void>;
}

export class HttpQueriesAClient implements IHttpQueriesAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: PagedReq | undefined, cancelToken?: CancelToken): Promise<HttpQueryResPage> {
        let url_ = this.baseUrl + "/api/HttpQueriesA/Page?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<HttpQueryResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HttpQueryResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpQueryResPage>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    get(id: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<HttpQueryRes> {
        let url_ = this.baseUrl + "/api/HttpQueriesA/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<HttpQueryRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HttpQueryRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpQueryRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: HttpQueryReq | undefined, cancelToken?: CancelToken): Promise<HttpQueryRes> {
        let url_ = this.baseUrl + "/api/HttpQueriesA/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<HttpQueryRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HttpQueryRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpQueryRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: HttpQueryReq | undefined, cancelToken?: CancelToken): Promise<HttpQueryRes> {
        let url_ = this.baseUrl + "/api/HttpQueriesA/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<HttpQueryRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HttpQueryRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpQueryRes>(null as any);
    }

    /**
     * Copies query and mappings.
    Existing query with same actionId and its mappings, if any, will get overwritten. (Auth roles: Admin)
     * @param id (optional) 
     * @param sourceCompanyId (optional) 
     * @param targetCompanyId (optional) 
     * @return OK
     */
    copy(id: number | undefined, sourceCompanyId: number | undefined, targetCompanyId: number | undefined, cancelToken?: CancelToken): Promise<HttpQueryRes> {
        let url_ = this.baseUrl + "/api/HttpQueriesA/Copy?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (sourceCompanyId === null)
            throw new Error("The parameter 'sourceCompanyId' cannot be null.");
        else if (sourceCompanyId !== undefined)
            url_ += "sourceCompanyId=" + encodeURIComponent("" + sourceCompanyId) + "&";
        if (targetCompanyId === null)
            throw new Error("The parameter 'targetCompanyId' cannot be null.");
        else if (targetCompanyId !== undefined)
            url_ += "targetCompanyId=" + encodeURIComponent("" + targetCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<HttpQueryRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HttpQueryRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpQueryRes>(null as any);
    }

    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    delete(id: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/HttpQueriesA/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param appRole (optional) 
     * @return OK
     */
    mapRole(id: number | undefined, appRole: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HttpQueriesA/MapRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (appRole === null)
            throw new Error("The parameter 'appRole' cannot be null.");
        else if (appRole !== undefined)
            url_ += "appRole=" + encodeURIComponent("" + appRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMapRole(_response);
        });
    }

    protected processMapRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param appRole (optional) 
     * @return OK
     */
    unmapRole(id: number | undefined, appRole: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HttpQueriesA/UnmapRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (appRole === null)
            throw new Error("The parameter 'appRole' cannot be null.");
        else if (appRole !== undefined)
            url_ += "appRole=" + encodeURIComponent("" + appRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnmapRole(_response);
        });
    }

    protected processUnmapRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IJobsitesClient {
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<JobsiteRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined): Promise<JobsiteResPage>;
    /**
     * Pagination in descending order of creation for Permanant Jobistes (not null Name).
    Use this for populating dropdowns (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    pagePermanant(body: PagedReq | undefined): Promise<JobsiteResPage>;
    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: JobsiteReq | undefined): Promise<JobsiteRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: JobsiteReq | undefined): Promise<JobsiteRes>;
    /**
     * Allows to soft-delete a Jobsite (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    softDelete(id: number | undefined): Promise<void>;
}

export class JobsitesClient implements IJobsitesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<JobsiteRes> {
        let url_ = this.baseUrl + "/api/Jobsites/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<JobsiteRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobsiteRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobsiteRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<JobsiteResPage> {
        let url_ = this.baseUrl + "/api/Jobsites/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<JobsiteResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobsiteResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobsiteResPage>(null as any);
    }

    /**
     * Pagination in descending order of creation for Permanant Jobistes (not null Name).
    Use this for populating dropdowns (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    pagePermanant(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<JobsiteResPage> {
        let url_ = this.baseUrl + "/api/Jobsites/PagePermanant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagePermanant(_response);
        });
    }

    protected processPagePermanant(response: AxiosResponse): Promise<JobsiteResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobsiteResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobsiteResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: JobsiteReq | undefined, cancelToken?: CancelToken): Promise<JobsiteRes> {
        let url_ = this.baseUrl + "/api/Jobsites/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<JobsiteRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobsiteRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobsiteRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: JobsiteReq | undefined, cancelToken?: CancelToken): Promise<JobsiteRes> {
        let url_ = this.baseUrl + "/api/Jobsites/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<JobsiteRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobsiteRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobsiteRes>(null as any);
    }

    /**
     * Allows to soft-delete a Jobsite (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    softDelete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobsites/SoftDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSoftDelete(_response);
        });
    }

    protected processSoftDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOdataClient {
    /**
     * @return OK
     */
    $metadata(): Promise<IEdmModel>;
    /**
     * (Auth roles: Admin)
     * @return OK
     */
    shiftsOData(): Promise<ShiftODataRes[]>;
}

export class OdataClient implements IOdataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    $metadata( cancelToken?: CancelToken): Promise<IEdmModel> {
        let url_ = this.baseUrl + "/odata/$metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.process$metadata(_response);
        });
    }

    protected process$metadata(response: AxiosResponse): Promise<IEdmModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IEdmModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IEdmModel>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @return OK
     */
    shiftsOData( cancelToken?: CancelToken): Promise<ShiftODataRes[]> {
        let url_ = this.baseUrl + "/odata/ShiftsOData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShiftsOData(_response);
        });
    }

    protected processShiftsOData(response: AxiosResponse): Promise<ShiftODataRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftODataRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftODataRes[]>(null as any);
    }
}

export interface IClient {
    /**
     * @return OK
     */
    odata(): Promise<ODataServiceDocument>;
}

export class Client implements IClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    odata( cancelToken?: CancelToken): Promise<ODataServiceDocument> {
        let url_ = this.baseUrl + "/odata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOdata(_response);
        });
    }

    protected processOdata(response: AxiosResponse): Promise<ODataServiceDocument> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ODataServiceDocument>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ODataServiceDocument>(null as any);
    }
}

export interface IPayRatesClient {
    /**
     * (Auth roles: Owner,Accountant)
     * @param staffId (optional) 
     * @return OK
     */
    getPayRate(staffId: number | undefined): Promise<PayRateRes>;
    /**
     * Bulk updates existing non-deleted staff's PayRates. (Auth roles: Owner)
     * @param body (optional) 
     * @return OK
     */
    updatePayRates(body: UpdatePayRatesReq | undefined): Promise<StaffRes[]>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @return OK
     */
    getPayRateJobsiteAddOn(addOnId: number | undefined): Promise<PayRateJobsiteAddOnRes>;
    /**
     * Gets Paginated PayRateJobsiteAddOns with mapping to Users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pagePayRateJobsiteAddOns(body: PagedReq | undefined): Promise<PayRateJobsiteAddOnResPage>;
    /**
     * Bulk creates PayRate Jobsite AddOns and optionally assign them to specified users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    createPayRateJobsiteAddOns(body: CreatePayRateJobsiteAddOnReq | undefined): Promise<PayRateJobsiteAddOnResPage>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePayRateJobsiteAddOn(addOnId: number | undefined, body: PayRateJobsiteAddOnReq | undefined): Promise<PayRateJobsiteAddOnRes>;
    /**
     * Assigns the specified Users to the specified PayrateJobsiteAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    assignUsersToPayRateJobsiteAddOn(body: UpdateUserToPayRateJobsiteAddOnMapReq | undefined): Promise<PayRateJobsiteAddOnRes>;
    /**
     * Unassigns the specified Users from the specified PayrateJobsiteAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    unassignUsersFromPayRateJobsiteAddOn(body: UpdateUserToPayRateJobsiteAddOnMapReq | undefined): Promise<PayRateJobsiteAddOnRes>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    deletePayRateJobsiteAddOns(body: number[] | undefined): Promise<void>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @return OK
     */
    getPayRateShiftTimeAddOn(addOnId: number | undefined): Promise<PayRateShiftTimeAddOnRes>;
    /**
     * Gets Paginated PayRateShiftTimeAddOns with mapping to Users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pagePayRateShiftTimeAddOns(body: PagedReq | undefined): Promise<PayRateShiftTimeAddOnResPage>;
    /**
     * Bulk creates PayRate ShiftTime AddOns and optionally assign them to specified users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    createPayRateShiftTimeAddOns(body: CreatePayRateShiftTimeAddOnReq | undefined): Promise<PayRateShiftTimeAddOnResPage>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePayRateShiftTimeAddOn(addOnId: number | undefined, body: PayRateShiftTimeAddOnReq | undefined): Promise<PayRateShiftTimeAddOnRes>;
    /**
     * Assigns the specified Users to the specified PayrateShiftTimeAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    assignUsersToPayRateShiftTimeAddOn(body: UpdateUserToPayRateShiftTimeAddOnMapReq | undefined): Promise<PayRateShiftTimeAddOnRes>;
    /**
     * Unassigns the specified Users from the specified PayrateShiftTimeAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    unassignUsersFromPayRateShiftTimeAddOn(body: UpdateUserToPayRateShiftTimeAddOnMapReq | undefined): Promise<PayRateShiftTimeAddOnRes>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    deletePayRateShiftTimeAddOns(body: number[] | undefined): Promise<void>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @return OK
     */
    getPayRateShiftDurationAddOn(addOnId: number | undefined): Promise<PayRateShiftDurationAddOnRes>;
    /**
     * Gets Paginated PayRateShiftDurationAddOns with mapping to Users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pagePayRateShiftDurationAddOns(body: PagedReq | undefined): Promise<PayRateShiftDurationAddOnResPage>;
    /**
     * Bulk creates PayRate ShiftDuration AddOns and optionally assign them to specified users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    createPayRateShiftDurationAddOns(body: CreatePayRateShiftDurationAddOnReq | undefined): Promise<PayRateShiftDurationAddOnResPage>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePayRateShiftDurationAddOn(addOnId: number | undefined, body: PayRateShiftDurationAddOnReq | undefined): Promise<PayRateShiftDurationAddOnRes>;
    /**
     * Assigns the specified Users to the specified PayrateShiftDurationAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    assignUsersToPayRateShiftDurationAddOn(body: UpdateUserToPayRateShiftDurationAddOnMapReq | undefined): Promise<PayRateShiftDurationAddOnRes>;
    /**
     * Unassigns the specified Users from the specified PayrateShiftDurationAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    unassignUsersFromPayRateShiftDurationAddOn(body: UpdateUserToPayRateShiftDurationAddOnMapReq | undefined): Promise<PayRateShiftDurationAddOnRes>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    deletePayRateShiftDurationAddOns(body: number[] | undefined): Promise<void>;
}

export class PayRatesClient implements IPayRatesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param staffId (optional) 
     * @return OK
     */
    getPayRate(staffId: number | undefined, cancelToken?: CancelToken): Promise<PayRateRes> {
        let url_ = this.baseUrl + "/api/PayRates/GetPayRate?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayRate(_response);
        });
    }

    protected processGetPayRate(response: AxiosResponse): Promise<PayRateRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateRes>(null as any);
    }

    /**
     * Bulk updates existing non-deleted staff's PayRates. (Auth roles: Owner)
     * @param body (optional) 
     * @return OK
     */
    updatePayRates(body: UpdatePayRatesReq | undefined, cancelToken?: CancelToken): Promise<StaffRes[]> {
        let url_ = this.baseUrl + "/api/PayRates/UpdatePayRates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayRates(_response);
        });
    }

    protected processUpdatePayRates(response: AxiosResponse): Promise<StaffRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StaffRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffRes[]>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @return OK
     */
    getPayRateJobsiteAddOn(addOnId: number | undefined, cancelToken?: CancelToken): Promise<PayRateJobsiteAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/GetPayRateJobsiteAddOn?";
        if (addOnId === null)
            throw new Error("The parameter 'addOnId' cannot be null.");
        else if (addOnId !== undefined)
            url_ += "addOnId=" + encodeURIComponent("" + addOnId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayRateJobsiteAddOn(_response);
        });
    }

    protected processGetPayRateJobsiteAddOn(response: AxiosResponse): Promise<PayRateJobsiteAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateJobsiteAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateJobsiteAddOnRes>(null as any);
    }

    /**
     * Gets Paginated PayRateJobsiteAddOns with mapping to Users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pagePayRateJobsiteAddOns(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<PayRateJobsiteAddOnResPage> {
        let url_ = this.baseUrl + "/api/PayRates/PagePayRateJobsiteAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagePayRateJobsiteAddOns(_response);
        });
    }

    protected processPagePayRateJobsiteAddOns(response: AxiosResponse): Promise<PayRateJobsiteAddOnResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateJobsiteAddOnResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateJobsiteAddOnResPage>(null as any);
    }

    /**
     * Bulk creates PayRate Jobsite AddOns and optionally assign them to specified users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    createPayRateJobsiteAddOns(body: CreatePayRateJobsiteAddOnReq | undefined, cancelToken?: CancelToken): Promise<PayRateJobsiteAddOnResPage> {
        let url_ = this.baseUrl + "/api/PayRates/CreatePayRateJobsiteAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePayRateJobsiteAddOns(_response);
        });
    }

    protected processCreatePayRateJobsiteAddOns(response: AxiosResponse): Promise<PayRateJobsiteAddOnResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateJobsiteAddOnResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateJobsiteAddOnResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePayRateJobsiteAddOn(addOnId: number | undefined, body: PayRateJobsiteAddOnReq | undefined, cancelToken?: CancelToken): Promise<PayRateJobsiteAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/UpdatePayRateJobsiteAddOn?";
        if (addOnId === null)
            throw new Error("The parameter 'addOnId' cannot be null.");
        else if (addOnId !== undefined)
            url_ += "addOnId=" + encodeURIComponent("" + addOnId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayRateJobsiteAddOn(_response);
        });
    }

    protected processUpdatePayRateJobsiteAddOn(response: AxiosResponse): Promise<PayRateJobsiteAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateJobsiteAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateJobsiteAddOnRes>(null as any);
    }

    /**
     * Assigns the specified Users to the specified PayrateJobsiteAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    assignUsersToPayRateJobsiteAddOn(body: UpdateUserToPayRateJobsiteAddOnMapReq | undefined, cancelToken?: CancelToken): Promise<PayRateJobsiteAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/AssignUsersToPayRateJobsiteAddOn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignUsersToPayRateJobsiteAddOn(_response);
        });
    }

    protected processAssignUsersToPayRateJobsiteAddOn(response: AxiosResponse): Promise<PayRateJobsiteAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateJobsiteAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateJobsiteAddOnRes>(null as any);
    }

    /**
     * Unassigns the specified Users from the specified PayrateJobsiteAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    unassignUsersFromPayRateJobsiteAddOn(body: UpdateUserToPayRateJobsiteAddOnMapReq | undefined, cancelToken?: CancelToken): Promise<PayRateJobsiteAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/UnassignUsersFromPayRateJobsiteAddOn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnassignUsersFromPayRateJobsiteAddOn(_response);
        });
    }

    protected processUnassignUsersFromPayRateJobsiteAddOn(response: AxiosResponse): Promise<PayRateJobsiteAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateJobsiteAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateJobsiteAddOnRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    deletePayRateJobsiteAddOns(body: number[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PayRates/DeletePayRateJobsiteAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePayRateJobsiteAddOns(_response);
        });
    }

    protected processDeletePayRateJobsiteAddOns(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @return OK
     */
    getPayRateShiftTimeAddOn(addOnId: number | undefined, cancelToken?: CancelToken): Promise<PayRateShiftTimeAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/GetPayRateShiftTimeAddOn?";
        if (addOnId === null)
            throw new Error("The parameter 'addOnId' cannot be null.");
        else if (addOnId !== undefined)
            url_ += "addOnId=" + encodeURIComponent("" + addOnId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayRateShiftTimeAddOn(_response);
        });
    }

    protected processGetPayRateShiftTimeAddOn(response: AxiosResponse): Promise<PayRateShiftTimeAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftTimeAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftTimeAddOnRes>(null as any);
    }

    /**
     * Gets Paginated PayRateShiftTimeAddOns with mapping to Users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pagePayRateShiftTimeAddOns(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftTimeAddOnResPage> {
        let url_ = this.baseUrl + "/api/PayRates/PagePayRateShiftTimeAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagePayRateShiftTimeAddOns(_response);
        });
    }

    protected processPagePayRateShiftTimeAddOns(response: AxiosResponse): Promise<PayRateShiftTimeAddOnResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftTimeAddOnResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftTimeAddOnResPage>(null as any);
    }

    /**
     * Bulk creates PayRate ShiftTime AddOns and optionally assign them to specified users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    createPayRateShiftTimeAddOns(body: CreatePayRateShiftTimeAddOnReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftTimeAddOnResPage> {
        let url_ = this.baseUrl + "/api/PayRates/CreatePayRateShiftTimeAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePayRateShiftTimeAddOns(_response);
        });
    }

    protected processCreatePayRateShiftTimeAddOns(response: AxiosResponse): Promise<PayRateShiftTimeAddOnResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftTimeAddOnResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftTimeAddOnResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePayRateShiftTimeAddOn(addOnId: number | undefined, body: PayRateShiftTimeAddOnReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftTimeAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/UpdatePayRateShiftTimeAddOn?";
        if (addOnId === null)
            throw new Error("The parameter 'addOnId' cannot be null.");
        else if (addOnId !== undefined)
            url_ += "addOnId=" + encodeURIComponent("" + addOnId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayRateShiftTimeAddOn(_response);
        });
    }

    protected processUpdatePayRateShiftTimeAddOn(response: AxiosResponse): Promise<PayRateShiftTimeAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftTimeAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftTimeAddOnRes>(null as any);
    }

    /**
     * Assigns the specified Users to the specified PayrateShiftTimeAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    assignUsersToPayRateShiftTimeAddOn(body: UpdateUserToPayRateShiftTimeAddOnMapReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftTimeAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/AssignUsersToPayRateShiftTimeAddOn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignUsersToPayRateShiftTimeAddOn(_response);
        });
    }

    protected processAssignUsersToPayRateShiftTimeAddOn(response: AxiosResponse): Promise<PayRateShiftTimeAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftTimeAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftTimeAddOnRes>(null as any);
    }

    /**
     * Unassigns the specified Users from the specified PayrateShiftTimeAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    unassignUsersFromPayRateShiftTimeAddOn(body: UpdateUserToPayRateShiftTimeAddOnMapReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftTimeAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/UnassignUsersFromPayRateShiftTimeAddOn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnassignUsersFromPayRateShiftTimeAddOn(_response);
        });
    }

    protected processUnassignUsersFromPayRateShiftTimeAddOn(response: AxiosResponse): Promise<PayRateShiftTimeAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftTimeAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftTimeAddOnRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    deletePayRateShiftTimeAddOns(body: number[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PayRates/DeletePayRateShiftTimeAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePayRateShiftTimeAddOns(_response);
        });
    }

    protected processDeletePayRateShiftTimeAddOns(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @return OK
     */
    getPayRateShiftDurationAddOn(addOnId: number | undefined, cancelToken?: CancelToken): Promise<PayRateShiftDurationAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/GetPayRateShiftDurationAddOn?";
        if (addOnId === null)
            throw new Error("The parameter 'addOnId' cannot be null.");
        else if (addOnId !== undefined)
            url_ += "addOnId=" + encodeURIComponent("" + addOnId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayRateShiftDurationAddOn(_response);
        });
    }

    protected processGetPayRateShiftDurationAddOn(response: AxiosResponse): Promise<PayRateShiftDurationAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftDurationAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftDurationAddOnRes>(null as any);
    }

    /**
     * Gets Paginated PayRateShiftDurationAddOns with mapping to Users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pagePayRateShiftDurationAddOns(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftDurationAddOnResPage> {
        let url_ = this.baseUrl + "/api/PayRates/PagePayRateShiftDurationAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagePayRateShiftDurationAddOns(_response);
        });
    }

    protected processPagePayRateShiftDurationAddOns(response: AxiosResponse): Promise<PayRateShiftDurationAddOnResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftDurationAddOnResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftDurationAddOnResPage>(null as any);
    }

    /**
     * Bulk creates PayRate ShiftDuration AddOns and optionally assign them to specified users (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    createPayRateShiftDurationAddOns(body: CreatePayRateShiftDurationAddOnReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftDurationAddOnResPage> {
        let url_ = this.baseUrl + "/api/PayRates/CreatePayRateShiftDurationAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePayRateShiftDurationAddOns(_response);
        });
    }

    protected processCreatePayRateShiftDurationAddOns(response: AxiosResponse): Promise<PayRateShiftDurationAddOnResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftDurationAddOnResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftDurationAddOnResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param addOnId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePayRateShiftDurationAddOn(addOnId: number | undefined, body: PayRateShiftDurationAddOnReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftDurationAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/UpdatePayRateShiftDurationAddOn?";
        if (addOnId === null)
            throw new Error("The parameter 'addOnId' cannot be null.");
        else if (addOnId !== undefined)
            url_ += "addOnId=" + encodeURIComponent("" + addOnId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayRateShiftDurationAddOn(_response);
        });
    }

    protected processUpdatePayRateShiftDurationAddOn(response: AxiosResponse): Promise<PayRateShiftDurationAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftDurationAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftDurationAddOnRes>(null as any);
    }

    /**
     * Assigns the specified Users to the specified PayrateShiftDurationAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    assignUsersToPayRateShiftDurationAddOn(body: UpdateUserToPayRateShiftDurationAddOnMapReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftDurationAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/AssignUsersToPayRateShiftDurationAddOn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignUsersToPayRateShiftDurationAddOn(_response);
        });
    }

    protected processAssignUsersToPayRateShiftDurationAddOn(response: AxiosResponse): Promise<PayRateShiftDurationAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftDurationAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftDurationAddOnRes>(null as any);
    }

    /**
     * Unassigns the specified Users from the specified PayrateShiftDurationAddOn (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    unassignUsersFromPayRateShiftDurationAddOn(body: UpdateUserToPayRateShiftDurationAddOnMapReq | undefined, cancelToken?: CancelToken): Promise<PayRateShiftDurationAddOnRes> {
        let url_ = this.baseUrl + "/api/PayRates/UnassignUsersFromPayRateShiftDurationAddOn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnassignUsersFromPayRateShiftDurationAddOn(_response);
        });
    }

    protected processUnassignUsersFromPayRateShiftDurationAddOn(response: AxiosResponse): Promise<PayRateShiftDurationAddOnRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayRateShiftDurationAddOnRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayRateShiftDurationAddOnRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    deletePayRateShiftDurationAddOns(body: number[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PayRates/DeletePayRateShiftDurationAddOns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePayRateShiftDurationAddOns(_response);
        });
    }

    protected processDeletePayRateShiftDurationAddOns(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPayrollClient {
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pagePayrollPeriods(body: PagedReq | undefined): Promise<PayrollPeriodPageResPage>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    getPayrollPeriod(payrollPeriodId: number | undefined): Promise<PayrollPeriodRes>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    createPayrollPeriod(body: PayrollPeriodReq | undefined): Promise<PayrollPeriodRes>;
    /**
     * Updates the PayrollPeriod and recalculates LineItems and Summaries in it (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePayrollPeriod(payrollPeriodId: number | undefined, body: PayrollPeriodReq | undefined): Promise<PayrollPeriodRes>;
    /**
     * Enqueues the spepcified PayPeriod for processing. (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    enqueuePayrollPeriod(body: EnqueuePayrollPeriodReq | undefined): Promise<MessageResponseDto>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    deletePayrollPeriod(payrollPeriodId: number | undefined): Promise<MessageResponseDto>;
    /**
     * Generates Payroll (LineItems and Summary) using Shifts saved in the Database (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    generatePayroll(body: GeneratePayrollReq | undefined): Promise<PayrollPeriodRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pageLineItems(body: PayrollLineItemPagedReq | undefined): Promise<PayrollLineItemResPage>;
    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pageLineItemsGroupedByUserAndDay(body: PayrollLineItemPagedReq | undefined): Promise<PayrollLineItemsGroupedByUserAndDayResPage>;
    /**
     * Allows to download the Payroll Upload file template as an excel file (.xlsx)
    Note: SwaggerRespose with coorect content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth roles: Owner,Accountant)
     * @return OK
     */
    downloadPayrollUploadFile(): Promise<FileResponse>;
    /**
     * Imports Payrole Excel, calculates LineItems, and recalculates Summary (Auth roles: Owner,Accountant)
     * @param excelFile (optional) Max 40 MB file size
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    uploadLineItems(excelFile: FileParameter | undefined, payrollPeriodId: number | undefined): Promise<PayrollPeriodRes>;
    /**
     * Imports PayrollLineItems from Google Sheet and returns them to UI without saving to DB
    UI can show them as a preview and allow user to confirm/change before sedning them back to API using M:Api.Controllers.PayrollController.CreateLineItems(System.Int64,System.Collections.Generic.List{Api.Poco.Dtos.PayrollLineItem.CreatePayrollLineItemReq}) (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    importFromGoogleSheetToUi(body: ImportPayrollLineItemsFromGoogleSheetToUiReq | undefined): Promise<CreatePayrollLineItemToUiReq[]>;
    /**
     * Creates new payrole line items and recalculates Summary (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createLineItems(payrollPeriodId: number | undefined, body: CreatePayrollLineItemReq[] | undefined): Promise<PayrollPeriodRes>;
    /**
     * Updates existing Payrole Line Items and recalculates Pay for Line Item and its Summary (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateLineItems(payrollPeriodId: number | undefined, body: UpdatePayrollLineItemReq[] | undefined): Promise<PayrollPeriodRes>;
    /**
     * Delete specified payrole line items and recalculates Summary (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @param body (optional) ids of line items
     * @return OK
     */
    deleteLineItems(payrollPeriodId: number | undefined, body: number[] | undefined): Promise<PayrollPeriodRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pageSummary(body: PayrollSummaryPagedReq | undefined): Promise<PayrollSummaryResPage>;
    /**
     * Allows to download the PayrollSummary as an Excel file (.xlsx)
    Note: SwaggerRespose with coorect content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    downloadSummary(payrollPeriodId: number | undefined): Promise<FileResponse>;
    /**
     * Gets monthly aggregated pay summaries for all the Users of the companies for the specified datetime interval (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    getUserPayMonthlySummaries(body: UserPayMonthlySummaryReq | undefined): Promise<UserPayMonthlySummaryRes[]>;
    /**
     * Downloads Excel file (.xlsx) containing monthly aggregated pay summaries for all the Users of the companies for the specified datetime interval
    Note: SwaggerRespose with correct content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    downloadUserPayMonthlySummaries(body: UserPayMonthlySummaryReq | undefined): Promise<FileResponse>;
}

export class PayrollClient implements IPayrollClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pagePayrollPeriods(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodPageResPage> {
        let url_ = this.baseUrl + "/api/Payroll/PagePayrollPeriods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagePayrollPeriods(_response);
        });
    }

    protected processPagePayrollPeriods(response: AxiosResponse): Promise<PayrollPeriodPageResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodPageResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodPageResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    getPayrollPeriod(payrollPeriodId: number | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodRes> {
        let url_ = this.baseUrl + "/api/Payroll/GetPayrollPeriod?";
        if (payrollPeriodId === null)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else if (payrollPeriodId !== undefined)
            url_ += "payrollPeriodId=" + encodeURIComponent("" + payrollPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayrollPeriod(_response);
        });
    }

    protected processGetPayrollPeriod(response: AxiosResponse): Promise<PayrollPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    createPayrollPeriod(body: PayrollPeriodReq | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodRes> {
        let url_ = this.baseUrl + "/api/Payroll/CreatePayrollPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePayrollPeriod(_response);
        });
    }

    protected processCreatePayrollPeriod(response: AxiosResponse): Promise<PayrollPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodRes>(null as any);
    }

    /**
     * Updates the PayrollPeriod and recalculates LineItems and Summaries in it (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePayrollPeriod(payrollPeriodId: number | undefined, body: PayrollPeriodReq | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodRes> {
        let url_ = this.baseUrl + "/api/Payroll/UpdatePayrollPeriod?";
        if (payrollPeriodId === null)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else if (payrollPeriodId !== undefined)
            url_ += "payrollPeriodId=" + encodeURIComponent("" + payrollPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayrollPeriod(_response);
        });
    }

    protected processUpdatePayrollPeriod(response: AxiosResponse): Promise<PayrollPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodRes>(null as any);
    }

    /**
     * Enqueues the spepcified PayPeriod for processing. (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    enqueuePayrollPeriod(body: EnqueuePayrollPeriodReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Payroll/EnqueuePayrollPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnqueuePayrollPeriod(_response);
        });
    }

    protected processEnqueuePayrollPeriod(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    deletePayrollPeriod(payrollPeriodId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Payroll/DeletePayrollPeriod?";
        if (payrollPeriodId === null)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else if (payrollPeriodId !== undefined)
            url_ += "payrollPeriodId=" + encodeURIComponent("" + payrollPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePayrollPeriod(_response);
        });
    }

    protected processDeletePayrollPeriod(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Generates Payroll (LineItems and Summary) using Shifts saved in the Database (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    generatePayroll(body: GeneratePayrollReq | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodRes> {
        let url_ = this.baseUrl + "/api/Payroll/GeneratePayroll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeneratePayroll(_response);
        });
    }

    protected processGeneratePayroll(response: AxiosResponse): Promise<PayrollPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pageLineItems(body: PayrollLineItemPagedReq | undefined, cancelToken?: CancelToken): Promise<PayrollLineItemResPage> {
        let url_ = this.baseUrl + "/api/Payroll/PageLineItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageLineItems(_response);
        });
    }

    protected processPageLineItems(response: AxiosResponse): Promise<PayrollLineItemResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollLineItemResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollLineItemResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pageLineItemsGroupedByUserAndDay(body: PayrollLineItemPagedReq | undefined, cancelToken?: CancelToken): Promise<PayrollLineItemsGroupedByUserAndDayResPage> {
        let url_ = this.baseUrl + "/api/Payroll/PageLineItemsGroupedByUserAndDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageLineItemsGroupedByUserAndDay(_response);
        });
    }

    protected processPageLineItemsGroupedByUserAndDay(response: AxiosResponse): Promise<PayrollLineItemsGroupedByUserAndDayResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollLineItemsGroupedByUserAndDayResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollLineItemsGroupedByUserAndDayResPage>(null as any);
    }

    /**
     * Allows to download the Payroll Upload file template as an excel file (.xlsx)
    Note: SwaggerRespose with coorect content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth roles: Owner,Accountant)
     * @return OK
     */
    downloadPayrollUploadFile( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payroll/DownloadPayrollUploadFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadPayrollUploadFile(_response);
        });
    }

    protected processDownloadPayrollUploadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Imports Payrole Excel, calculates LineItems, and recalculates Summary (Auth roles: Owner,Accountant)
     * @param excelFile (optional) Max 40 MB file size
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    uploadLineItems(excelFile: FileParameter | undefined, payrollPeriodId: number | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodRes> {
        let url_ = this.baseUrl + "/api/Payroll/UploadLineItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("ExcelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "ExcelFile");
        if (payrollPeriodId === null || payrollPeriodId === undefined)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else
            content_.append("PayrollPeriodId", payrollPeriodId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadLineItems(_response);
        });
    }

    protected processUploadLineItems(response: AxiosResponse): Promise<PayrollPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodRes>(null as any);
    }

    /**
     * Imports PayrollLineItems from Google Sheet and returns them to UI without saving to DB
    UI can show them as a preview and allow user to confirm/change before sedning them back to API using M:Api.Controllers.PayrollController.CreateLineItems(System.Int64,System.Collections.Generic.List{Api.Poco.Dtos.PayrollLineItem.CreatePayrollLineItemReq}) (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    importFromGoogleSheetToUi(body: ImportPayrollLineItemsFromGoogleSheetToUiReq | undefined, cancelToken?: CancelToken): Promise<CreatePayrollLineItemToUiReq[]> {
        let url_ = this.baseUrl + "/api/Payroll/ImportFromGoogleSheetToUi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportFromGoogleSheetToUi(_response);
        });
    }

    protected processImportFromGoogleSheetToUi(response: AxiosResponse): Promise<CreatePayrollLineItemToUiReq[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CreatePayrollLineItemToUiReq[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatePayrollLineItemToUiReq[]>(null as any);
    }

    /**
     * Creates new payrole line items and recalculates Summary (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createLineItems(payrollPeriodId: number | undefined, body: CreatePayrollLineItemReq[] | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodRes> {
        let url_ = this.baseUrl + "/api/Payroll/CreateLineItems?";
        if (payrollPeriodId === null)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else if (payrollPeriodId !== undefined)
            url_ += "payrollPeriodId=" + encodeURIComponent("" + payrollPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLineItems(_response);
        });
    }

    protected processCreateLineItems(response: AxiosResponse): Promise<PayrollPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodRes>(null as any);
    }

    /**
     * Updates existing Payrole Line Items and recalculates Pay for Line Item and its Summary (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateLineItems(payrollPeriodId: number | undefined, body: UpdatePayrollLineItemReq[] | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodRes> {
        let url_ = this.baseUrl + "/api/Payroll/UpdateLineItems?";
        if (payrollPeriodId === null)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else if (payrollPeriodId !== undefined)
            url_ += "payrollPeriodId=" + encodeURIComponent("" + payrollPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLineItems(_response);
        });
    }

    protected processUpdateLineItems(response: AxiosResponse): Promise<PayrollPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodRes>(null as any);
    }

    /**
     * Delete specified payrole line items and recalculates Summary (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @param body (optional) ids of line items
     * @return OK
     */
    deleteLineItems(payrollPeriodId: number | undefined, body: number[] | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodRes> {
        let url_ = this.baseUrl + "/api/Payroll/DeleteLineItems?";
        if (payrollPeriodId === null)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else if (payrollPeriodId !== undefined)
            url_ += "payrollPeriodId=" + encodeURIComponent("" + payrollPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLineItems(_response);
        });
    }

    protected processDeleteLineItems(response: AxiosResponse): Promise<PayrollPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    pageSummary(body: PayrollSummaryPagedReq | undefined, cancelToken?: CancelToken): Promise<PayrollSummaryResPage> {
        let url_ = this.baseUrl + "/api/Payroll/PageSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageSummary(_response);
        });
    }

    protected processPageSummary(response: AxiosResponse): Promise<PayrollSummaryResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollSummaryResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollSummaryResPage>(null as any);
    }

    /**
     * Allows to download the PayrollSummary as an Excel file (.xlsx)
    Note: SwaggerRespose with coorect content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth roles: Owner,Accountant)
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    downloadSummary(payrollPeriodId: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payroll/DownloadSummary?";
        if (payrollPeriodId === null)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else if (payrollPeriodId !== undefined)
            url_ += "payrollPeriodId=" + encodeURIComponent("" + payrollPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSummary(_response);
        });
    }

    protected processDownloadSummary(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets monthly aggregated pay summaries for all the Users of the companies for the specified datetime interval (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    getUserPayMonthlySummaries(body: UserPayMonthlySummaryReq | undefined, cancelToken?: CancelToken): Promise<UserPayMonthlySummaryRes[]> {
        let url_ = this.baseUrl + "/api/Payroll/GetUserPayMonthlySummaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPayMonthlySummaries(_response);
        });
    }

    protected processGetUserPayMonthlySummaries(response: AxiosResponse): Promise<UserPayMonthlySummaryRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserPayMonthlySummaryRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPayMonthlySummaryRes[]>(null as any);
    }

    /**
     * Downloads Excel file (.xlsx) containing monthly aggregated pay summaries for all the Users of the companies for the specified datetime interval
    Note: SwaggerRespose with correct content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth roles: Owner,Accountant)
     * @param body (optional) 
     * @return OK
     */
    downloadUserPayMonthlySummaries(body: UserPayMonthlySummaryReq | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payroll/DownloadUserPayMonthlySummaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadUserPayMonthlySummaries(_response);
        });
    }

    protected processDownloadUserPayMonthlySummaries(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPayrollAClient {
    /**
     * Gets all queued PayrollPeriods for specified Company (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    getQueuedPayrollPeriods(companyId: number | undefined): Promise<PayrollPeriodQueueRes[]>;
    /**
     * Gets all queued PayrollPeriods for all Companies (Auth roles: Admin)
     * @return OK
     */
    getQueuedPayrollPeriodsAll(): Promise<PayrollPeriodQueueRes[]>;
    /**
     * Gets PayrollSummaries aggregated by user over the specified period of time for the specified company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    payrollSummaryReport(body: PayrollSummaryReportReq | undefined): Promise<PayrollSummaryReportRes[]>;
    /**
     * Processes the specified PayPeriod (previosuly enqueued). (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    dequeuedPayrollPeriod(body: DequeuePayrollPeriodAReq | undefined): Promise<MessageResponseDto>;
    /**
     * Processes the specified PayPeriod (previosuly enqueued). (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    processQueuedPayrollPeriod(body: ProcessPayrollPeriodAReq | undefined): Promise<MessageResponseDto>;
    /**
     * Emails the Default Owner a zip of a previously processed payroll period (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    emailPayrollInvoiceZip(body: ProcessPayrollPeriodAReq | undefined): Promise<MessageResponseDto>;
    /**
     * Permanently deletes all data associated with the specified PayrollPeriod 
    including Payroll LineItems, Payroll Summary and Invoice Blobs (Auth roles: Admin)
     * @param companyId (optional) 
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    purge(companyId: number | undefined, payrollPeriodId: number | undefined): Promise<MessageResponseDto>;
}

export class PayrollAClient implements IPayrollAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets all queued PayrollPeriods for specified Company (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    getQueuedPayrollPeriods(companyId: number | undefined, cancelToken?: CancelToken): Promise<PayrollPeriodQueueRes[]> {
        let url_ = this.baseUrl + "/api/PayrollA/GetQueuedPayrollPeriods?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQueuedPayrollPeriods(_response);
        });
    }

    protected processGetQueuedPayrollPeriods(response: AxiosResponse): Promise<PayrollPeriodQueueRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodQueueRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodQueueRes[]>(null as any);
    }

    /**
     * Gets all queued PayrollPeriods for all Companies (Auth roles: Admin)
     * @return OK
     */
    getQueuedPayrollPeriodsAll( cancelToken?: CancelToken): Promise<PayrollPeriodQueueRes[]> {
        let url_ = this.baseUrl + "/api/PayrollA/GetQueuedPayrollPeriodsAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQueuedPayrollPeriodsAll(_response);
        });
    }

    protected processGetQueuedPayrollPeriodsAll(response: AxiosResponse): Promise<PayrollPeriodQueueRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollPeriodQueueRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollPeriodQueueRes[]>(null as any);
    }

    /**
     * Gets PayrollSummaries aggregated by user over the specified period of time for the specified company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    payrollSummaryReport(body: PayrollSummaryReportReq | undefined, cancelToken?: CancelToken): Promise<PayrollSummaryReportRes[]> {
        let url_ = this.baseUrl + "/api/PayrollA/PayrollSummaryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayrollSummaryReport(_response);
        });
    }

    protected processPayrollSummaryReport(response: AxiosResponse): Promise<PayrollSummaryReportRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayrollSummaryReportRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayrollSummaryReportRes[]>(null as any);
    }

    /**
     * Processes the specified PayPeriod (previosuly enqueued). (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    dequeuedPayrollPeriod(body: DequeuePayrollPeriodAReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/PayrollA/DequeuedPayrollPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDequeuedPayrollPeriod(_response);
        });
    }

    protected processDequeuedPayrollPeriod(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Processes the specified PayPeriod (previosuly enqueued). (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    processQueuedPayrollPeriod(body: ProcessPayrollPeriodAReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/PayrollA/ProcessQueuedPayrollPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessQueuedPayrollPeriod(_response);
        });
    }

    protected processProcessQueuedPayrollPeriod(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Emails the Default Owner a zip of a previously processed payroll period (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    emailPayrollInvoiceZip(body: ProcessPayrollPeriodAReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/PayrollA/EmailPayrollInvoiceZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailPayrollInvoiceZip(_response);
        });
    }

    protected processEmailPayrollInvoiceZip(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Permanently deletes all data associated with the specified PayrollPeriod 
    including Payroll LineItems, Payroll Summary and Invoice Blobs (Auth roles: Admin)
     * @param companyId (optional) 
     * @param payrollPeriodId (optional) 
     * @return OK
     */
    purge(companyId: number | undefined, payrollPeriodId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/PayrollA/Purge?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (payrollPeriodId === null)
            throw new Error("The parameter 'payrollPeriodId' cannot be null.");
        else if (payrollPeriodId !== undefined)
            url_ += "payrollPeriodId=" + encodeURIComponent("" + payrollPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurge(_response);
        });
    }

    protected processPurge(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface IPreCheckQuestionsClient {
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<PreCheckQuestionRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined): Promise<PreCheckQuestionResPage>;
    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: PreCheckQuestionReq | undefined): Promise<PreCheckQuestionRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: PreCheckQuestionReq | undefined): Promise<PreCheckQuestionRes>;
    /**
     * Allows to soft-delete a PreCheckQuestion (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    softDelete(id: number | undefined): Promise<void>;
}

export class PreCheckQuestionsClient implements IPreCheckQuestionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<PreCheckQuestionRes> {
        let url_ = this.baseUrl + "/api/PreCheckQuestions/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PreCheckQuestionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PreCheckQuestionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreCheckQuestionRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<PreCheckQuestionResPage> {
        let url_ = this.baseUrl + "/api/PreCheckQuestions/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<PreCheckQuestionResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PreCheckQuestionResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreCheckQuestionResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: PreCheckQuestionReq | undefined, cancelToken?: CancelToken): Promise<PreCheckQuestionRes> {
        let url_ = this.baseUrl + "/api/PreCheckQuestions/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PreCheckQuestionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PreCheckQuestionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreCheckQuestionRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: PreCheckQuestionReq | undefined, cancelToken?: CancelToken): Promise<PreCheckQuestionRes> {
        let url_ = this.baseUrl + "/api/PreCheckQuestions/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<PreCheckQuestionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PreCheckQuestionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreCheckQuestionRes>(null as any);
    }

    /**
     * Allows to soft-delete a PreCheckQuestion (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    softDelete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PreCheckQuestions/SoftDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSoftDelete(_response);
        });
    }

    protected processSoftDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPredefinedShiftCommentClient {
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<PredefinedShiftCommentRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined): Promise<PredefinedShiftCommentResPage>;
    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: PredefinedShiftCommentReq | undefined): Promise<PredefinedShiftCommentRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: PredefinedShiftCommentReq | undefined): Promise<PredefinedShiftCommentRes>;
    /**
     * Allows to soft-delete a PredefinedShiftComment (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Promise<void>;
}

export class PredefinedShiftCommentClient implements IPredefinedShiftCommentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<PredefinedShiftCommentRes> {
        let url_ = this.baseUrl + "/api/PredefinedShiftComment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PredefinedShiftCommentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PredefinedShiftCommentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PredefinedShiftCommentRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<PredefinedShiftCommentResPage> {
        let url_ = this.baseUrl + "/api/PredefinedShiftComment/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<PredefinedShiftCommentResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PredefinedShiftCommentResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PredefinedShiftCommentResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: PredefinedShiftCommentReq | undefined, cancelToken?: CancelToken): Promise<PredefinedShiftCommentRes> {
        let url_ = this.baseUrl + "/api/PredefinedShiftComment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PredefinedShiftCommentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PredefinedShiftCommentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PredefinedShiftCommentRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: PredefinedShiftCommentReq | undefined, cancelToken?: CancelToken): Promise<PredefinedShiftCommentRes> {
        let url_ = this.baseUrl + "/api/PredefinedShiftComment/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<PredefinedShiftCommentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PredefinedShiftCommentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PredefinedShiftCommentRes>(null as any);
    }

    /**
     * Allows to soft-delete a PredefinedShiftComment (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PredefinedShiftComment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPublicHolidaysClient {
    /**
     * Returns all the PublicHolidays (Auth roles: Owner,Accountant)
     * @return OK
     */
    all(): Promise<PublicHolidayRes[]>;
    /**
     * Gets existing Public Holidays for a state (Auth roles: Owner,Accountant)
     * @param stateId (optional) 
     * @return OK
     */
    get(stateId: number | undefined): Promise<PublicHolidayRes[]>;
}

export class PublicHolidaysClient implements IPublicHolidaysClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns all the PublicHolidays (Auth roles: Owner,Accountant)
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<PublicHolidayRes[]> {
        let url_ = this.baseUrl + "/api/PublicHolidays/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<PublicHolidayRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PublicHolidayRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayRes[]>(null as any);
    }

    /**
     * Gets existing Public Holidays for a state (Auth roles: Owner,Accountant)
     * @param stateId (optional) 
     * @return OK
     */
    get(stateId: number | undefined, cancelToken?: CancelToken): Promise<PublicHolidayRes[]> {
        let url_ = this.baseUrl + "/api/PublicHolidays/Get?";
        if (stateId === null)
            throw new Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PublicHolidayRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PublicHolidayRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayRes[]>(null as any);
    }
}

export interface IPublicHolidaysAClient {
    /**
     * Returns all the PublicHolidays (Auth roles: Admin)
     * @return OK
     */
    all(): Promise<PublicHolidayRes[]>;
    /**
     * Gets existing Public Holidays for a state (Auth roles: Admin)
     * @param stateId (optional) 
     * @return OK
     */
    get(stateId: number | undefined): Promise<PublicHolidayRes[]>;
    /**
     * Allows to create new Public Holiday (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: PublicHolidayReq | undefined): Promise<PublicHolidayRes>;
    /**
     * Updates existing Public Holiday (Auth roles: Admin)
     * @param id (optional) Holiday Id
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: PublicHolidayReq | undefined): Promise<PublicHolidayRes>;
    /**
     * Delete existing Public Holiday
    Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) Holiday Id
     * @param stateId (optional) 
     * @return OK
     */
    delete(id: number | undefined, stateId: number | undefined): Promise<MessageResponseDto>;
}

export class PublicHolidaysAClient implements IPublicHolidaysAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns all the PublicHolidays (Auth roles: Admin)
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<PublicHolidayRes[]> {
        let url_ = this.baseUrl + "/api/PublicHolidaysA/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<PublicHolidayRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PublicHolidayRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayRes[]>(null as any);
    }

    /**
     * Gets existing Public Holidays for a state (Auth roles: Admin)
     * @param stateId (optional) 
     * @return OK
     */
    get(stateId: number | undefined, cancelToken?: CancelToken): Promise<PublicHolidayRes[]> {
        let url_ = this.baseUrl + "/api/PublicHolidaysA/Get?";
        if (stateId === null)
            throw new Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PublicHolidayRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PublicHolidayRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayRes[]>(null as any);
    }

    /**
     * Allows to create new Public Holiday (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: PublicHolidayReq | undefined, cancelToken?: CancelToken): Promise<PublicHolidayRes> {
        let url_ = this.baseUrl + "/api/PublicHolidaysA/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PublicHolidayRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PublicHolidayRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayRes>(null as any);
    }

    /**
     * Updates existing Public Holiday (Auth roles: Admin)
     * @param id (optional) Holiday Id
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: PublicHolidayReq | undefined, cancelToken?: CancelToken): Promise<PublicHolidayRes> {
        let url_ = this.baseUrl + "/api/PublicHolidaysA/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<PublicHolidayRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PublicHolidayRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayRes>(null as any);
    }

    /**
     * Delete existing Public Holiday
    Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) Holiday Id
     * @param stateId (optional) 
     * @return OK
     */
    delete(id: number | undefined, stateId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/PublicHolidaysA/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (stateId === null)
            throw new Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface IPushNotificationsClient {
    /**
     * Returns OneSignal AppId (Auth)
     * @return OK
     */
    getAppId(): Promise<string>;
    /**
     * Register to receive push notifications. Can call this multiple times. (Auth)
     * @param body (optional) 
     * @return OK
     */
    register(body: OneSignalRegisterReq | undefined): Promise<string>;
    /**
     * Deletes the registration Id and hence unregisters from receiving push notifications (Auth)
     * @param registrationId (optional) Id returned during Registration
     * @return OK
     */
    unRegister(registrationId: string | undefined): Promise<void>;
}

export class PushNotificationsClient implements IPushNotificationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns OneSignal AppId (Auth)
     * @return OK
     */
    getAppId( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/PushNotifications/GetAppId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppId(_response);
        });
    }

    protected processGetAppId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Register to receive push notifications. Can call this multiple times. (Auth)
     * @param body (optional) 
     * @return OK
     */
    register(body: OneSignalRegisterReq | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/PushNotifications/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the registration Id and hence unregisters from receiving push notifications (Auth)
     * @param registrationId (optional) Id returned during Registration
     * @return OK
     */
    unRegister(registrationId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PushNotifications/UnRegister?";
        if (registrationId === null)
            throw new Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnRegister(_response);
        });
    }

    protected processUnRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRegularExpressionsClient {
    /**
     * Returns all the RegularExpressions avaible for this company and system (Auth roles: Owner,Manager,Driver,Accountant)
     * @return OK
     */
    all(): Promise<RegularExpressionRes[]>;
}

export class RegularExpressionsClient implements IRegularExpressionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns all the RegularExpressions avaible for this company and system (Auth roles: Owner,Manager,Driver,Accountant)
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<RegularExpressionRes[]> {
        let url_ = this.baseUrl + "/api/RegularExpressions/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<RegularExpressionRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RegularExpressionRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegularExpressionRes[]>(null as any);
    }
}

export interface IRegularExpressionsAClient {
    /**
     * Returns all the RegularExpressions (Auth roles: Admin)
     * @return OK
     */
    all(): Promise<RegularExpressionRes[]>;
    /**
     * Allows to create new RegularExpression (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    create(companyId: number | undefined, body: RegularExpressionAReq | undefined): Promise<RegularExpressionRes>;
    /**
     * Updates existing RegularExpression (Auth roles: Admin)
     * @param id (optional) RegularExpression Id
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: RegularExpressionAReq | undefined): Promise<RegularExpressionRes>;
    /**
     * Delete existing RegularExpression
    Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) RegularExpression Id
     * @return OK
     */
    delete(id: number | undefined): Promise<MessageResponseDto>;
}

export class RegularExpressionsAClient implements IRegularExpressionsAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns all the RegularExpressions (Auth roles: Admin)
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<RegularExpressionRes[]> {
        let url_ = this.baseUrl + "/api/RegularExpressionsA/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<RegularExpressionRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RegularExpressionRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegularExpressionRes[]>(null as any);
    }

    /**
     * Allows to create new RegularExpression (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    create(companyId: number | undefined, body: RegularExpressionAReq | undefined, cancelToken?: CancelToken): Promise<RegularExpressionRes> {
        let url_ = this.baseUrl + "/api/RegularExpressionsA/Create?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RegularExpressionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RegularExpressionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegularExpressionRes>(null as any);
    }

    /**
     * Updates existing RegularExpression (Auth roles: Admin)
     * @param id (optional) RegularExpression Id
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: RegularExpressionAReq | undefined, cancelToken?: CancelToken): Promise<RegularExpressionRes> {
        let url_ = this.baseUrl + "/api/RegularExpressionsA/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RegularExpressionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RegularExpressionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegularExpressionRes>(null as any);
    }

    /**
     * Delete existing RegularExpression
    Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) RegularExpression Id
     * @return OK
     */
    delete(id: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/RegularExpressionsA/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface IReleasesAClient {
    /**
     * Sends a Release email to all valid users in the system. (Auth roles: Admin)
     * @param body (optional) The period between which the release would be made and the website will be unavailable
     * @return OK
     */
    sendReleaseEmail(body: DateTimeIntervalUtc | undefined): Promise<void>;
}

export class ReleasesAClient implements IReleasesAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Sends a Release email to all valid users in the system. (Auth roles: Admin)
     * @param body (optional) The period between which the release would be made and the website will be unavailable
     * @return OK
     */
    sendReleaseEmail(body: DateTimeIntervalUtc | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ReleasesA/SendReleaseEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendReleaseEmail(_response);
        });
    }

    protected processSendReleaseEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IShiftNRClient {
    /**
     * (Auth roles: Owner,Manager, Owner,Manager,Accountant)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<ShiftNRRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager, Owner,Manager,Accountant)
     * @param body (optional) 
     * @return OK
     */
    page(body: ShiftNRPagedReq | undefined): Promise<ShiftNRResPage>;
    /**
     * Overwrites a Remark associated with ShiftNR (Auth roles: Owner,Manager, Owner,Manager,Accountant)
     * @param body (optional) 
     * @return OK
     */
    updateRemark(body: ShiftNRRemarkReq | undefined): Promise<ShiftNRRes>;
    /**
     * Updates all computed properties for the specifed ShiftNRs
    Compute breaches, sets certain properties in Shift and Shift NR (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    recomputeProperties(body: ShiftNRRecomputePropertiesReq | undefined): Promise<ShiftNRRes[]>;
    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    warnDriver(body: ShiftNRWarningReq | undefined): Promise<ShiftNRWarningRes>;
    /**
     * (Auth roles: Driver, Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    acknowledgeWarning(body: AcknowledgeShiftNRWarningReq | undefined): Promise<ShiftNRWarningRes>;
    /**
     * Allows to delete ShiftNRs.
    Note: Warn the user that this is a permanent operation. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    delete(body: number[] | undefined): Promise<void>;
    /**
     * Allows to download the Timsheets as an Excel file (.xlsx)
    Note: SwaggerRespose with correct content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth roles: Owner,Manager, Owner,Manager,Accountant)
     * @param body (optional) 
     * @return OK
     */
    download(body: ShiftNRDownloadReq | undefined): Promise<FileResponse>;
}

export class ShiftNRClient implements IShiftNRClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager, Owner,Manager,Accountant)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<ShiftNRRes> {
        let url_ = this.baseUrl + "/api/ShiftNR/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ShiftNRRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager, Owner,Manager,Accountant)
     * @param body (optional) 
     * @return OK
     */
    page(body: ShiftNRPagedReq | undefined, cancelToken?: CancelToken): Promise<ShiftNRResPage> {
        let url_ = this.baseUrl + "/api/ShiftNR/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ShiftNRResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRResPage>(null as any);
    }

    /**
     * Overwrites a Remark associated with ShiftNR (Auth roles: Owner,Manager, Owner,Manager,Accountant)
     * @param body (optional) 
     * @return OK
     */
    updateRemark(body: ShiftNRRemarkReq | undefined, cancelToken?: CancelToken): Promise<ShiftNRRes> {
        let url_ = this.baseUrl + "/api/ShiftNR/UpdateRemark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRemark(_response);
        });
    }

    protected processUpdateRemark(response: AxiosResponse): Promise<ShiftNRRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRRes>(null as any);
    }

    /**
     * Updates all computed properties for the specifed ShiftNRs
    Compute breaches, sets certain properties in Shift and Shift NR (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    recomputeProperties(body: ShiftNRRecomputePropertiesReq | undefined, cancelToken?: CancelToken): Promise<ShiftNRRes[]> {
        let url_ = this.baseUrl + "/api/ShiftNR/RecomputeProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecomputeProperties(_response);
        });
    }

    protected processRecomputeProperties(response: AxiosResponse): Promise<ShiftNRRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRRes[]>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    warnDriver(body: ShiftNRWarningReq | undefined, cancelToken?: CancelToken): Promise<ShiftNRWarningRes> {
        let url_ = this.baseUrl + "/api/ShiftNR/WarnDriver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWarnDriver(_response);
        });
    }

    protected processWarnDriver(response: AxiosResponse): Promise<ShiftNRWarningRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRWarningRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRWarningRes>(null as any);
    }

    /**
     * (Auth roles: Driver, Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    acknowledgeWarning(body: AcknowledgeShiftNRWarningReq | undefined, cancelToken?: CancelToken): Promise<ShiftNRWarningRes> {
        let url_ = this.baseUrl + "/api/ShiftNR/AcknowledgeWarning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcknowledgeWarning(_response);
        });
    }

    protected processAcknowledgeWarning(response: AxiosResponse): Promise<ShiftNRWarningRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRWarningRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRWarningRes>(null as any);
    }

    /**
     * Allows to delete ShiftNRs.
    Note: Warn the user that this is a permanent operation. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    delete(body: number[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ShiftNR/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Allows to download the Timsheets as an Excel file (.xlsx)
    Note: SwaggerRespose with correct content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth roles: Owner,Manager, Owner,Manager,Accountant)
     * @param body (optional) 
     * @return OK
     */
    download(body: ShiftNRDownloadReq | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ShiftNR/Download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IShiftNRAClient {
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    get(id: number | undefined, companyId: number | undefined): Promise<ShiftNRRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: ShiftNRAPagedReq | undefined): Promise<ShiftNRResPage>;
    /**
     * Bulk Create (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createBulk(companyId: number | undefined, body: ShiftNRReq[] | undefined): Promise<MessageResponseDto>;
    /**
     * Create using HTML Email (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    createFromEmail(body: ShiftNREmailReq | undefined): Promise<ShiftNRRes>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, companyId: number | undefined, body: ShiftNRReq | undefined): Promise<ShiftNRRes>;
    /**
     * Allows to delete a ShiftNR (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    delete(id: number | undefined, companyId: number | undefined): Promise<void>;
}

export class ShiftNRAClient implements IShiftNRAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    get(id: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<ShiftNRRes> {
        let url_ = this.baseUrl + "/api/ShiftNRA/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ShiftNRRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: ShiftNRAPagedReq | undefined, cancelToken?: CancelToken): Promise<ShiftNRResPage> {
        let url_ = this.baseUrl + "/api/ShiftNRA/Page?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ShiftNRResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRResPage>(null as any);
    }

    /**
     * Bulk Create (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createBulk(companyId: number | undefined, body: ShiftNRReq[] | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/ShiftNRA/CreateBulk?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulk(_response);
        });
    }

    protected processCreateBulk(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Create using HTML Email (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    createFromEmail(body: ShiftNREmailReq | undefined, cancelToken?: CancelToken): Promise<ShiftNRRes> {
        let url_ = this.baseUrl + "/api/ShiftNRA/CreateFromEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFromEmail(_response);
        });
    }

    protected processCreateFromEmail(response: AxiosResponse): Promise<ShiftNRRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, companyId: number | undefined, body: ShiftNRReq | undefined, cancelToken?: CancelToken): Promise<ShiftNRRes> {
        let url_ = this.baseUrl + "/api/ShiftNRA/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ShiftNRRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftNRRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftNRRes>(null as any);
    }

    /**
     * Allows to delete a ShiftNR (Auth roles: Admin)
     * @param id (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    delete(id: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ShiftNRA/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IShiftsClient {
    /**
     * Get Shift with all teh details including ShiftBreaks
    Driver can get only their Shifts (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<ShiftRes>;
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    getBulk(body: number[] | undefined): Promise<ShiftRes[]>;
    /**
     * Pagination in descending order of creation with DateTime filter
    Driver can get Shifts created by him alone (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page2(body: ShiftPagedReq | undefined): Promise<ShiftPageResPage>;
    /**
     * Downloads Excel containing Shifts between specified interval
    Note: Supports maximum of 1000 shifts (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    download(body: DateTimeInterval8Days | undefined): Promise<string>;
    /**
     * Gets lastest Ongoing or Completed Shift for the Driver (Auth roles: Driver)
     * @return OK
     */
    latest(): Promise<ShiftRes>;
    /**
     * Gets a formatted shift comment for filling in the Jotform (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    getCommentForJotformSubmission(id: number | undefined): Promise<string>;
    /**
     * Creates scheduled Shifts in bulk (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    scheduleBulk(body: ScheduleBulkReq | undefined): Promise<ShiftRes[]>;
    /**
     * Notifies (push notification) the driver of the specifed ongoing Shift that the vehicle is due to be returned at the vehicle due time. (Auth roles: Owner,Manager)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @return OK
     */
    notifyVehicleDueTime(companyId: number | undefined, shiftId: number | undefined): Promise<void>;
    /**
     * Allows to download the Shift Upload file template as an excel file (.xlsx)
    Note: SwaggerRespose with correct content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth)
     * @return OK
     */
    downloadShiftUploadFile(): Promise<FileResponse>;
    /**
     * Allows to upload scheduled shifts using and excel file (Auth roles: Owner,Manager)
     * @param excelFile (optional) Max 40 MB file size
     * @param startDateUtc (optional) The Date for which this schdeule is for (starts on)
     * @param endDateUtc (optional) The Date for which this schedule ends on
     * @param notifyAssignedDrivers (optional) if true then all assigned Drivers will be notified that they have been assigned a new shift
     * @param validatePotentialBreaches (optional) When true, ShiftNr from previous day will be used to check for potential breanches before creating new shifts
     * @return OK
     */
    uploadSchedule(excelFile: FileParameter | undefined, startDateUtc: string | undefined, endDateUtc: string | undefined, notifyAssignedDrivers: boolean | undefined, validatePotentialBreaches: boolean | undefined): Promise<MessageResponseDto>;
    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    importFromGoogleSheet(body: ImportShiftFromGoogleSheetReq | undefined): Promise<MessageResponseDto>;
    /**
     * Returns shifts imported from GoogleSheet. This will not create/dispatch(notify drivers) the shifts. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    importFromGoogleSheetToUi(body: ImportShiftFromGoogleSheetToUiReq | undefined): Promise<ImportShiftFromGoogleSheetToUiShiftRes[]>;
    /**
     * Updates an existing Shift. Does not notify driver of the changes. (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(shiftId: number | undefined, body: ScheduledShiftReq | undefined): Promise<ShiftRes>;
    /**
     * Allows Driver to update only certain fields in the Shift assigned to him.
    This can be done as long as the Shift has no Timesheets associated, irrespective of the Shift status. (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateForDriver(shiftId: number | undefined, body: UpdateScheduledShiftForDriver | undefined): Promise<ShiftRes>;
    /**
     * Deletes specified shifts including any breaks, comments, precheck answers, checkins etc.
    Ongoing, Completed Shifts cannot be deleted. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    delete(body: number[] | undefined): Promise<MessageResponseDto>;
    /**
     * Notifies the Driver that he has been assigned the Shift (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @return OK
     */
    notify(shiftId: number | undefined): Promise<MessageResponseDto>;
    /**
     * Notifies the Driver that he has been assigned the Shift using push notification (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @return OK
     */
    pushNotify(shiftId: number | undefined): Promise<MessageResponseDto>;
    /**
     * Allows Manager/Owner to notify the Driver to request an estimate of when the vehicle will be returned. (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @return OK
     */
    pushNotifyEstimatedVehicleReturn(shiftId: number | undefined): Promise<MessageResponseDto>;
    /**
     * Allows Driver to provide an estimate of when the vehicle will be returned. (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param minutesFromNow (optional) The number of minutes from now when the vehicle will be returned
     * @return OK
     */
    estimatedVehicleReturn(shiftId: number | undefined, minutesFromNow: number | undefined): Promise<ShiftRes>;
    /**
     * Allows User to accept a shift assinged to him.
    Applicable to Linfox, NonLinfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @return OK
     */
    accept(shiftId: number | undefined): Promise<ShiftRes>;
    /**
     * (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param answer (optional) 
     * @param photo (optional) 
     * @param geoLocation_Latitude (optional) 
     * @param geoLocation_Longitude (optional) 
     * @param requiresPhoto (optional) Indicates that a Photo must be supplied with the answer
     * @param preCheckQuestionId (optional) 
     * @return OK
     */
    shiftPreStartPrecheckAnswerLinfox(shiftId: number | undefined, answer: boolean | undefined, photo: FileParameter | undefined, geoLocation_Latitude: number | undefined, geoLocation_Longitude: number | undefined, requiresPhoto: boolean | undefined, preCheckQuestionId: number | undefined): Promise<ShiftRes>;
    /**
     * Allows to perform a 30 Mintue Checkin before ShiftStart with optional photo
    AKA WooliesGo Checkin
    Applicable to Linfox, NonLinfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param photo (optional) Max 2 MB file size
    Only png/jpeg files supported
     * @param geoLocation_Latitude (optional) 
     * @param geoLocation_Longitude (optional) 
     * @return OK
     */
    shiftPreStart30MinuteCheckin2(shiftId: number | undefined, photo: FileParameter | undefined, geoLocation_Latitude: number | undefined, geoLocation_Longitude: number | undefined): Promise<ShiftRes>;
    /**
     * Applicable to Linfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @return OK
     */
    shiftStartLinfox(shiftId: number | undefined): Promise<ShiftRes>;
    /**
     * Allows to quickly End a Shift, by asking for all required fields in one go.
    This is a temporary intermediate alternative to the regular StartShift, StopShift, StartBreak, StopBreak, CreateComment API calls.
    Drivers will do this at the end of the day when they are back home, hence no Precheck Questions, no Checkins requried.
    This will allows them to submit jotform with minimal efforts since most of data will be prefilled.
    Applicable to Linfox (Auth roles: Driver,Manager)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    quickStopLinfox(shiftId: number | undefined, body: QuickShiftReq | undefined): Promise<ShiftRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @return OK
     */
    quickStopLinfoxSmsOnly(shiftId: number | undefined): Promise<ShiftRes>;
    /**
     * Starts a new Shift
    Applicable to NonLinfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    startScheduledNonLinfox(shiftId: number | undefined, body: StartScheduledShiftReq | undefined): Promise<ShiftRes>;
    /**
     * Stops an ongoing Shift 
    Applicable to NonLinfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    stopNonLinfox(shiftId: number | undefined, body: StopShiftReq | undefined): Promise<ShiftRes>;
    /**
     * Clears Jotform from a completed/stopped Shift indicating that the driver has filled in the jotform.
    Applicable to Linfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @return OK
     */
    jotformSubmitted(shiftId: number | undefined): Promise<ShiftRes>;
    /**
     * Updates Shift with Jotform submission id after the driver has filled in the jotform. (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param jotformSubmissionId (optional) 
     * @return OK
     */
    jotformSubmissionId(shiftId: number | undefined, jotformSubmissionId: string | undefined): Promise<ShiftRes>;
    /**
     * Starts a break in an ongoing Shift (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    startBreak(body: StartShiftBreakReq | undefined): Promise<ShiftBreakRes>;
    /**
     * Stop an ongoing break in an ongoing Shift (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    stopBreak(body: StopShiftBreakReq | undefined): Promise<ShiftBreakRes>;
    /**
     * Creates a new break (with start and end time both needed) in an ongoing Shift (Auth roles: Driver,Manager)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    quickBreak(shiftId: number | undefined, body: QuickShiftBreakReq | undefined): Promise<ShiftBreakRes>;
    /**
     * Allows to delete breaks form an Ongoing Shift (Auth roles: Driver,Manager)
     * @param shiftId (optional) 
     * @param breakId (optional) 
     * @return OK
     */
    deleteBreak(shiftId: number | undefined, breakId: number | undefined): Promise<void>;
    /**
     * Gets breaches for the Company between the specified DateTime interval (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    breaches(body: DateTimeInterval15Days | undefined): Promise<ShiftBreachBlob[]>;
    /**
     * Adds new ShiftComment 
    Driver can only add comment for an Ongoing Shift (Auth roles: Driver,Manager,Owner)
     * @param body (optional) 
     * @return OK
     */
    shiftComment(body: ShiftCommentReq | undefined): Promise<ShiftCommentRes>;
    /**
     * Allows Driver to Checkin during an Ongoing Shift (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    ongoingShiftCheckin(body: ShiftCheckinReq | undefined): Promise<CheckinRes>;
    /**
     * (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param shiftMediaType (optional) 
     * @param mediaFile_Description (optional) 
     * @param mediaFile_File (optional) 
     * @return OK
     */
    uploadShiftPhoto(shiftId: number | undefined, shiftMediaType: ShiftMediaType | undefined, mediaFile_Description: string | undefined, mediaFile_File: FileParameter | undefined): Promise<ShiftMediaFileRes>;
    /**
     * (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    deleteShiftPhoto(body: DeleteShiftMediaReq | undefined): Promise<MessageResponseDto>;
    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    warnDriver(body: ShiftWarningReq | undefined): Promise<ShiftWarningRes>;
    /**
     * (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    acknowledgeWarning(body: AcknowledgeShiftWarningReq | undefined): Promise<ShiftWarningRes>;
    /**
     * Associates a ShiftFleetIoFormSubmission to a Shift. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    associateShiftFleetIoFormSubmission(body: ShiftFleetIoFormSubmissionReq | undefined): Promise<ShiftFleetIoFormSubmissionRes>;
    /**
     * Dissociates a ShiftFleetIoFormSubmission from a Shift.
    Note: This deletes submission from DB. (Auth roles: Owner,Manager)
     * @param shiftFleetIoFormSubmissionId (optional) 
     * @return OK
     */
    dissociateShiftFleetIoFormSubmission(shiftFleetIoFormSubmissionId: number | undefined): Promise<void>;
}

export class ShiftsClient implements IShiftsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get Shift with all teh details including ShiftBreaks
    Driver can get only their Shifts (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    getBulk(body: number[] | undefined, cancelToken?: CancelToken): Promise<ShiftRes[]> {
        let url_ = this.baseUrl + "/api/Shifts/GetBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulk(_response);
        });
    }

    protected processGetBulk(response: AxiosResponse): Promise<ShiftRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes[]>(null as any);
    }

    /**
     * Pagination in descending order of creation with DateTime filter
    Driver can get Shifts created by him alone (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page2(body: ShiftPagedReq | undefined, cancelToken?: CancelToken): Promise<ShiftPageResPage> {
        let url_ = this.baseUrl + "/api/Shifts/Page2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage2(_response);
        });
    }

    protected processPage2(response: AxiosResponse): Promise<ShiftPageResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftPageResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftPageResPage>(null as any);
    }

    /**
     * Downloads Excel containing Shifts between specified interval
    Note: Supports maximum of 1000 shifts (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    download(body: DateTimeInterval8Days | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Shifts/Download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets lastest Ongoing or Completed Shift for the Driver (Auth roles: Driver)
     * @return OK
     */
    latest( cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/Latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLatest(_response);
        });
    }

    protected processLatest(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Gets a formatted shift comment for filling in the Jotform (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    getCommentForJotformSubmission(id: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Shifts/GetCommentForJotformSubmission?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommentForJotformSubmission(_response);
        });
    }

    protected processGetCommentForJotformSubmission(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Creates scheduled Shifts in bulk (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    scheduleBulk(body: ScheduleBulkReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes[]> {
        let url_ = this.baseUrl + "/api/Shifts/ScheduleBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScheduleBulk(_response);
        });
    }

    protected processScheduleBulk(response: AxiosResponse): Promise<ShiftRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes[]>(null as any);
    }

    /**
     * Notifies (push notification) the driver of the specifed ongoing Shift that the vehicle is due to be returned at the vehicle due time. (Auth roles: Owner,Manager)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @return OK
     */
    notifyVehicleDueTime(companyId: number | undefined, shiftId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Shifts/NotifyVehicleDueTime?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotifyVehicleDueTime(_response);
        });
    }

    protected processNotifyVehicleDueTime(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Allows to download the Shift Upload file template as an excel file (.xlsx)
    Note: SwaggerRespose with correct content-type is required for nswag studio to genearte a functional the proxy API call to this file download API (Auth)
     * @return OK
     */
    downloadShiftUploadFile( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Shifts/DownloadShiftUploadFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadShiftUploadFile(_response);
        });
    }

    protected processDownloadShiftUploadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Allows to upload scheduled shifts using and excel file (Auth roles: Owner,Manager)
     * @param excelFile (optional) Max 40 MB file size
     * @param startDateUtc (optional) The Date for which this schdeule is for (starts on)
     * @param endDateUtc (optional) The Date for which this schedule ends on
     * @param notifyAssignedDrivers (optional) if true then all assigned Drivers will be notified that they have been assigned a new shift
     * @param validatePotentialBreaches (optional) When true, ShiftNr from previous day will be used to check for potential breanches before creating new shifts
     * @return OK
     */
    uploadSchedule(excelFile: FileParameter | undefined, startDateUtc: string | undefined, endDateUtc: string | undefined, notifyAssignedDrivers: boolean | undefined, validatePotentialBreaches: boolean | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Shifts/UploadSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("ExcelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "ExcelFile");
        if (startDateUtc === null || startDateUtc === undefined)
            throw new Error("The parameter 'startDateUtc' cannot be null.");
        else
            content_.append("StartDateUtc", startDateUtc.toString());
        if (endDateUtc === null || endDateUtc === undefined)
            throw new Error("The parameter 'endDateUtc' cannot be null.");
        else
            content_.append("EndDateUtc", endDateUtc.toString());
        if (notifyAssignedDrivers === null || notifyAssignedDrivers === undefined)
            throw new Error("The parameter 'notifyAssignedDrivers' cannot be null.");
        else
            content_.append("NotifyAssignedDrivers", notifyAssignedDrivers.toString());
        if (validatePotentialBreaches === null || validatePotentialBreaches === undefined)
            throw new Error("The parameter 'validatePotentialBreaches' cannot be null.");
        else
            content_.append("ValidatePotentialBreaches", validatePotentialBreaches.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadSchedule(_response);
        });
    }

    protected processUploadSchedule(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    importFromGoogleSheet(body: ImportShiftFromGoogleSheetReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Shifts/ImportFromGoogleSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportFromGoogleSheet(_response);
        });
    }

    protected processImportFromGoogleSheet(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Returns shifts imported from GoogleSheet. This will not create/dispatch(notify drivers) the shifts. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    importFromGoogleSheetToUi(body: ImportShiftFromGoogleSheetToUiReq | undefined, cancelToken?: CancelToken): Promise<ImportShiftFromGoogleSheetToUiShiftRes[]> {
        let url_ = this.baseUrl + "/api/Shifts/ImportFromGoogleSheetToUi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportFromGoogleSheetToUi(_response);
        });
    }

    protected processImportFromGoogleSheetToUi(response: AxiosResponse): Promise<ImportShiftFromGoogleSheetToUiShiftRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ImportShiftFromGoogleSheetToUiShiftRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportShiftFromGoogleSheetToUiShiftRes[]>(null as any);
    }

    /**
     * Updates an existing Shift. Does not notify driver of the changes. (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(shiftId: number | undefined, body: ScheduledShiftReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/Update?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Allows Driver to update only certain fields in the Shift assigned to him.
    This can be done as long as the Shift has no Timesheets associated, irrespective of the Shift status. (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateForDriver(shiftId: number | undefined, body: UpdateScheduledShiftForDriver | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/UpdateForDriver?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateForDriver(_response);
        });
    }

    protected processUpdateForDriver(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Deletes specified shifts including any breaks, comments, precheck answers, checkins etc.
    Ongoing, Completed Shifts cannot be deleted. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    delete(body: number[] | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Shifts/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Notifies the Driver that he has been assigned the Shift (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @return OK
     */
    notify(shiftId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Shifts/Notify?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotify(_response);
        });
    }

    protected processNotify(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Notifies the Driver that he has been assigned the Shift using push notification (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @return OK
     */
    pushNotify(shiftId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Shifts/PushNotify?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushNotify(_response);
        });
    }

    protected processPushNotify(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Allows Manager/Owner to notify the Driver to request an estimate of when the vehicle will be returned. (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @return OK
     */
    pushNotifyEstimatedVehicleReturn(shiftId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Shifts/PushNotifyEstimatedVehicleReturn?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushNotifyEstimatedVehicleReturn(_response);
        });
    }

    protected processPushNotifyEstimatedVehicleReturn(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Allows Driver to provide an estimate of when the vehicle will be returned. (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param minutesFromNow (optional) The number of minutes from now when the vehicle will be returned
     * @return OK
     */
    estimatedVehicleReturn(shiftId: number | undefined, minutesFromNow: number | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/EstimatedVehicleReturn?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (minutesFromNow === null)
            throw new Error("The parameter 'minutesFromNow' cannot be null.");
        else if (minutesFromNow !== undefined)
            url_ += "minutesFromNow=" + encodeURIComponent("" + minutesFromNow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEstimatedVehicleReturn(_response);
        });
    }

    protected processEstimatedVehicleReturn(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Allows User to accept a shift assinged to him.
    Applicable to Linfox, NonLinfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @return OK
     */
    accept(shiftId: number | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/Accept?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param answer (optional) 
     * @param photo (optional) 
     * @param geoLocation_Latitude (optional) 
     * @param geoLocation_Longitude (optional) 
     * @param requiresPhoto (optional) Indicates that a Photo must be supplied with the answer
     * @param preCheckQuestionId (optional) 
     * @return OK
     */
    shiftPreStartPrecheckAnswerLinfox(shiftId: number | undefined, answer: boolean | undefined, photo: FileParameter | undefined, geoLocation_Latitude: number | undefined, geoLocation_Longitude: number | undefined, requiresPhoto: boolean | undefined, preCheckQuestionId: number | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/ShiftPreStartPrecheckAnswerLinfox?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (answer === null || answer === undefined)
            throw new Error("The parameter 'answer' cannot be null.");
        else
            content_.append("Answer", answer.toString());
        if (photo === null || photo === undefined)
            throw new Error("The parameter 'photo' cannot be null.");
        else
            content_.append("Photo", photo.data, photo.fileName ? photo.fileName : "Photo");
        if (geoLocation_Latitude === null || geoLocation_Latitude === undefined)
            throw new Error("The parameter 'geoLocation_Latitude' cannot be null.");
        else
            content_.append("GeoLocation.Latitude", geoLocation_Latitude.toString());
        if (geoLocation_Longitude === null || geoLocation_Longitude === undefined)
            throw new Error("The parameter 'geoLocation_Longitude' cannot be null.");
        else
            content_.append("GeoLocation.Longitude", geoLocation_Longitude.toString());
        if (requiresPhoto === null || requiresPhoto === undefined)
            throw new Error("The parameter 'requiresPhoto' cannot be null.");
        else
            content_.append("RequiresPhoto", requiresPhoto.toString());
        if (preCheckQuestionId === null || preCheckQuestionId === undefined)
            throw new Error("The parameter 'preCheckQuestionId' cannot be null.");
        else
            content_.append("PreCheckQuestionId", preCheckQuestionId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShiftPreStartPrecheckAnswerLinfox(_response);
        });
    }

    protected processShiftPreStartPrecheckAnswerLinfox(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Allows to perform a 30 Mintue Checkin before ShiftStart with optional photo
    AKA WooliesGo Checkin
    Applicable to Linfox, NonLinfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param photo (optional) Max 2 MB file size
    Only png/jpeg files supported
     * @param geoLocation_Latitude (optional) 
     * @param geoLocation_Longitude (optional) 
     * @return OK
     */
    shiftPreStart30MinuteCheckin2(shiftId: number | undefined, photo: FileParameter | undefined, geoLocation_Latitude: number | undefined, geoLocation_Longitude: number | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/ShiftPreStart30MinuteCheckin2?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (photo === null || photo === undefined)
            throw new Error("The parameter 'photo' cannot be null.");
        else
            content_.append("Photo", photo.data, photo.fileName ? photo.fileName : "Photo");
        if (geoLocation_Latitude === null || geoLocation_Latitude === undefined)
            throw new Error("The parameter 'geoLocation_Latitude' cannot be null.");
        else
            content_.append("GeoLocation.Latitude", geoLocation_Latitude.toString());
        if (geoLocation_Longitude === null || geoLocation_Longitude === undefined)
            throw new Error("The parameter 'geoLocation_Longitude' cannot be null.");
        else
            content_.append("GeoLocation.Longitude", geoLocation_Longitude.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShiftPreStart30MinuteCheckin2(_response);
        });
    }

    protected processShiftPreStart30MinuteCheckin2(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Applicable to Linfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @return OK
     */
    shiftStartLinfox(shiftId: number | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/ShiftStartLinfox?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShiftStartLinfox(_response);
        });
    }

    protected processShiftStartLinfox(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Allows to quickly End a Shift, by asking for all required fields in one go.
    This is a temporary intermediate alternative to the regular StartShift, StopShift, StartBreak, StopBreak, CreateComment API calls.
    Drivers will do this at the end of the day when they are back home, hence no Precheck Questions, no Checkins requried.
    This will allows them to submit jotform with minimal efforts since most of data will be prefilled.
    Applicable to Linfox (Auth roles: Driver,Manager)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    quickStopLinfox(shiftId: number | undefined, body: QuickShiftReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/QuickStopLinfox?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuickStopLinfox(_response);
        });
    }

    protected processQuickStopLinfox(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param shiftId (optional) 
     * @return OK
     */
    quickStopLinfoxSmsOnly(shiftId: number | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/QuickStopLinfoxSmsOnly?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuickStopLinfoxSmsOnly(_response);
        });
    }

    protected processQuickStopLinfoxSmsOnly(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Starts a new Shift
    Applicable to NonLinfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    startScheduledNonLinfox(shiftId: number | undefined, body: StartScheduledShiftReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/StartScheduledNonLinfox?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartScheduledNonLinfox(_response);
        });
    }

    protected processStartScheduledNonLinfox(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Stops an ongoing Shift 
    Applicable to NonLinfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    stopNonLinfox(shiftId: number | undefined, body: StopShiftReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/StopNonLinfox?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopNonLinfox(_response);
        });
    }

    protected processStopNonLinfox(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Clears Jotform from a completed/stopped Shift indicating that the driver has filled in the jotform.
    Applicable to Linfox (Auth roles: Driver)
     * @param shiftId (optional) 
     * @return OK
     */
    jotformSubmitted(shiftId: number | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/JotformSubmitted?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJotformSubmitted(_response);
        });
    }

    protected processJotformSubmitted(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Updates Shift with Jotform submission id after the driver has filled in the jotform. (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param jotformSubmissionId (optional) 
     * @return OK
     */
    jotformSubmissionId(shiftId: number | undefined, jotformSubmissionId: string | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/Shifts/JotformSubmissionId?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (jotformSubmissionId === null)
            throw new Error("The parameter 'jotformSubmissionId' cannot be null.");
        else if (jotformSubmissionId !== undefined)
            url_ += "jotformSubmissionId=" + encodeURIComponent("" + jotformSubmissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJotformSubmissionId(_response);
        });
    }

    protected processJotformSubmissionId(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Starts a break in an ongoing Shift (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    startBreak(body: StartShiftBreakReq | undefined, cancelToken?: CancelToken): Promise<ShiftBreakRes> {
        let url_ = this.baseUrl + "/api/Shifts/StartBreak";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartBreak(_response);
        });
    }

    protected processStartBreak(response: AxiosResponse): Promise<ShiftBreakRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftBreakRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftBreakRes>(null as any);
    }

    /**
     * Stop an ongoing break in an ongoing Shift (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    stopBreak(body: StopShiftBreakReq | undefined, cancelToken?: CancelToken): Promise<ShiftBreakRes> {
        let url_ = this.baseUrl + "/api/Shifts/StopBreak";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopBreak(_response);
        });
    }

    protected processStopBreak(response: AxiosResponse): Promise<ShiftBreakRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftBreakRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftBreakRes>(null as any);
    }

    /**
     * Creates a new break (with start and end time both needed) in an ongoing Shift (Auth roles: Driver,Manager)
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    quickBreak(shiftId: number | undefined, body: QuickShiftBreakReq | undefined, cancelToken?: CancelToken): Promise<ShiftBreakRes> {
        let url_ = this.baseUrl + "/api/Shifts/QuickBreak?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuickBreak(_response);
        });
    }

    protected processQuickBreak(response: AxiosResponse): Promise<ShiftBreakRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftBreakRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftBreakRes>(null as any);
    }

    /**
     * Allows to delete breaks form an Ongoing Shift (Auth roles: Driver,Manager)
     * @param shiftId (optional) 
     * @param breakId (optional) 
     * @return OK
     */
    deleteBreak(shiftId: number | undefined, breakId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Shifts/DeleteBreak?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (breakId === null)
            throw new Error("The parameter 'breakId' cannot be null.");
        else if (breakId !== undefined)
            url_ += "breakId=" + encodeURIComponent("" + breakId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBreak(_response);
        });
    }

    protected processDeleteBreak(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets breaches for the Company between the specified DateTime interval (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    breaches(body: DateTimeInterval15Days | undefined, cancelToken?: CancelToken): Promise<ShiftBreachBlob[]> {
        let url_ = this.baseUrl + "/api/Shifts/Breaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBreaches(_response);
        });
    }

    protected processBreaches(response: AxiosResponse): Promise<ShiftBreachBlob[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftBreachBlob[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftBreachBlob[]>(null as any);
    }

    /**
     * Adds new ShiftComment 
    Driver can only add comment for an Ongoing Shift (Auth roles: Driver,Manager,Owner)
     * @param body (optional) 
     * @return OK
     */
    shiftComment(body: ShiftCommentReq | undefined, cancelToken?: CancelToken): Promise<ShiftCommentRes> {
        let url_ = this.baseUrl + "/api/Shifts/ShiftComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShiftComment(_response);
        });
    }

    protected processShiftComment(response: AxiosResponse): Promise<ShiftCommentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftCommentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftCommentRes>(null as any);
    }

    /**
     * Allows Driver to Checkin during an Ongoing Shift (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    ongoingShiftCheckin(body: ShiftCheckinReq | undefined, cancelToken?: CancelToken): Promise<CheckinRes> {
        let url_ = this.baseUrl + "/api/Shifts/OngoingShiftCheckin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOngoingShiftCheckin(_response);
        });
    }

    protected processOngoingShiftCheckin(response: AxiosResponse): Promise<CheckinRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CheckinRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckinRes>(null as any);
    }

    /**
     * (Auth roles: Driver)
     * @param shiftId (optional) 
     * @param shiftMediaType (optional) 
     * @param mediaFile_Description (optional) 
     * @param mediaFile_File (optional) 
     * @return OK
     */
    uploadShiftPhoto(shiftId: number | undefined, shiftMediaType: ShiftMediaType | undefined, mediaFile_Description: string | undefined, mediaFile_File: FileParameter | undefined, cancelToken?: CancelToken): Promise<ShiftMediaFileRes> {
        let url_ = this.baseUrl + "/api/Shifts/UploadShiftPhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (shiftId === null || shiftId === undefined)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else
            content_.append("ShiftId", shiftId.toString());
        if (shiftMediaType === null || shiftMediaType === undefined)
            throw new Error("The parameter 'shiftMediaType' cannot be null.");
        else
            content_.append("ShiftMediaType", shiftMediaType.toString());
        if (mediaFile_Description === null || mediaFile_Description === undefined)
            throw new Error("The parameter 'mediaFile_Description' cannot be null.");
        else
            content_.append("MediaFile.Description", mediaFile_Description.toString());
        if (mediaFile_File === null || mediaFile_File === undefined)
            throw new Error("The parameter 'mediaFile_File' cannot be null.");
        else
            content_.append("MediaFile.File", mediaFile_File.data, mediaFile_File.fileName ? mediaFile_File.fileName : "MediaFile.File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadShiftPhoto(_response);
        });
    }

    protected processUploadShiftPhoto(response: AxiosResponse): Promise<ShiftMediaFileRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftMediaFileRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftMediaFileRes>(null as any);
    }

    /**
     * (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    deleteShiftPhoto(body: DeleteShiftMediaReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Shifts/DeleteShiftPhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteShiftPhoto(_response);
        });
    }

    protected processDeleteShiftPhoto(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    warnDriver(body: ShiftWarningReq | undefined, cancelToken?: CancelToken): Promise<ShiftWarningRes> {
        let url_ = this.baseUrl + "/api/Shifts/WarnDriver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWarnDriver(_response);
        });
    }

    protected processWarnDriver(response: AxiosResponse): Promise<ShiftWarningRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftWarningRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftWarningRes>(null as any);
    }

    /**
     * (Auth roles: Driver)
     * @param body (optional) 
     * @return OK
     */
    acknowledgeWarning(body: AcknowledgeShiftWarningReq | undefined, cancelToken?: CancelToken): Promise<ShiftWarningRes> {
        let url_ = this.baseUrl + "/api/Shifts/AcknowledgeWarning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcknowledgeWarning(_response);
        });
    }

    protected processAcknowledgeWarning(response: AxiosResponse): Promise<ShiftWarningRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftWarningRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftWarningRes>(null as any);
    }

    /**
     * Associates a ShiftFleetIoFormSubmission to a Shift. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    associateShiftFleetIoFormSubmission(body: ShiftFleetIoFormSubmissionReq | undefined, cancelToken?: CancelToken): Promise<ShiftFleetIoFormSubmissionRes> {
        let url_ = this.baseUrl + "/api/Shifts/AssociateShiftFleetIoFormSubmission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssociateShiftFleetIoFormSubmission(_response);
        });
    }

    protected processAssociateShiftFleetIoFormSubmission(response: AxiosResponse): Promise<ShiftFleetIoFormSubmissionRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftFleetIoFormSubmissionRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftFleetIoFormSubmissionRes>(null as any);
    }

    /**
     * Dissociates a ShiftFleetIoFormSubmission from a Shift.
    Note: This deletes submission from DB. (Auth roles: Owner,Manager)
     * @param shiftFleetIoFormSubmissionId (optional) 
     * @return OK
     */
    dissociateShiftFleetIoFormSubmission(shiftFleetIoFormSubmissionId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Shifts/DissociateShiftFleetIoFormSubmission?";
        if (shiftFleetIoFormSubmissionId === null)
            throw new Error("The parameter 'shiftFleetIoFormSubmissionId' cannot be null.");
        else if (shiftFleetIoFormSubmissionId !== undefined)
            url_ += "shiftFleetIoFormSubmissionId=" + encodeURIComponent("" + shiftFleetIoFormSubmissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDissociateShiftFleetIoFormSubmission(_response);
        });
    }

    protected processDissociateShiftFleetIoFormSubmission(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IShiftsAClient {
    /**
     * Updates OTDPercentage, LateArrivalMinutes etc into Shifts from OTD GoogleSheet for the specified Company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    otdMasterSyncOtdSheet(body: ShiftOtdSyncReq | undefined): Promise<ShiftRes[]>;
    /**
     * Updates Shift's VoiceOfCustomerComment from OTD Master GoogleSheet's VOC Comments worksheet for the specified Company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    otdMasterSyncShiftVocComments(body: ShiftOtdSyncReq | undefined): Promise<ShiftRes[]>;
    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    otdMasterEndShifts(body: ShiftOtdSyncReq | undefined): Promise<ShiftRes[]>;
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    otdUpdateShift(companyId: number | undefined, shiftId: number | undefined, body: ShiftOtdReq | undefined): Promise<ShiftRes>;
    /**
     * Associates the Jotform Submission Id with the specified Shift. (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param jotformSubmissionId (optional) 
     * @return OK
     */
    jotformSubmissionId(companyId: number | undefined, shiftId: number | undefined, jotformSubmissionId: string | undefined): Promise<ShiftRes>;
    /**
     * Updates bunch of Route Performance related cols in Shifts from the RoutePerformance GoogleSheet for the specified Company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    syncFromRoutePerformanceGoogleSheet(body: ShiftOtdSyncReq | undefined): Promise<ShiftRes[]>;
    /**
     * Computes and Notifies breaches for the specified Day and Company using past 7 days of Shifts. (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    computeAndNotifyBreaches(body: ShiftBreachReq | undefined): Promise<ShiftBreachBlob[]>;
    /**
     * Call every 30 minutes to notify Drivers of a potential breach.
    Only notifies for 5 hour driving without a break breach
    Checks for Ongoing shift for today only. (Auth roles: Admin)
     * @return OK
     */
    notifyRealTimeBreaches(): Promise<void>;
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: ShiftPagedReq | undefined): Promise<ShiftPageResPage>;
    /**
     * Permanently deletes specified Shift that is older than 14 days and not completed. (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @return OK
     */
    delete(companyId: number | undefined, shiftId: number | undefined): Promise<MessageResponseDto>;
}

export class ShiftsAClient implements IShiftsAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Updates OTDPercentage, LateArrivalMinutes etc into Shifts from OTD GoogleSheet for the specified Company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    otdMasterSyncOtdSheet(body: ShiftOtdSyncReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes[]> {
        let url_ = this.baseUrl + "/api/ShiftsA/OtdMasterSyncOtdSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtdMasterSyncOtdSheet(_response);
        });
    }

    protected processOtdMasterSyncOtdSheet(response: AxiosResponse): Promise<ShiftRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes[]>(null as any);
    }

    /**
     * Updates Shift's VoiceOfCustomerComment from OTD Master GoogleSheet's VOC Comments worksheet for the specified Company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    otdMasterSyncShiftVocComments(body: ShiftOtdSyncReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes[]> {
        let url_ = this.baseUrl + "/api/ShiftsA/OtdMasterSyncShiftVocComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtdMasterSyncShiftVocComments(_response);
        });
    }

    protected processOtdMasterSyncShiftVocComments(response: AxiosResponse): Promise<ShiftRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes[]>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    otdMasterEndShifts(body: ShiftOtdSyncReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes[]> {
        let url_ = this.baseUrl + "/api/ShiftsA/OtdMasterEndShifts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtdMasterEndShifts(_response);
        });
    }

    protected processOtdMasterEndShifts(response: AxiosResponse): Promise<ShiftRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes[]>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    otdUpdateShift(companyId: number | undefined, shiftId: number | undefined, body: ShiftOtdReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/ShiftsA/OtdUpdateShift?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtdUpdateShift(_response);
        });
    }

    protected processOtdUpdateShift(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Associates the Jotform Submission Id with the specified Shift. (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param jotformSubmissionId (optional) 
     * @return OK
     */
    jotformSubmissionId(companyId: number | undefined, shiftId: number | undefined, jotformSubmissionId: string | undefined, cancelToken?: CancelToken): Promise<ShiftRes> {
        let url_ = this.baseUrl + "/api/ShiftsA/JotformSubmissionId?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (jotformSubmissionId === null)
            throw new Error("The parameter 'jotformSubmissionId' cannot be null.");
        else if (jotformSubmissionId !== undefined)
            url_ += "jotformSubmissionId=" + encodeURIComponent("" + jotformSubmissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJotformSubmissionId(_response);
        });
    }

    protected processJotformSubmissionId(response: AxiosResponse): Promise<ShiftRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes>(null as any);
    }

    /**
     * Updates bunch of Route Performance related cols in Shifts from the RoutePerformance GoogleSheet for the specified Company (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    syncFromRoutePerformanceGoogleSheet(body: ShiftOtdSyncReq | undefined, cancelToken?: CancelToken): Promise<ShiftRes[]> {
        let url_ = this.baseUrl + "/api/ShiftsA/SyncFromRoutePerformanceGoogleSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncFromRoutePerformanceGoogleSheet(_response);
        });
    }

    protected processSyncFromRoutePerformanceGoogleSheet(response: AxiosResponse): Promise<ShiftRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftRes[]>(null as any);
    }

    /**
     * Computes and Notifies breaches for the specified Day and Company using past 7 days of Shifts. (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    computeAndNotifyBreaches(body: ShiftBreachReq | undefined, cancelToken?: CancelToken): Promise<ShiftBreachBlob[]> {
        let url_ = this.baseUrl + "/api/ShiftsA/ComputeAndNotifyBreaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComputeAndNotifyBreaches(_response);
        });
    }

    protected processComputeAndNotifyBreaches(response: AxiosResponse): Promise<ShiftBreachBlob[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftBreachBlob[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftBreachBlob[]>(null as any);
    }

    /**
     * Call every 30 minutes to notify Drivers of a potential breach.
    Only notifies for 5 hour driving without a break breach
    Checks for Ongoing shift for today only. (Auth roles: Admin)
     * @return OK
     */
    notifyRealTimeBreaches( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ShiftsA/NotifyRealTimeBreaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotifyRealTimeBreaches(_response);
        });
    }

    protected processNotifyRealTimeBreaches(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    page(companyId: number | undefined, body: ShiftPagedReq | undefined, cancelToken?: CancelToken): Promise<ShiftPageResPage> {
        let url_ = this.baseUrl + "/api/ShiftsA/Page?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ShiftPageResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftPageResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftPageResPage>(null as any);
    }

    /**
     * Permanently deletes specified Shift that is older than 14 days and not completed. (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @return OK
     */
    delete(companyId: number | undefined, shiftId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/ShiftsA/Delete?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface IShiftsODataClient {
    /**
     * (Auth roles: Admin)
     * @return OK
     */
    $count(): Promise<ShiftODataRes[]>;
}

export class ShiftsODataClient implements IShiftsODataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Admin)
     * @return OK
     */
    $count( cancelToken?: CancelToken): Promise<ShiftODataRes[]> {
        let url_ = this.baseUrl + "/odata/ShiftsOData/$count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.process$count(_response);
        });
    }

    protected process$count(response: AxiosResponse): Promise<ShiftODataRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftODataRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftODataRes[]>(null as any);
    }
}

export interface IShiftVoiceOfCustomerCommentsAClient {
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @return OK
     */
    all(companyId: number | undefined, shiftId: number | undefined): Promise<ShiftVoiceOfCustomerCommentRes[]>;
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param id (optional) 
     * @return OK
     */
    get(companyId: number | undefined, shiftId: number | undefined, id: number | undefined): Promise<ShiftVoiceOfCustomerCommentRes>;
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    create(companyId: number | undefined, shiftId: number | undefined, body: ShiftVoiceOfCustomerCommentAReq | undefined): Promise<ShiftVoiceOfCustomerCommentRes>;
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(companyId: number | undefined, shiftId: number | undefined, id: number | undefined, body: ShiftVoiceOfCustomerCommentAReq | undefined): Promise<ShiftVoiceOfCustomerCommentRes>;
    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param id (optional) 
     * @return OK
     */
    delete(companyId: number | undefined, shiftId: number | undefined, id: number | undefined): Promise<void>;
}

export class ShiftVoiceOfCustomerCommentsAClient implements IShiftVoiceOfCustomerCommentsAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @return OK
     */
    all(companyId: number | undefined, shiftId: number | undefined, cancelToken?: CancelToken): Promise<ShiftVoiceOfCustomerCommentRes[]> {
        let url_ = this.baseUrl + "/api/ShiftVoiceOfCustomerCommentsA/All?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<ShiftVoiceOfCustomerCommentRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftVoiceOfCustomerCommentRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftVoiceOfCustomerCommentRes[]>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param id (optional) 
     * @return OK
     */
    get(companyId: number | undefined, shiftId: number | undefined, id: number | undefined, cancelToken?: CancelToken): Promise<ShiftVoiceOfCustomerCommentRes> {
        let url_ = this.baseUrl + "/api/ShiftVoiceOfCustomerCommentsA/Get?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ShiftVoiceOfCustomerCommentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftVoiceOfCustomerCommentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftVoiceOfCustomerCommentRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param body (optional) 
     * @return OK
     */
    create(companyId: number | undefined, shiftId: number | undefined, body: ShiftVoiceOfCustomerCommentAReq | undefined, cancelToken?: CancelToken): Promise<ShiftVoiceOfCustomerCommentRes> {
        let url_ = this.baseUrl + "/api/ShiftVoiceOfCustomerCommentsA/Create?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ShiftVoiceOfCustomerCommentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftVoiceOfCustomerCommentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftVoiceOfCustomerCommentRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(companyId: number | undefined, shiftId: number | undefined, id: number | undefined, body: ShiftVoiceOfCustomerCommentAReq | undefined, cancelToken?: CancelToken): Promise<ShiftVoiceOfCustomerCommentRes> {
        let url_ = this.baseUrl + "/api/ShiftVoiceOfCustomerCommentsA/Update?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ShiftVoiceOfCustomerCommentRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShiftVoiceOfCustomerCommentRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftVoiceOfCustomerCommentRes>(null as any);
    }

    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param companyId (optional) 
     * @param shiftId (optional) 
     * @param id (optional) 
     * @return OK
     */
    delete(companyId: number | undefined, shiftId: number | undefined, id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ShiftVoiceOfCustomerCommentsA/Delete?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISmsesAClient {
    /**
     * Returns a paged collection of Queued Smses (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    pageQueued(companyId: number | undefined, body: PagedReq | undefined): Promise<SmsQueueAResPage>;
    /**
     * Returns a paged collection of Sms History (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    pageHistory(companyId: number | undefined, body: PagedReq | undefined): Promise<SmsHistoryAResPage>;
    /**
     * Sends SMSes queued for specified Company which is Active or not
    Can be invoked in parallel per Company but don't invoke simultaneously for same Company (Auth roles: Admin)
     * @param companyId (optional) 
     * @param maxSmsesToSend (optional) maximum number of SMSes to send. Null indicates all SMSes must be sent, which could be time consuming.
     * @return OK
     */
    sendQueuedSmses(companyId: number | undefined, maxSmsesToSend: number | undefined): Promise<MessageResponseDto>;
}

export class SmsesAClient implements ISmsesAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns a paged collection of Queued Smses (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    pageQueued(companyId: number | undefined, body: PagedReq | undefined, cancelToken?: CancelToken): Promise<SmsQueueAResPage> {
        let url_ = this.baseUrl + "/api/SmsesA/PageQueued?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageQueued(_response);
        });
    }

    protected processPageQueued(response: AxiosResponse): Promise<SmsQueueAResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SmsQueueAResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SmsQueueAResPage>(null as any);
    }

    /**
     * Returns a paged collection of Sms History (Auth roles: Admin)
     * @param companyId (optional) 
     * @param body (optional) 
     * @return OK
     */
    pageHistory(companyId: number | undefined, body: PagedReq | undefined, cancelToken?: CancelToken): Promise<SmsHistoryAResPage> {
        let url_ = this.baseUrl + "/api/SmsesA/PageHistory?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageHistory(_response);
        });
    }

    protected processPageHistory(response: AxiosResponse): Promise<SmsHistoryAResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SmsHistoryAResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SmsHistoryAResPage>(null as any);
    }

    /**
     * Sends SMSes queued for specified Company which is Active or not
    Can be invoked in parallel per Company but don't invoke simultaneously for same Company (Auth roles: Admin)
     * @param companyId (optional) 
     * @param maxSmsesToSend (optional) maximum number of SMSes to send. Null indicates all SMSes must be sent, which could be time consuming.
     * @return OK
     */
    sendQueuedSmses(companyId: number | undefined, maxSmsesToSend: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/SmsesA/SendQueuedSmses?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (maxSmsesToSend === null)
            throw new Error("The parameter 'maxSmsesToSend' cannot be null.");
        else if (maxSmsesToSend !== undefined)
            url_ += "maxSmsesToSend=" + encodeURIComponent("" + maxSmsesToSend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendQueuedSmses(_response);
        });
    }

    protected processSendQueuedSmses(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface IStaffClient {
    /**
     * Returns all the Staff users (non deleted) belonging to the Company of the current user. (Auth roles: Owner,Manager,Accountant)
     * @return OK
     */
    all(): Promise<StaffRes[]>;
    /**
     * (Auth roles: Owner,Manager,Accountant)
     * @param staffId (optional) 
     * @return OK
     */
    get(staffId: number | undefined): Promise<StaffRes>;
    /**
     * Invite a new Staff.
    Note: Manager can only invite Driver (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    invite(body: ImportStaffReq | undefined): Promise<InviteStaffRes>;
    /**
     * Invite a new Staff with minimal fields. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    inviteMin(body: InviteStaffMinReq | undefined): Promise<InviteStaffRes>;
    /**
     * Imports CSA from Google Sheet and returns them to UI without saving to DB
    UI can show them as a preview and allow user to confirm/change before sending them back to API using M:Api.Controllers.StaffController.Invite(Api.Poco.Dtos.Staff.ImportStaffReq) or !:InviteDriver(InviteStaffMinReq) (Auth roles: Owner,Manager)
     * @return OK
     */
    importFromGoogleSheetToUi(): Promise<ImportStaffToUiReq[]>;
    /**
     * Resends the Email confirmation link to the Staff's Email 
    as a reminder for him to confirm his email. (Auth roles: Owner,Manager)
     * @param staffId (optional) 
     * @return OK
     */
    inviteReminder(staffId: number | undefined): Promise<void>;
    /**
     * Returns true if the specified Staff has registered for GST as shown on https://abr.business.gov.au (Auth roles: Owner,Manager,Accountant)
     * @param staffId (optional) 
     * @return OK
     */
    updateGST(staffId: number | undefined): Promise<StaffRes>;
    /**
     * Update existing non-deleted staff.
    Note: For Staff with confirmed email address, Email and Role cannot be updated. (Auth roles: Owner,Manager)
     * @param staffId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(staffId: number | undefined, body: StaffReq | undefined): Promise<StaffRes>;
    /**
     * Soft-deletes a Staff
    Manager can delete a Driver alone.
    Note: Warn on the UI that this is a permanent operation. (Auth roles: Owner,Manager)
     * @param staffId (optional) 
     * @return OK
     */
    delete(staffId: number | undefined): Promise<MessageResponseDto>;
}

export class StaffClient implements IStaffClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns all the Staff users (non deleted) belonging to the Company of the current user. (Auth roles: Owner,Manager,Accountant)
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<StaffRes[]> {
        let url_ = this.baseUrl + "/api/Staff/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<StaffRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StaffRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffRes[]>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager,Accountant)
     * @param staffId (optional) 
     * @return OK
     */
    get(staffId: number | undefined, cancelToken?: CancelToken): Promise<StaffRes> {
        let url_ = this.baseUrl + "/api/Staff/Get?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<StaffRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StaffRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffRes>(null as any);
    }

    /**
     * Invite a new Staff.
    Note: Manager can only invite Driver (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    invite(body: ImportStaffReq | undefined, cancelToken?: CancelToken): Promise<InviteStaffRes> {
        let url_ = this.baseUrl + "/api/Staff/Invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvite(_response);
        });
    }

    protected processInvite(response: AxiosResponse): Promise<InviteStaffRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InviteStaffRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteStaffRes>(null as any);
    }

    /**
     * Invite a new Staff with minimal fields. (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    inviteMin(body: InviteStaffMinReq | undefined, cancelToken?: CancelToken): Promise<InviteStaffRes> {
        let url_ = this.baseUrl + "/api/Staff/InviteMin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteMin(_response);
        });
    }

    protected processInviteMin(response: AxiosResponse): Promise<InviteStaffRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InviteStaffRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteStaffRes>(null as any);
    }

    /**
     * Imports CSA from Google Sheet and returns them to UI without saving to DB
    UI can show them as a preview and allow user to confirm/change before sending them back to API using M:Api.Controllers.StaffController.Invite(Api.Poco.Dtos.Staff.ImportStaffReq) or !:InviteDriver(InviteStaffMinReq) (Auth roles: Owner,Manager)
     * @return OK
     */
    importFromGoogleSheetToUi( cancelToken?: CancelToken): Promise<ImportStaffToUiReq[]> {
        let url_ = this.baseUrl + "/api/Staff/ImportFromGoogleSheetToUi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportFromGoogleSheetToUi(_response);
        });
    }

    protected processImportFromGoogleSheetToUi(response: AxiosResponse): Promise<ImportStaffToUiReq[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ImportStaffToUiReq[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportStaffToUiReq[]>(null as any);
    }

    /**
     * Resends the Email confirmation link to the Staff's Email 
    as a reminder for him to confirm his email. (Auth roles: Owner,Manager)
     * @param staffId (optional) 
     * @return OK
     */
    inviteReminder(staffId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Staff/InviteReminder?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteReminder(_response);
        });
    }

    protected processInviteReminder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns true if the specified Staff has registered for GST as shown on https://abr.business.gov.au (Auth roles: Owner,Manager,Accountant)
     * @param staffId (optional) 
     * @return OK
     */
    updateGST(staffId: number | undefined, cancelToken?: CancelToken): Promise<StaffRes> {
        let url_ = this.baseUrl + "/api/Staff/UpdateGST?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGST(_response);
        });
    }

    protected processUpdateGST(response: AxiosResponse): Promise<StaffRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StaffRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffRes>(null as any);
    }

    /**
     * Update existing non-deleted staff.
    Note: For Staff with confirmed email address, Email and Role cannot be updated. (Auth roles: Owner,Manager)
     * @param staffId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(staffId: number | undefined, body: StaffReq | undefined, cancelToken?: CancelToken): Promise<StaffRes> {
        let url_ = this.baseUrl + "/api/Staff/Update?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<StaffRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StaffRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffRes>(null as any);
    }

    /**
     * Soft-deletes a Staff
    Manager can delete a Driver alone.
    Note: Warn on the UI that this is a permanent operation. (Auth roles: Owner,Manager)
     * @param staffId (optional) 
     * @return OK
     */
    delete(staffId: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/Staff/Delete?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface IStaticValuesClient {
    /**
     * Enumerates all the enum types with all the integer values and string values(names). (Auth)
     * @return OK
     */
    allEnums(): Promise<AllEnumsRes>;
    /**
     * Returns latest Timezones (Auth)
     * @return OK
     */
    timezones(): Promise<TimeZoneInfo[]>;
    /**
     * Returns API version (Auth)
     * @return OK
     */
    version(): Promise<string>;
    /**
     * (Auth)
     * @return OK
     */
    errorDtoSample(): Promise<ErrorDto>;
}

export class StaticValuesClient implements IStaticValuesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Enumerates all the enum types with all the integer values and string values(names). (Auth)
     * @return OK
     */
    allEnums( cancelToken?: CancelToken): Promise<AllEnumsRes> {
        let url_ = this.baseUrl + "/api/StaticValues/AllEnums";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllEnums(_response);
        });
    }

    protected processAllEnums(response: AxiosResponse): Promise<AllEnumsRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AllEnumsRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllEnumsRes>(null as any);
    }

    /**
     * Returns latest Timezones (Auth)
     * @return OK
     */
    timezones( cancelToken?: CancelToken): Promise<TimeZoneInfo[]> {
        let url_ = this.baseUrl + "/api/StaticValues/Timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTimezones(_response);
        });
    }

    protected processTimezones(response: AxiosResponse): Promise<TimeZoneInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimeZoneInfo[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeZoneInfo[]>(null as any);
    }

    /**
     * Returns API version (Auth)
     * @return OK
     */
    version( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/StaticValues/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * (Auth)
     * @return OK
     */
    errorDtoSample( cancelToken?: CancelToken): Promise<ErrorDto> {
        let url_ = this.baseUrl + "/api/StaticValues/ErrorDtoSample";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processErrorDtoSample(_response);
        });
    }

    protected processErrorDtoSample(response: AxiosResponse): Promise<ErrorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ErrorDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ErrorDto>(null as any);
    }
}

export interface ITaxCalculatorAClient {
    /**
     * Calculate annual tax for given income and parameters (Auth roles: Admin)
     * @param body (optional) Tax calculation parameters
     * @return OK
     */
    calculateTaxAnnually(body: TaxAnnualReq | undefined): Promise<TaxAnnualRes>;
    /**
     * Calculate pay for specific pay period (Auth roles: Admin)
     * @param body (optional) Pay period calculation parameters
     * @return OK
     */
    calculateTaxByPayPeriod(body: TaxByPayPeriodReq | undefined): Promise<TaxByPayPeriodRes>;
    /**
     * Calculate PAYG withholding for fortnightly pay (Auth roles: Admin)
     * @param fortnightlyGross (optional) Fortnightly gross income
     * @param fiscalYear (optional) Fiscal year (optional, defaults to 2024-25)
     * @return OK
     */
    calculateFortnightlyPaygWithholding(fortnightlyGross: number | undefined, fiscalYear: TaxFiscalYear | undefined): Promise<number>;
    /**
     * Get tax year configuration details (Auth roles: Admin)
     * @return OK
     */
    getTaxYearConfigs(): Promise<TaxYearConfig[]>;
    /**
     * Web Bot endpoint to get tax calculation response from https://paycalculator.com.au (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    calculateUsingPayCalculatorWebBot(body: PayCalcWebBotTaxCalculationReq | undefined): Promise<PayCalcWebBotTaxCalculationRes>;
}

export class TaxCalculatorAClient implements ITaxCalculatorAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Calculate annual tax for given income and parameters (Auth roles: Admin)
     * @param body (optional) Tax calculation parameters
     * @return OK
     */
    calculateTaxAnnually(body: TaxAnnualReq | undefined, cancelToken?: CancelToken): Promise<TaxAnnualRes> {
        let url_ = this.baseUrl + "/api/TaxCalculatorA/CalculateTaxAnnually";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateTaxAnnually(_response);
        });
    }

    protected processCalculateTaxAnnually(response: AxiosResponse): Promise<TaxAnnualRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaxAnnualRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxAnnualRes>(null as any);
    }

    /**
     * Calculate pay for specific pay period (Auth roles: Admin)
     * @param body (optional) Pay period calculation parameters
     * @return OK
     */
    calculateTaxByPayPeriod(body: TaxByPayPeriodReq | undefined, cancelToken?: CancelToken): Promise<TaxByPayPeriodRes> {
        let url_ = this.baseUrl + "/api/TaxCalculatorA/CalculateTaxByPayPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateTaxByPayPeriod(_response);
        });
    }

    protected processCalculateTaxByPayPeriod(response: AxiosResponse): Promise<TaxByPayPeriodRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaxByPayPeriodRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxByPayPeriodRes>(null as any);
    }

    /**
     * Calculate PAYG withholding for fortnightly pay (Auth roles: Admin)
     * @param fortnightlyGross (optional) Fortnightly gross income
     * @param fiscalYear (optional) Fiscal year (optional, defaults to 2024-25)
     * @return OK
     */
    calculateFortnightlyPaygWithholding(fortnightlyGross: number | undefined, fiscalYear: TaxFiscalYear | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/TaxCalculatorA/CalculateFortnightlyPaygWithholding?";
        if (fortnightlyGross === null)
            throw new Error("The parameter 'fortnightlyGross' cannot be null.");
        else if (fortnightlyGross !== undefined)
            url_ += "fortnightlyGross=" + encodeURIComponent("" + fortnightlyGross) + "&";
        if (fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' cannot be null.");
        else if (fiscalYear !== undefined)
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateFortnightlyPaygWithholding(_response);
        });
    }

    protected processCalculateFortnightlyPaygWithholding(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get tax year configuration details (Auth roles: Admin)
     * @return OK
     */
    getTaxYearConfigs( cancelToken?: CancelToken): Promise<TaxYearConfig[]> {
        let url_ = this.baseUrl + "/api/TaxCalculatorA/GetTaxYearConfigs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxYearConfigs(_response);
        });
    }

    protected processGetTaxYearConfigs(response: AxiosResponse): Promise<TaxYearConfig[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaxYearConfig[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxYearConfig[]>(null as any);
    }

    /**
     * Web Bot endpoint to get tax calculation response from https://paycalculator.com.au (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    calculateUsingPayCalculatorWebBot(body: PayCalcWebBotTaxCalculationReq | undefined, cancelToken?: CancelToken): Promise<PayCalcWebBotTaxCalculationRes> {
        let url_ = this.baseUrl + "/api/TaxCalculatorA/CalculateUsingPayCalculatorWebBot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateUsingPayCalculatorWebBot(_response);
        });
    }

    protected processCalculateUsingPayCalculatorWebBot(response: AxiosResponse): Promise<PayCalcWebBotTaxCalculationRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayCalcWebBotTaxCalculationRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayCalcWebBotTaxCalculationRes>(null as any);
    }
}

export interface IApiClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    token(body: TokenReq | undefined): Promise<TokenRes>;
}

export class ApiClient implements IApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    token(body: TokenReq | undefined, cancelToken?: CancelToken): Promise<TokenRes> {
        let url_ = this.baseUrl + "/api/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: AxiosResponse): Promise<TokenRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TokenRes>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenRes>(null as any);
    }
}

export interface ITokenClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    refresh(body: RefreshTokenReq | undefined): Promise<TokenRes>;
}

export class TokenClient implements ITokenClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refresh(body: RefreshTokenReq | undefined, cancelToken?: CancelToken): Promise<TokenRes> {
        let url_ = this.baseUrl + "/api/Token/Refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<TokenRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TokenRes>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenRes>(null as any);
    }
}

export interface IUserProfileClient {
    /**
     * Gets User Profile along with Role (Auth)
     * @return OK
     */
    get(): Promise<UserProfileRes>;
    /**
     * Allows a user to update his User Profile (Auth)
     * @param body (optional) 
     * @return OK
     */
    update(body: UserProfileReq | undefined): Promise<UserProfileRes>;
    /**
     * Returns true if the current User has registered for GST as shown on https://abr.business.gov.au (Auth)
     * @return OK
     */
    updateGST(): Promise<UserProfileRes>;
    /**
     * Creates or updates the User's signature. (Auth)
     * @param signature (optional) 
     * @return OK
     */
    createOrUpdateSignature(signature: FileParameter | undefined): Promise<void>;
    /**
     * (Auth)
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateWeeklyAvailability(body: WeeklyAvailabilityReq | undefined): Promise<UserProfileRes>;
    /**
     * Gets recent 10 ApiKeys for the User (Auth)
     * @return OK
     */
    apiKeys(): Promise<ApiKeyRes[]>;
    /**
     * Creates a new ApiKey for the User if he already does not have a valid ApiKey.
    Note: warn the user that this key will not be shwon again and he must store it securely somewhere. (Auth)
     * @param body (optional) 
     * @return OK
     */
    createApiKey(body: CreateApiKeyReq | undefined): Promise<string>;
    /**
     * Note: Warn the user that this is a permanent operation (Auth)
     * @param id (optional) 
     * @return OK
     */
    deleteApiKey(id: number | undefined): Promise<void>;
}

export class UserProfileClient implements IUserProfileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets User Profile along with Role (Auth)
     * @return OK
     */
    get( cancelToken?: CancelToken): Promise<UserProfileRes> {
        let url_ = this.baseUrl + "/api/UserProfile/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserProfileRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserProfileRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileRes>(null as any);
    }

    /**
     * Allows a user to update his User Profile (Auth)
     * @param body (optional) 
     * @return OK
     */
    update(body: UserProfileReq | undefined, cancelToken?: CancelToken): Promise<UserProfileRes> {
        let url_ = this.baseUrl + "/api/UserProfile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserProfileRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserProfileRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileRes>(null as any);
    }

    /**
     * Returns true if the current User has registered for GST as shown on https://abr.business.gov.au (Auth)
     * @return OK
     */
    updateGST( cancelToken?: CancelToken): Promise<UserProfileRes> {
        let url_ = this.baseUrl + "/api/UserProfile/UpdateGST";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGST(_response);
        });
    }

    protected processUpdateGST(response: AxiosResponse): Promise<UserProfileRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserProfileRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileRes>(null as any);
    }

    /**
     * Creates or updates the User's signature. (Auth)
     * @param signature (optional) 
     * @return OK
     */
    createOrUpdateSignature(signature: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/CreateOrUpdateSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (signature === null || signature === undefined)
            throw new Error("The parameter 'signature' cannot be null.");
        else
            content_.append("signature", signature.data, signature.fileName ? signature.fileName : "signature");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateSignature(_response);
        });
    }

    protected processCreateOrUpdateSignature(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateWeeklyAvailability(body: WeeklyAvailabilityReq | undefined, cancelToken?: CancelToken): Promise<UserProfileRes> {
        let url_ = this.baseUrl + "/api/UserProfile/AddOrUpdateWeeklyAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateWeeklyAvailability(_response);
        });
    }

    protected processAddOrUpdateWeeklyAvailability(response: AxiosResponse): Promise<UserProfileRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserProfileRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileRes>(null as any);
    }

    /**
     * Gets recent 10 ApiKeys for the User (Auth)
     * @return OK
     */
    apiKeys( cancelToken?: CancelToken): Promise<ApiKeyRes[]> {
        let url_ = this.baseUrl + "/api/UserProfile/ApiKeys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiKeys(_response);
        });
    }

    protected processApiKeys(response: AxiosResponse): Promise<ApiKeyRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiKeyRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiKeyRes[]>(null as any);
    }

    /**
     * Creates a new ApiKey for the User if he already does not have a valid ApiKey.
    Note: warn the user that this key will not be shwon again and he must store it securely somewhere. (Auth)
     * @param body (optional) 
     * @return OK
     */
    createApiKey(body: CreateApiKeyReq | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/UserProfile/CreateApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateApiKey(_response);
        });
    }

    protected processCreateApiKey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Note: Warn the user that this is a permanent operation (Auth)
     * @param id (optional) 
     * @return OK
     */
    deleteApiKey(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/DeleteApiKey?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteApiKey(_response);
        });
    }

    protected processDeleteApiKey(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUsersAClient {
    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined): Promise<UserDetailedResPage>;
    /**
     * Allows existing Admin to create a new Admin User. 
    Existing Admin needs to manually confirm the email id after adding the new Admin user.
    Use this with caution since Admin has access to entire system (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    createAdmin(body: RegisterUserReq | undefined): Promise<MessageResponseDto>;
    /**
     * Confirms user's email (Auth roles: Admin)
     * @param email (optional) 
     * @return OK
     */
    confirmEmail(email: string | undefined): Promise<MessageResponseDto>;
    /**
     * Use this to get a link to rset password for a user who is unable to receive emails. (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    getForgotPasswordLink(body: ForgotPasswordReq | undefined): Promise<ForgotPasswordRes>;
    /**
     * Changes the user's email id. (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    changeEmail(body: ChangeEmailReq | undefined): Promise<UserRes>;
}

export class UsersAClient implements IUsersAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    page(body: PagedReq | undefined, cancelToken?: CancelToken): Promise<UserDetailedResPage> {
        let url_ = this.baseUrl + "/api/UsersA/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<UserDetailedResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDetailedResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDetailedResPage>(null as any);
    }

    /**
     * Allows existing Admin to create a new Admin User. 
    Existing Admin needs to manually confirm the email id after adding the new Admin user.
    Use this with caution since Admin has access to entire system (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    createAdmin(body: RegisterUserReq | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/UsersA/CreateAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAdmin(_response);
        });
    }

    protected processCreateAdmin(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Confirms user's email (Auth roles: Admin)
     * @param email (optional) 
     * @return OK
     */
    confirmEmail(email: string | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/UsersA/ConfirmEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }

    /**
     * Use this to get a link to rset password for a user who is unable to receive emails. (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    getForgotPasswordLink(body: ForgotPasswordReq | undefined, cancelToken?: CancelToken): Promise<ForgotPasswordRes> {
        let url_ = this.baseUrl + "/api/UsersA/GetForgotPasswordLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForgotPasswordLink(_response);
        });
    }

    protected processGetForgotPasswordLink(response: AxiosResponse): Promise<ForgotPasswordRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ForgotPasswordRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForgotPasswordRes>(null as any);
    }

    /**
     * Changes the user's email id. (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    changeEmail(body: ChangeEmailReq | undefined, cancelToken?: CancelToken): Promise<UserRes> {
        let url_ = this.baseUrl + "/api/UsersA/ChangeEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeEmail(_response);
        });
    }

    protected processChangeEmail(response: AxiosResponse): Promise<UserRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRes>(null as any);
    }
}

export interface IVehicleAClient {
    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    syncWithFleetIo(companyId: number | undefined): Promise<VehicleRes[]>;
}

export class VehicleAClient implements IVehicleAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Admin)
     * @param companyId (optional) 
     * @return OK
     */
    syncWithFleetIo(companyId: number | undefined, cancelToken?: CancelToken): Promise<VehicleRes[]> {
        let url_ = this.baseUrl + "/api/VehicleA/SyncWithFleetIo?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncWithFleetIo(_response);
        });
    }

    protected processSyncWithFleetIo(response: AxiosResponse): Promise<VehicleRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleRes[]>(null as any);
    }
}

export interface IVehicleIssuesClient {
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<VehicleIssueRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: VehicleIssuePagedReq | undefined): Promise<VehicleIssueResPage>;
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    create(body: VehicleIssueReq | undefined): Promise<VehicleIssueRes>;
    /**
     * Note: Driver can only update his VehicleIssue (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: VehicleIssueReq | undefined): Promise<VehicleIssueRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param fleetIoId (optional) 
     * @return OK
     */
    associateFleetIoId(id: number | undefined, fleetIoId: number | undefined): Promise<VehicleIssueRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    disssociateFleetIoId(id: number | undefined): Promise<VehicleIssueRes>;
    /**
     * Permanently deletes a VehicleIssue (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Promise<void>;
}

export class VehicleIssuesClient implements IVehicleIssuesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<VehicleIssueRes> {
        let url_ = this.baseUrl + "/api/VehicleIssues/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<VehicleIssueRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleIssueRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleIssueRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: VehicleIssuePagedReq | undefined, cancelToken?: CancelToken): Promise<VehicleIssueResPage> {
        let url_ = this.baseUrl + "/api/VehicleIssues/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<VehicleIssueResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleIssueResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleIssueResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    create(body: VehicleIssueReq | undefined, cancelToken?: CancelToken): Promise<VehicleIssueRes> {
        let url_ = this.baseUrl + "/api/VehicleIssues/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<VehicleIssueRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleIssueRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleIssueRes>(null as any);
    }

    /**
     * Note: Driver can only update his VehicleIssue (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: VehicleIssueReq | undefined, cancelToken?: CancelToken): Promise<VehicleIssueRes> {
        let url_ = this.baseUrl + "/api/VehicleIssues/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VehicleIssueRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleIssueRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleIssueRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param fleetIoId (optional) 
     * @return OK
     */
    associateFleetIoId(id: number | undefined, fleetIoId: number | undefined, cancelToken?: CancelToken): Promise<VehicleIssueRes> {
        let url_ = this.baseUrl + "/api/VehicleIssues/AssociateFleetIoId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (fleetIoId === null)
            throw new Error("The parameter 'fleetIoId' cannot be null.");
        else if (fleetIoId !== undefined)
            url_ += "fleetIoId=" + encodeURIComponent("" + fleetIoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssociateFleetIoId(_response);
        });
    }

    protected processAssociateFleetIoId(response: AxiosResponse): Promise<VehicleIssueRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleIssueRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleIssueRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    disssociateFleetIoId(id: number | undefined, cancelToken?: CancelToken): Promise<VehicleIssueRes> {
        let url_ = this.baseUrl + "/api/VehicleIssues/DisssociateFleetIoId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisssociateFleetIoId(_response);
        });
    }

    protected processDisssociateFleetIoId(response: AxiosResponse): Promise<VehicleIssueRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleIssueRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleIssueRes>(null as any);
    }

    /**
     * Permanently deletes a VehicleIssue (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/VehicleIssues/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVehiclesClient {
    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<VehicleRes>;
    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: VehiclePagedReq | undefined): Promise<VehicleResPage>;
    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: VehicleReq | undefined): Promise<VehicleRes>;
    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: VehicleReq | undefined): Promise<VehicleRes>;
    /**
     * Allows to soft-delete a Vehicle (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    softDelete(id: number | undefined): Promise<void>;
}

export class VehiclesClient implements IVehiclesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * (Auth roles: Owner,Manager,Driver)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<VehicleRes> {
        let url_ = this.baseUrl + "/api/Vehicles/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<VehicleRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleRes>(null as any);
    }

    /**
     * Pagination in descending order of creation (Auth roles: Owner,Manager,Driver)
     * @param body (optional) 
     * @return OK
     */
    page(body: VehiclePagedReq | undefined, cancelToken?: CancelToken): Promise<VehicleResPage> {
        let url_ = this.baseUrl + "/api/Vehicles/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<VehicleResPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleResPage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleResPage>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param body (optional) 
     * @return OK
     */
    create(body: VehicleReq | undefined, cancelToken?: CancelToken): Promise<VehicleRes> {
        let url_ = this.baseUrl + "/api/Vehicles/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<VehicleRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleRes>(null as any);
    }

    /**
     * (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: VehicleReq | undefined, cancelToken?: CancelToken): Promise<VehicleRes> {
        let url_ = this.baseUrl + "/api/Vehicles/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VehicleRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleRes>(null as any);
    }

    /**
     * Allows to soft-delete a Vehicle (Auth roles: Owner,Manager)
     * @param id (optional) 
     * @return OK
     */
    softDelete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Vehicles/SoftDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSoftDelete(_response);
        });
    }

    protected processSoftDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVehicleTypesAClient {
    /**
     * Returns all the VehicleTypes (Auth roles: Admin)
     * @return OK
     */
    all(): Promise<VehicleTypeRes[]>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Promise<VehicleTypeRes>;
    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: VehicleTypeReq | undefined): Promise<VehicleTypeRes>;
    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: VehicleTypeReq | undefined): Promise<VehicleTypeRes>;
    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Promise<MessageResponseDto>;
}

export class VehicleTypesAClient implements IVehicleTypesAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns all the VehicleTypes (Auth roles: Admin)
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<VehicleTypeRes[]> {
        let url_ = this.baseUrl + "/api/VehicleTypesA/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<VehicleTypeRes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleTypeRes[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleTypeRes[]>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined, cancelToken?: CancelToken): Promise<VehicleTypeRes> {
        let url_ = this.baseUrl + "/api/VehicleTypesA/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<VehicleTypeRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleTypeRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleTypeRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param body (optional) 
     * @return OK
     */
    create(body: VehicleTypeReq | undefined, cancelToken?: CancelToken): Promise<VehicleTypeRes> {
        let url_ = this.baseUrl + "/api/VehicleTypesA/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<VehicleTypeRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleTypeRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleTypeRes>(null as any);
    }

    /**
     * (Auth roles: Admin)
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: number | undefined, body: VehicleTypeReq | undefined, cancelToken?: CancelToken): Promise<VehicleTypeRes> {
        let url_ = this.baseUrl + "/api/VehicleTypesA/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VehicleTypeRes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VehicleTypeRes>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleTypeRes>(null as any);
    }

    /**
     * Note: This is a permanent operation (Auth roles: Admin)
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined, cancelToken?: CancelToken): Promise<MessageResponseDto> {
        let url_ = this.baseUrl + "/api/VehicleTypesA/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MessageResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponseDto>(null as any);
    }
}

export interface AcknowledgeShiftNRWarningReq {
    shiftNrId?: number;
    shiftNRWarningId?: number;
}

export interface AcknowledgeShiftWarningReq {
    shiftId?: number;
    shiftWarningId?: number;
}

export interface AddressODataRes {
    id?: number;
    /** Free text */
    street?: string | null;
    /** Or Pincode */
    areaCode?: string | null;
    /** Or District */
    suburb?: string | null;
    /** Or Town */
    city?: string | null;
    /** Or Province */
    stateId?: number;
    latitude?: number | null;
    longitude?: number | null;
    state?: StateODataRes;
}

export interface AddressReq {
    /** Free text */
    street?: string | null;
    /** Or Pincode */
    areaCode: string;
    /** Or District */
    suburb?: string | null;
    /** Or Town */
    city?: string | null;
    /** Or Province */
    stateId: number;
    latitude?: number | null;
    longitude?: number | null;
}

export interface AddressRes {
    id?: number;
    /** Free text */
    street?: string | null;
    /** Or Pincode */
    areaCode?: string | null;
    /** Or District */
    suburb?: string | null;
    /** Or Town */
    city?: string | null;
    /** Or Province */
    stateId?: number;
    state?: StateRes;
    latitude?: number | null;
    longitude?: number | null;
}

/** Wraps all Enum types Response objects */
export interface AllEnumsRes {
    appUsagePatterns?: EnumRes[] | null;
    checkinTypes?: EnumRes[] | null;
    companyHtmlTemplateTypes?: EnumRes[] | null;
    companyDocumentTypes?: EnumRes[] | null;
    companyDashboardConfigTypes?: EnumRes[] | null;
    /** E.g. Sunday = 0, etc */
    dayOfWeek?: EnumRes[] | null;
    externalApiProviderTypes?: EnumRes[] | null;
    /** External User Types */
    extUserType?: EnumRes[] | null;
    fleetIoFormTypes?: EnumRes[] | null;
    formQuestionNumericRestrictionTypes?: EnumRes[] | null;
    formQuestionTypes?: EnumRes[] | null;
    payrollPeriodStatus?: EnumRes[] | null;
    payRateKinds?: EnumRes[] | null;
    payRateTypes?: EnumRes[] | null;
    payRollFrequency?: EnumRes[] | null;
    payrollTimesheetHoursMismatchTypes?: EnumRes[] | null;
    pdfServiceTypes?: EnumRes[] | null;
    mobileNotificationPlatforms?: EnumRes[] | null;
    breachCalculationTypes?: EnumRes[] | null;
    blobTypes?: EnumRes[] | null;
    drivingLicenseClass?: EnumRes[] | null;
    extFormTypes?: EnumRes[] | null;
    formTypes?: EnumRes[] | null;
    errorTypes?: EnumRes[] | null;
    googleSheetTypes?: EnumRes[] | null;
    httpVerbs?: EnumRes[] | null;
    months?: EnumRes[] | null;
    employmentTypes?: EnumRes[] | null;
    oneSignalDeviceTypes?: EnumRes[] | null;
    smsTypes?: EnumRes[] | null;
    smsDeliveryStatuses?: EnumRes[] | null;
    shiftNrTypes?: EnumRes[] | null;
    shiftMediaTypes?: EnumRes[] | null;
    shiftStatus?: EnumRes[] | null;
    extCompanies?: ExtCompanyRes[] | null;
    predefinedShiftComments?: PredefinedShiftCommentRes[] | null;
    shiftCommentTypes?: EnumRes[] | null;
    states?: StateRes[] | null;
    vehicleTypes?: VehicleTypeRes[] | null;
    /** Roles that a staff of a Company can have.
E.g. Driver, Owner etc */
    staffRoles?: string[] | null;
    taxFiscalYears?: EnumRes[] | null;
    taxPayPeriods?: EnumRes[] | null;
    vehicleStatuses?: EnumRes[] | null;
    vehicleIssueStatuses?: EnumRes[] | null;
    vehicleServiceTypes?: EnumRes[] | null;
    weeklyAvailabilityTypes?: EnumRes[] | null;
}

export interface ApiKeyRes {
    id?: number;
    /** User friendly/given name to the ApiKey. 
This will be used by user to identify his key */
    name?: string | null;
    createdOnUtc?: string;
    expiresOnUtc?: string;
    userId?: number;
}

export interface AppRoleRes {
    id?: number;
    name?: string | null;
}

/** Pattern or way of using the Trucksight App */
export enum AppUsagePattern {
    _0 = 0,
    _1 = 1,
}

export interface AppUserBlob {
    id?: number;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
}

export interface AppUserLicenseClassMapReq {
    drivingLicenseClasses?: DrivingLicenseClass[] | null;
}

export interface AppUserLicenseClassMapRes {
    userId?: number;
    drivingLicenseClass?: DrivingLicenseClass;
}

export interface BillAReq {
    year?: number;
    month?: number;
    companyId?: number;
}

export interface BillReq {
    year?: number;
    month?: number;
}

export interface BillingItem {
    servicePrice?: number;
    serviceName?: string | null;
}

export enum BlobType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum BreachCalculationType {
    _0 = 0,
    _1 = 1,
}

export interface ChangeEmailReq {
    userId?: number;
    /** New Email Id */
    email: string;
}

export interface ChangePasswordReq {
    oldPassword: string;
    newPassword: string;
}

export interface CheckinMinRes {
    id?: number;
    createdOnLocal?: string;
    createdOnUtc?: string;
    latitude?: number;
    longitude?: number;
    checkinType?: CheckinType;
    photoSasUrl?: string | null;
    /** User who checked in */
    userId?: number;
}

export interface CheckinODataRes {
    id?: number;
    createdOnLocal?: string;
    createdOnUtc?: string;
    latitude?: number;
    longitude?: number;
    checkinType?: CheckinType;
    photoSasUrl?: string | null;
    /** User who checked in */
    userId?: number;
    shiftId?: number | null;
    shiftBreakId?: number | null;
    shiftCommentId?: number | null;
}

export interface CheckinRes {
    id?: number;
    createdOnLocal?: string;
    createdOnUtc?: string;
    latitude?: number;
    longitude?: number;
    checkinType?: CheckinType;
    photoSasUrl?: string | null;
    /** User who checked in */
    userId?: number;
    user?: UserMinRes;
    shift?: ShiftRes;
    shiftBreak?: ShiftBreakRes;
    shiftComment?: ShiftCommentRes;
}

/** Provides for paginated results. */
export interface CheckinResPage {
    /** The collection of objects belonging to this page. */
    items?: CheckinRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

/** Checkins of multiple types can be indicated in the same flag by bit-wise ORing ref: https://stackoverflow.com/a/9811862/1508398 */
export enum CheckinType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
}

export interface CompanyARes {
    id?: number;
    name?: string | null;
    /** Australian Business Number */
    abn?: string | null;
    /** Email Id to which notifications such as Shift Start will be sent.
In case this is not available, email the Owner's email id */
    notificationEmail?: string | null;
    /** Email Id from which we will receive Linfox Timesheet emails
e.g. this is populated as Contractor email in jotform */
    timesheetSourceEmail?: string | null;
    timesheetSourceEmailNsw?: string | null;
    timesheetSourceEmailVic?: string | null;
    timesheetSourceEmailQld?: string | null;
    timesheetSourceEmailTas?: string | null;
    timesheetSourceEmailAct?: string | null;
    timesheetSourceEmailNt?: string | null;
    timesheetSourceEmailSa?: string | null;
    timesheetSourceEmailWa?: string | null;
    defaultOwner?: UserRes;
    /** Indicates whether the Company was Approved or Rejected by an Admin */
    isApproved?: boolean;
    /** When true, Users of this Company cannot generate Access Tokens */
    isLocked?: boolean;
    lockedOnUtc?: string | null;
    lockedByUser?: UserRes;
    /** Upper limit for maximum number of staff/employes that this company can have with currrent subscription/package
Note: This will be moved to subscription related table when they are implemented. */
    maximumEmployees?: number;
    /** e.g. If this is 200. No SMS sent for this Company should exceed 200 characters.
0 indicates no SMS is to be sent. */
    smsCharacterLimit?: number;
    /** e.g. If this is 500. Only 500 SMS of the type Automated can be sent for this Company. */
    automatedSmsLimit?: number;
    /** Number of Automated SMSes remaining.
This will be set to Api.Poco.Dtos.Company.CompanyARes.AutomatedSmsLimit every time a new invoice is generated. */
    automatedSmsRemaining?: number;
    /** e.g. If this is 100. Only 100 SMS of the type Manual can be sent for this Company. */
    manualSmsLimit?: number;
    /** Number of Manual SMSes remaining.
This will be set to Api.Poco.Dtos.Company.CompanyARes.ManualSmsLimit every time a new invoice is generated. */
    manualSmsRemaining?: number;
    /** Maximum number of FormsSubmissions that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formSubmissionsLimit?: number;
    /** Maximum number of Forms that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formsLimit?: number;
    /** Maximum number of questions a Api.Poco.Dtos.Forms.FormReq can have */
    formsMaxQuestionsPerFormLimit?: number;
    /** Maximum number of Files (media, photo, document etc) a Api.Poco.Dtos.Forms.FormReq can have */
    formsMaxFilesPerFormLimit?: number;
    /** Maximum number of Files a question (Api.Poco.Dtos.FormQuestion.JsonModels.FormQuestionMedia) can have */
    formsMaxFilesPerQuestionLimit?: number;
    approvedOrRejectedByUser?: UserRes;
    approvedOrRejectedOnUtc?: string | null;
    payPeriodStartDay?: DayOfWeek;
    payRollFrequency?: PayRollFrequency;
    /** Details of External Companies such as LinFox */
    extCompanies?: ExtCompanyRes[] | null;
}

/** Provides for paginated results. */
export interface CompanyAResPage {
    /** The collection of objects belonging to this page. */
    items?: CompanyARes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum CompanyDashboardConfigType {
    _0 = 0,
}

export interface CompanyDashboardFleetIoConfigReq {
    config?: FleetIoDashboardConfigJson;
}

export interface CompanyDashboardFleetIoConfigRes {
    id?: number;
    companyDashboardConfigType?: CompanyDashboardConfigType;
    config?: FleetIoDashboardConfigJson;
}

export interface CompanyDocumentRes {
    id?: number;
    title?: string | null;
    description?: string | null;
    blobSasUrl?: string | null;
    companyDocumentType?: CompanyDocumentType;
    /** Index */
    companyId?: number;
}

/** Provides for paginated results. */
export interface CompanyDocumentResPage {
    /** The collection of objects belonging to this page. */
    items?: CompanyDocumentRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum CompanyDocumentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface CompanyHtmlTemplateReq {
    /** HTML template with dynamic fields */
    template?: string | null;
    templateType?: CompanyHtmlTemplateType;
    companyId?: number;
}

export interface CompanyHtmlTemplateRes {
    id?: number;
    /** HTML template with dynamic fields */
    template?: string | null;
    templateType?: CompanyHtmlTemplateType;
    /** Index */
    companyId?: number;
}

/** Provides for paginated results. */
export interface CompanyHtmlTemplateResPage {
    /** The collection of objects belonging to this page. */
    items?: CompanyHtmlTemplateRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum CompanyHtmlTemplateType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export interface CompanyMinARes {
    id?: number;
    name?: string | null;
    /** Australian Business Number */
    abn?: string | null;
    /** Indicates whether the Company was Approved or Rejected by an Admin */
    isApproved?: boolean;
    /** When true, Users of this Company cannot generate Access Tokens */
    isLocked?: boolean;
    lockedOnUtc?: string | null;
}

export interface CompanyPayFrequencyReq {
    payPeriodStartDay?: DayOfWeek;
    payRollFrequency?: PayRollFrequency;
}

export interface CompanyPayRatesReq {
    payRate?: PayRateReq;
    /** The Role of the Staff for whom this Pay Rate will be applied.
e.g. Manager or Driver or Staff */
    role: string;
}

export interface CompanyRes {
    id?: number;
    name?: string | null;
    /** Australian Business Number */
    abn?: string | null;
    /** Email Id to which notifications such as Shift Start will be sent.
In case this is not available, email the Owner's email id */
    notificationEmail?: string | null;
    /** Email Id from which we will receive Linfox Timesheet emails
e.g. this is populated as Contractor email in jotform */
    timesheetSourceEmail?: string | null;
    timesheetSourceEmailNsw?: string | null;
    timesheetSourceEmailVic?: string | null;
    timesheetSourceEmailQld?: string | null;
    timesheetSourceEmailTas?: string | null;
    timesheetSourceEmailAct?: string | null;
    timesheetSourceEmailNt?: string | null;
    timesheetSourceEmailSa?: string | null;
    timesheetSourceEmailWa?: string | null;
    address?: AddressRes;
    payPeriodStartDay?: DayOfWeek;
    payRollFrequency?: PayRollFrequency;
    /** Public Url with readonly SAS of company Logo */
    logoBlobUrl?: string | null;
    /** Upper limit for maximum number of staff/employes that this company can have with currrent subscription/package
Note: This will be moved to subscription related table when they are implemented. */
    maximumEmployees?: number;
    /** e.g. If this is 200. No SMS sent for this Company should exceed 200 characters.
0 indicates no SMS is to be sent. */
    smsCharacterLimit?: number;
    /** e.g. If this is 500. Only 500 SMS of the type Automated can be sent for this Company. */
    automatedSmsLimit?: number;
    /** Number of Automated SMSes remaining.
This will be set to Api.Poco.Dtos.Company.CompanyRes.AutomatedSmsLimit every time a new invoice is generated. */
    automatedSmsRemaining?: number;
    /** e.g. If this is 100. Only 100 SMS of the type Manual can be sent for this Company. */
    manualSmsLimit?: number;
    /** Number of Manual SMSes remaining.
This will be set to Api.Poco.Dtos.Company.CompanyRes.ManualSmsLimit every time a new invoice is generated. */
    manualSmsRemaining?: number;
    /** Maximum number of FormsSubmissions that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formSubmissionsLimit?: number;
    /** Maximum number of Forms that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formsLimit?: number;
    /** Maximum number of questions a Api.Poco.Dtos.Forms.FormReq can have */
    formsMaxQuestionsPerFormLimit?: number;
    /** Maximum number of Files (media, photo, document etc) a Api.Poco.Dtos.Forms.FormReq can have */
    formsMaxFilesPerFormLimit?: number;
    /** Maximum number of Files a question (Api.Poco.Dtos.FormQuestion.JsonModels.FormQuestionMedia) can have */
    formsMaxFilesPerQuestionLimit?: number;
    /** Details of External Companies such as LinFox */
    extCompanies?: ExtCompanyRes[] | null;
    companyDocuments?: CompanyDocumentRes[] | null;
}

export interface ConfirmEmailReq {
    /** The email confirmation token/code. (url encoded)
Note: The API sends url encoded email id; as a part of the confirm email token message. 
This should be sent as the url encoded string. */
    code: string;
    /** The email id (url encoded)
Note: The API sends url encoded email id; as a part of the confirm email token message. 
This should be sent as the url encoded string. */
    email: string;
}

export interface CreateApiKeyReq {
    /** User friendly/given name to the ApiKey. 
This will be used by user to identify his key */
    name?: string | null;
}

export interface CreateExtCompanyReq {
    /** Name of the external Company e.g. Linfox */
    name?: string | null;
    /** Name of a Company in our system, used in external systems such as JotForm */
    extCompanyJotformName?: string | null;
    /** EmailId to send notifications such as ShiftStart Precheck questions to Linfox
Note: Keep this empty/null to avoid sending email notifications to ExtCompany */
    notificationEmail?: string | null;
    extForms?: ExtFormReq[] | null;
}

export interface CreatePayRateJobsiteAddOnReq {
    /** Optionally specify this to assign users to the AddOn */
    userIds?: number[] | null;
    payRateJobsiteAddOnReqs: PayRateJobsiteAddOnReq[];
}

export interface CreatePayRateShiftDurationAddOnReq {
    /** Optionally specify this to assign users to the AddOn */
    userIds?: number[] | null;
    payRateShiftDurationAddOnReqs: PayRateShiftDurationAddOnReq[];
}

export interface CreatePayRateShiftTimeAddOnReq {
    /** Optionally specify this to assign users to the AddOn */
    userIds?: number[] | null;
    payRateShiftTimeAddOnReqs: PayRateShiftTimeAddOnReq[];
}

export interface CreatePayrollLineItemReq {
    userId?: number;
    /** Date on which the Shift happened (time should be 00:00:00) */
    dateLocal: string;
    /** Date cell as read from Payroll Excel. */
    dateLocalBeforeParsing?: string | null;
    jobsiteId?: number;
    /** AM, PM, 0 , MD, null */
    shift?: string | null;
    /** numeric , optional */
    hours?: number;
    comments?: string | null;
    /** numeric, optional */
    adjustments?: number;
    paidStartDateTimeLocal?: string | null;
    paidEndDateTimeLocal?: string | null;
    creditNote?: string | null;
}

/** Wrapper for CreatePayrollLineItemReq containg errors and other stuff for to display UI */
export interface CreatePayrollLineItemToUiReq {
    userId?: number;
    /** Date on which the Shift happened (time should be 00:00:00) */
    dateLocal: string;
    /** Date cell as read from Payroll Excel. */
    dateLocalBeforeParsing?: string | null;
    jobsiteId?: number;
    /** AM, PM, 0 , MD, null */
    shift?: string | null;
    /** numeric , optional */
    hours?: number;
    comments?: string | null;
    /** numeric, optional */
    adjustments?: number;
    paidStartDateTimeLocal?: string | null;
    paidEndDateTimeLocal?: string | null;
    creditNote?: string | null;
    /** Row number form excel sheet (1 based index) */
    rowNo?: number;
    rowError?: string | null;
}

export interface CreateShiftCommentReq {
    /** 4000 char comment */
    text: string;
    shiftCommentTypeId?: number;
}

export interface DateTimeInterval15Days {
    startTimeUtc?: string;
    /** Must be within 15 days of Api.Poco.Common.DateTimeInterval15Days.StartTimeUtc
Must be greater than Api.Poco.Common.DateTimeInterval15Days.StartTimeUtc */
    endTimeUtc?: string;
}

export interface DateTimeInterval31Days {
    startTimeUtc?: string;
    /** Must be within 30 days of Api.Poco.Common.DateTimeInterval31Days.StartTimeUtc
Must be greater than Api.Poco.Common.DateTimeInterval31Days.StartTimeUtc */
    endTimeUtc?: string;
}

export interface DateTimeInterval370Days {
    startTimeUtc?: string;
    /** Must be within 30 days of Api.Poco.Common.DateTimeInterval370Days.StartTimeUtc
Must be greater than Api.Poco.Common.DateTimeInterval370Days.StartTimeUtc */
    endTimeUtc?: string;
}

export interface DateTimeInterval8Days {
    startTimeUtc?: string;
    /** Must be within 8 days of Api.Poco.Common.DateTimeInterval8Days.StartTimeUtc
Must be greater than Api.Poco.Common.DateTimeInterval8Days.StartTimeUtc */
    endTimeUtc?: string;
}

export interface DateTimeIntervalUtc {
    startTimeUtc?: string;
    /** Must be greater than Api.Poco.Common.DateTimeIntervalUtc.StartTimeUtc */
    endTimeUtc?: string;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export interface DeleteShiftMediaReq {
    shiftId: number;
    mediaFileIds: number[];
}

export interface DequeuePayrollPeriodAReq {
    companyId?: number;
    /** Id of the PayrollPeriod */
    payrollPeriodId?: number;
}

export interface DriverWeeklyAggregateReq {
    companyId?: number;
    dateOnly?: string;
}

export interface DriverWeeklyAggregateRes {
    id?: number;
    /** Week start, usually Monday */
    startTimeUtc?: string;
    /** Week end, usually Sunday */
    endTimeUtc?: string;
    user?: UserMinRes;
    state?: StateRes;
    /** Sum of !:PayrollLineItem.Pay */
    payrollLineItemPayAggregated?: number;
    /** Sum of !:PayrollLineItem.Hours */
    payrollLineItemHoursAggregated?: number;
    /** Sum of !:ShiftNR.ActualWorkingHours */
    timesheetHoursAggregated?: number;
    /** Sum of !:ShiftNR.HasBreach when true */
    timesheetBreachesCount?: number;
    /** Average of !:Shift.OtdPercentage */
    shiftOtdPercentageAverage?: number | null;
    /** Sum of !:ShiftNR.AMOrPM when it is AM */
    shiftAmCount?: number;
    /** Sum of !:ShiftNR.AMOrPM when it is PM */
    shiftPmCount?: number;
}

/** Driving LicenseClass available on a Driving License */
export enum DrivingLicenseClass {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum EdmContainerElementKind {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum EdmExpressionKind {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _25 = 25,
}

export enum EdmSchemaElementKind {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum EdmTypeKind {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export interface EmailInvoiceReq {
    companyId: number;
    /** Optionally set this to TRue to send a copy of the Company.NotificationEmail */
    copyToNotificationEmail?: boolean;
    /** e.g Feb 2022 */
    invoiceMonthYear?: string | null;
    /** Date by which this invoice is due */
    dueDateUtc?: string;
    billingItems: BillingItem[];
    subTotal?: number;
    discount?: number;
    gst?: number;
    total?: number;
    pdfServiceType?: PdfServiceType;
    /** If true, the Api.Poco.Dtos.Company.CompanyRes.AutomatedSmsRemaining and Api.Poco.Dtos.Company.CompanyRes.ManualSmsRemaining will be reset */
    resetSmsLimits?: boolean;
}

export enum EmploymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export interface EnqueuePayrollPeriodReq {
    /** Id of the PayrollPeriod */
    id?: number;
    /** Pay Date (in Josbite's Timezone) when the payment was made.
e.g. If set to 11/12/2022. It will indicate that all payments in this PayrollPeriod were made on this date in Jobsite's Timezone. */
    payDateLocal?: string;
}

export interface EnumRes {
    id?: number;
    value?: string | null;
}

/** An object of this class would be sent as a response, when as exception is thrown or an error occurs. */
export interface ErrorDto {
    /** The UTC when this exception was being handled. */
    dateTimeUtc?: string;
    /** The Id that has been logged by the ErrorLogger. 
The end user may be prompted to send this to the customer care to help fixing the causing issue. 
This is used to search the LogEntries table.
An Guid.Empty value indicates that there was exception thrown by ErrorLogger itself. */
    errorReference?: string | null;
    errorType?: ErrorType;
    /** The summarized, user-friendly title for the exception */
    title?: string | null;
    /** Certain types of business exception have a unique code.
E.g. ErrorType.Action
Such codes can be used by the UI to uniquely identify an error and redirect the user to a custom UI action. */
    code?: string | null;
    /** Userfriendly error messages. */
    messages?: string[] | null;
    /** Optional additional data about the error
e.g. Api.Poco.Contracts.Errors.JotformBusinessException will populate this with image of the web page */
    errorData?: { [key: string]: string; } | null;
}

export enum ErrorType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface ExpenseApproveReq {
    id?: number;
}

export interface ExpenseReq {
    amount?: number;
    description?: string | null;
}

export interface ExpenseRes {
    id?: number;
    /** Utc timestamp when this entity was created */
    createdOnUtc?: string;
    /** Utc timestamp when this entity was last updated */
    updatedOnUtc?: string;
    incurredByUser?: UserRes;
    approvedByUser?: UserRes;
    approvedOnUtc?: string | null;
    amount?: number;
    description?: string | null;
}

/** Provides for paginated results. */
export interface ExpenseResPage {
    /** The collection of objects belonging to this page. */
    items?: ExpenseRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface ExtCompanyRes {
    id?: number;
    /** Name of the external Company e.g. Linfox */
    name?: string | null;
    /** Name of a Company in our system, used in external systems such as JotForm */
    extCompanyJotformName?: string | null;
    /** EmailId to send notifications such as ShiftStart Precheck questions to Linfox
Note: Keep this empty/null to avoid sending email notifications to ExtCompany */
    notificationEmail?: string | null;
    /** Id of Company in our system that has a contract with this external Company */
    companyId?: number;
    extForms?: ExtFormRes[] | null;
}

export interface ExtFormReq {
    /** E.G JotForm url */
    url: string;
    extFormType?: ExtFormType;
    stateId?: number;
}

export interface ExtFormRes {
    blobName?: string | null;
    fileName?: string | null;
    description?: string | null;
    blobType?: BlobType;
    sasToken?: string | null;
    sasUrl?: string | null;
    expiresOnUtc?: string;
    createdOnUtc?: string | null;
    id?: number;
    /** E.G JotForm */
    url?: string | null;
    extFormType?: ExtFormType;
    state?: StateRes;
}

export enum ExtFormType {
    _1 = 1,
}

/** Name of the external Api provider e.g. GeoTab, GeoTab etc */
export enum ExternalApiProviderType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export interface FleetIoDashboardConfigJson {
    /** This was previously separate lists. 
Now we have FleetIoFormType to distinguish hence combined into a single list. */
    forms?: FleetIoForm[] | null;
}

export interface FleetIoExecuteQueryReq {
    actionId?: number;
    /** Some API Keys are specific to states. In case data for that state is required then specify this. */
    stateId?: number;
    queryParams?: { [key: string]: string; } | null;
    /** Query given by ActionId will already have QuerySTring parameters. But some paramsters are dynamic, they need can be specifed here.
e.g. start_cursor can change with every page
     { "start_cursor", "eyJjcmVhdGVkX2F0IjoiMjAyN" } */
    addtionalQueryStringParams?: { [key: string]: string; } | null;
    bodyJsonObject?: JsonNode;
}

export interface FleetIoForm {
    /** FleetIo Form Id */
    id?: number;
    /** FleetIo Form title or name */
    name?: string | null;
    /** TruckSight StateIds
Form applies/used for these States
When null, it applies to all states */
    stateIds?: number[] | null;
    fleetIoFormType?: FleetIoFormType;
}

export enum FleetIoFormType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface FleetIoQueryAppRoleMapRes {
    fleetIoQueryId?: number;
    appRoleId?: number;
    appRole?: AppRoleRes;
}

export interface FleetIoQueryReq {
    /** e.g. api/v2/issues */
    endpointUri: string;
    queryTemplate?: string | null;
    /** Unique user specified ActionId that is sent by UI and used by API to determine which query to fetch from DB and execute.
This is similar to Id but user specified for a better control. */
    actionId: number;
    description?: string | null;
    httpVerb?: HttpVerb;
    companyId?: number;
}

export interface FleetIoQueryRes {
    id?: number;
    /** e.g. api/v2/issues */
    endpointUri?: string | null;
    queryTemplate?: string | null;
    /** Unique user specified ActionId that is sent by UI and used by API to determine which query to fetch from DB and execute.
This is similar to Id but user specified for a better control. */
    actionId?: number;
    description?: string | null;
    httpVerb?: HttpVerb;
    companyId?: number;
    fleetIoQueryAppRoleMap?: FleetIoQueryAppRoleMapRes[] | null;
}

/** Provides for paginated results. */
export interface FleetIoQueryResPage {
    /** The collection of objects belonging to this page. */
    items?: FleetIoQueryRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface ForgotPasswordReq {
    email: string;
}

export interface ForgotPasswordRes {
    resetPasswordUrl?: string | null;
}

/** This will be stored as JSON in FormSubmissions table Avoid generics here since JsonPolymorphic does not work well with it https://stackoverflow.com/a/77522841/1508398 https://learn.microsoft.com/en-us/dotnet/standard/serialization/system-text-json/polymorphism?pivots=dotnet-8-0 */
export interface FormAnswerBase {
    discriminator: FormQuestionType;
    formQuestionId: string;
    /** Label/question */
    title: string;
    /** Validation Errors */
    errors?: string[] | null;
    /** ChildAnswers, if any */
    childAnswers?: FormAnswerBase[] | null;
}

/** This will be stored as JSON in FormSubmissions table https://stackoverflow.com/a/77522841/1508398 https://learn.microsoft.com/en-us/dotnet/standard/serialization/system-text-json/polymorphism?pivots=dotnet-8-0 */
export interface FormAnswerBaseReq {
    discriminator: FormQuestionType;
    formId: number;
    formQuestionId: string;
}

/** This will be stored as JSON in FormSubmissions table https://stackoverflow.com/a/77522841/1508398 https://learn.microsoft.com/en-us/dotnet/standard/serialization/system-text-json/polymorphism?pivots=dotnet-8-0 */
export interface FormAnswerBaseRes {
    discriminator: FormQuestionType;
    formQuestionId: string;
    /** Label/question */
    title: string;
    /** Validation Errors */
    errors?: string[] | null;
    /** ChildAnswers, if any */
    childAnswers?: FormAnswerBase[] | null;
}

export interface FormAnswerMedia extends FormAnswerBase {
    companyId?: number;
    formId?: number;
    formSubmissionId?: number;
    /** Media file names/GUIDs with file extension */
    answers?: string[] | null;
}

export interface FormAnswerMediaReq extends FormAnswerBaseReq {
    /** Media file names/GUIDs with file extension */
    answers?: string[] | null;
}

export interface FormAnswerMediaRes extends FormAnswerBaseRes {
    companyId?: number;
    formId?: number;
    formSubmissionId?: number;
    /** Media file names/GUIDs with file extension */
    answers?: string[] | null;
    /** Sas Urls from where file in Api.Poco.Dtos.FormAnswer.FormAnswerMediaRes.Answers can be downloaded */
    answerSasUrls?: string[] | null;
}

export interface FormAnswerMultiChoice extends FormAnswerBase {
    answers?: string[] | null;
}

export interface FormAnswerMultiChoiceReq extends FormAnswerBaseReq {
    answers?: string[] | null;
}

export interface FormAnswerMultiChoiceRes extends FormAnswerBaseRes {
    answers?: string[] | null;
}

export interface FormAnswerNumeric extends FormAnswerBase {
    answer?: number | null;
}

export interface FormAnswerNumericReq extends FormAnswerBaseReq {
    answer?: number | null;
}

export interface FormAnswerNumericRes extends FormAnswerBaseRes {
    answer?: number | null;
}

export interface FormAnswerSignature extends FormAnswerBase {
    companyId?: number;
    formId?: number;
    formSubmissionId?: number;
    /** Image file name/GUID with file extension */
    answer?: string | null;
}

export interface FormAnswerSignatureReq extends FormAnswerBaseReq {
    /** Image file name/GUID with file extension */
    answer?: string | null;
}

export interface FormAnswerSignatureRes extends FormAnswerBaseRes {
    companyId?: number;
    formId?: number;
    formSubmissionId?: number;
    /** Image file name/GUID with file extension */
    answer?: string | null;
    /** Sas Urls from where file in Api.Poco.Dtos.FormAnswer.FormAnswerSignatureRes.Answer can be downloaded */
    answerSasUrl?: string | null;
}

export interface FormAnswerSingleChoice extends FormAnswerBase {
    answer?: string | null;
}

export interface FormAnswerSingleChoiceReq extends FormAnswerBaseReq {
    answer?: string | null;
}

export interface FormAnswerSingleChoiceRes extends FormAnswerBaseRes {
    answer?: string | null;
}

export interface FormAnswerTextual extends FormAnswerBase {
    answer?: string | null;
}

export interface FormAnswerTextualReq extends FormAnswerBaseReq {
    answer?: string | null;
}

export interface FormAnswerTextualRes extends FormAnswerBaseRes {
    answer?: string | null;
}

export interface FormLink {
    title?: string | null;
    /** Hyper link */
    link?: string | null;
}

/** This will be stored as JSON in the Forms table */
export interface FormQuestionBase {
    discriminator: FormQuestionType;
    /** GUID */
    id: string;
    /** Order on the current page */
    order?: number;
    questionType: FormQuestionType;
    /** Label/question */
    title: string;
    /** Explaination of the label/question */
    subTitle?: string | null;
    /** PageNumber that this Field belong on.
Form Questions should always be grouped by Api.Poco.Dtos.FormQuestion.JsonModels.FormQuestionBase.PageNumber on the UI. */
    pageNumber?: number | null;
    /** Indicates at least 1 item is needed in Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerTextual.Answer */
    required?: boolean;
    /** ChildQuestions, if any
Note: Child can't further have Child */
    childQuestions?: FormQuestionTextual[] | null;
    /** Validation Errors */
    errors?: string[] | null;
}

/** This will be stored as JSON in the Forms table */
export interface FormQuestionBaseReq {
    discriminator: FormQuestionType;
    /** Order on the current page */
    order?: number;
    questionType: FormQuestionType;
    /** Label/question */
    title: string;
    /** Explaination of the label/question */
    subTitle?: string | null;
    /** PageNumber that this Field belong on.
Form Questions should always be grouped by Api.Poco.Dtos.FormQuestion.FormQuestionBaseReq.PageNumber on the UI. */
    pageNumber?: number | null;
    /** Indicates at least 1 item is needed in the for example Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerTextual.Answer for a text questions */
    required?: boolean;
}

export interface FormQuestionBaseRes {
    discriminator: FormQuestionType;
    /** GUID */
    id?: string;
    /** Order on the current page */
    order?: number;
    questionType?: FormQuestionType;
    /** Label/question */
    title?: string | null;
    /** Explaination of the label/question */
    subTitle?: string | null;
    /** PageNumber that this Field belong on.
Form Questions should always be grouped by Api.Poco.Dtos.FormQuestion.FormQuestionBaseRes.PageNumber on the UI. */
    pageNumber?: number | null;
    /** Indicates at least 1 item is needed in Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerTextual.Answer */
    required?: boolean;
    /** ChildQuestions, if any
Note: ChildFormFields can't further have ChildFormFields */
    childQuestions?: FormQuestionTextual[] | null;
    /** Validation Errors */
    errors?: string[] | null;
}

export interface FormQuestionMedia extends FormQuestionBase {
    /** Minimum number of files required */
    minimumFilesLimit?: number | null;
    /** Maximum number of files permitted */
    maximumFilesLimit?: number | null;
}

export interface FormQuestionMediaReq extends FormQuestionBaseReq {
    /** Minimum number of files required */
    minimumFilesLimit?: number | null;
    /** Maximum number of files permitted */
    maximumFilesLimit?: number | null;
}

export interface FormQuestionMediaRes extends FormQuestionBaseRes {
    /** Minimum number of files required */
    minimumFilesLimit?: number | null;
    /** Maximum number of files permitted */
    maximumFilesLimit?: number | null;
}

export interface FormQuestionMultiChoice extends FormQuestionBase {
    /** Choices to show in the dropdown for user to choose/select from. */
    choices?: string[] | null;
}

export interface FormQuestionMultiChoiceReq extends FormQuestionBaseReq {
    /** Choices to show in the dropdown for user to choose/select from. */
    choices?: string[] | null;
}

export interface FormQuestionMultiChoiceRes extends FormQuestionBaseRes {
    /** Choices to show in the dropdown for user to choose/select from. */
    choices?: string[] | null;
}

export interface FormQuestionNumeric extends FormQuestionBase {
    formQuestionNumericRestrictionType?: FormQuestionNumericRestrictionType;
    /** Used for validating all types of Api.Poco.Dtos.FormQuestion.JsonModels.FormQuestionNumeric.FormQuestionNumericRestrictionType
Used as lower limit to validate Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.Between
    and Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.NotBetween */
    restrictionInput1?: number | null;
    /** Used as upper limit to validate Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.Between
    and Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.NotBetween */
    restrictionInput2?: number | null;
}

export interface FormQuestionNumericReq extends FormQuestionBaseReq {
    formQuestionNumericRestrictionType?: FormQuestionNumericRestrictionType;
    /** Used for validating all types of Api.Poco.Dtos.FormQuestion.FormQuestionNumericReq.FormQuestionNumericRestrictionType
Used as lower limit to validate Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.Between
    and Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.NotBetween */
    restrictionInput1?: number | null;
    /** Used as upper limit to validate Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.Between
    and Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.NotBetween */
    restrictionInput2?: number | null;
}

export interface FormQuestionNumericRes extends FormQuestionBaseRes {
    formQuestionNumericRestrictionType?: FormQuestionNumericRestrictionType;
    /** Used for validating all types of Api.Poco.Dtos.FormQuestion.FormQuestionNumericRes.FormQuestionNumericRestrictionType
Used as lower limit to validate Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.Between
    and Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.NotBetween */
    restrictionInput1?: number | null;
    /** Used as upper limit to validate Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.Between
    and Api.Poco.Common.Enums.FormQuestionNumericRestrictionType.NotBetween */
    restrictionInput2?: number | null;
}

export enum FormQuestionNumericRestrictionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export interface FormQuestionSignature extends FormQuestionBase {
}

export interface FormQuestionSignatureReq extends FormQuestionBaseReq {
}

export interface FormQuestionSignatureRes extends FormQuestionBaseRes {
}

export interface FormQuestionSingleChoice extends FormQuestionBase {
    /** Choices to show in the dropdown for user to choose/select from. */
    choices?: string[] | null;
}

export interface FormQuestionSingleChoiceReq extends FormQuestionBaseReq {
    /** Choices to show in the dropdown for user to choose/select from. */
    choices?: string[] | null;
}

export interface FormQuestionSingleChoiceRes extends FormQuestionBaseRes {
    /** Choices to show in the dropdown for user to choose/select from. */
    choices?: string[] | null;
}

export interface FormQuestionTextual extends FormQuestionBase {
    /** Used to validate each item in Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerTextual.Answer
Can be a Regex from RegularExpressions table or a free text set by user */
    regularExpression?: string | null;
    /** Name to display on the UI */
    regularExpressionName?: string | null;
    /** Simply indicates UI to show multiple lines/bigger TextArea/InputArea */
    isMultiline?: boolean;
}

export interface FormQuestionTextualReq extends FormQuestionBaseReq {
    /** Used to validate each item in for exmaple Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerTextual.Answer for text question
Can be a Regex from RegularExpressions table or a free text set by user */
    regularExpression?: string | null;
    /** Name to display on the UI */
    regularExpressionName?: string | null;
    /** Simply indicates UI to show multiple lines/bigger TextArea/InputArea */
    isMultiline?: boolean;
}

export interface FormQuestionTextualRes extends FormQuestionBaseRes {
    /** Used to validate each item in Api.Poco.Dtos.FormAnswer.JsonModels.FormAnswerTextual.Answer
Can be a Regex from RegularExpressions table or a free text set by user */
    regularExpression?: string | null;
    /** Name to display on the UI */
    regularExpressionName?: string | null;
    /** Simply indicates UI to show multiple lines/bigger TextArea/InputArea */
    isMultiline?: boolean;
}

/** Question/AnswerType */
export enum FormQuestionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export interface FormReq {
    name: string;
    description?: string | null;
    onOpenMessage?: string | null;
    onCompleteMessage?: string | null;
    formLinks?: FormLink[] | null;
    formType?: FormType;
    /** Null implies form can be submitted by anyone in the Company */
    appRoles?: string[] | null;
}

export interface FormRes {
    id?: number;
    companyId: number;
    name?: string | null;
    description?: string | null;
    formQuestions?: FormQuestionTextualRes[] | null;
    onOpenMessage?: string | null;
    onCompleteMessage?: string | null;
    formLinks?: FormLink[] | null;
    createdByUser?: UserMinRes;
    createdOnUtc?: string;
    updatedOnUtc?: string;
    formType?: FormType;
    /** Deactive forms can't be submitted */
    isActive?: boolean;
    formToAppRoleMap?: FormToAppRoleMapRes[] | null;
}

export interface FormSubmissionDeleteMediaFileReq {
    formSubmissionId: number;
    formQuestionId: string;
    /** File name with extension */
    mediaFileName?: string | null;
}

export interface FormSubmissionDeleteMediaFileRes {
    formSubmissionId?: number;
    formQuestionId?: string;
    /** File name with GUID and extension */
    mediaFileName?: string | null;
}

export interface FormSubmissionMediaFileRes {
    formId?: number;
    formSubmissionId?: number;
    /** File name with GUID and extension */
    mediaFileName?: string | null;
    mediaFileSASUrl?: string | null;
}

export interface FormSubmissionRes {
    id?: number;
    companyId: number;
    /** We may want CompanyId as well here instead.
Do we want to remove FormId since we will have the entire form template here? */
    formId?: number;
    /** User who submitted */
    userId?: number;
    user?: UserMinRes;
    /** Each form can have upto 50 fields */
    formAnswers?: FormAnswerBaseRes[] | null;
    createdOnUtc?: string;
    updatedOnUtc?: string;
    /** Not null value for this indicates form was submitted.
A submitted form can't be changed.
If FormFields have errors this will be null */
    submittedOnUtc?: string | null;
    /** Shift associated with this form, if any */
    shiftId?: number | null;
}

export interface FormToAppRoleMapRes {
    appRole?: AppRoleRes;
}

export enum FormType {
    _0 = 0,
}

export interface GeneratePayrollReq {
    /** PayrollPeriod for which to generate Payroll (PayrollLineItems and PayrollSummaries) */
    payrollPeriodId?: number;
}

export interface GeoLocationReq {
    latitude?: number;
    longitude?: number;
}

export interface GetFormSubmissionsReq {
    dateTimeInterval: DateTimeInterval15Days;
    formIds?: number[] | null;
}

export interface GoogleSheetHtmlTemplatePageRes {
    id?: number;
    /** Unique name of the Tab in Google Sheet */
    tabName?: string | null;
    googleSheetId?: number;
}

export interface GoogleSheetHtmlTemplateReq {
    /** Unique name of the Tab in Google Sheet */
    tabName: string;
    /** HTML template */
    template: string;
    googleSheetId?: number;
}

export interface GoogleSheetHtmlTemplateRes {
    id?: number;
    /** Unique name of the Tab in Google Sheet */
    tabName?: string | null;
    /** HTML template */
    template?: string | null;
    googleSheetId?: number;
}

export interface GoogleSheetReq {
    url: string;
    googleSheetType?: GoogleSheetType;
    /** Company to which this belongs */
    companyId?: number;
    stateId?: number | null;
}

export interface GoogleSheetRes {
    id?: number;
    url: string;
    googleSheetType?: GoogleSheetType;
    updatedOnUtc?: string;
    /** Company to which this belongs */
    companyId?: number;
    stateId?: number | null;
    googleSheetHtmlTemplates?: GoogleSheetHtmlTemplateRes[] | null;
}

/** Provides for paginated results. */
export interface GoogleSheetResPage {
    /** The collection of objects belonging to this page. */
    items?: GoogleSheetRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum GoogleSheetType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export interface HtmlStringToPdfReq {
    masterPassword?: string | null;
    password?: string | null;
    htmlFileContent: string;
    pdfServiceType?: PdfServiceType;
}

/** DTO for UI */
export interface HttpExecuteQueryReq {
    actionId?: number;
    queryParams?: { [key: string]: string; } | null;
    /** Query given by ActionId will already have QuerySTring parameters. But some paramsters are dynamic, they need can be specifed here.
e.g. start_cursor can change with every page
     { "start_cursor", "eyJjcmVhdGVkX2F0IjoiMjAyN" } */
    additionalQueryStringParams?: { [key: string]: string; } | null;
    headers?: { [key: string]: string; } | null;
    bodyJsonObject?: JsonNode;
}

export interface HttpQueryAppRoleMapRes {
    httpQueryId?: number;
    appRoleId?: number;
    appRole?: AppRoleRes;
}

export interface HttpQueryReq {
    /** e.g. https://api.fleetio.com */
    apiBaseUrl: string;
    /** e.g. api/v2/issues */
    endpointUri: string;
    queryTemplate?: string | null;
    /** Unique user specified ActionId that is sent by UI and used by API to determine which query to fetch from DB and execute.
This is similar to Id but user specified for a better control. */
    actionId: number;
    description?: string | null;
    httpVerb?: HttpVerb;
    externalApiProvider?: ExternalApiProviderType;
    companyId?: number;
}

export interface HttpQueryRes {
    id?: number;
    /** e.g. https://api.fleetio.com */
    apiBaseUrl?: string | null;
    /** e.g. api/v2/issues */
    endpointUri?: string | null;
    queryTemplate?: string | null;
    /** Unique user specified ActionId that is sent by UI and used by API to determine which query to fetch from DB and execute.
This is similar to Id but user specified for a better control. */
    actionId?: number;
    description?: string | null;
    httpVerb?: HttpVerb;
    externalApiProvider?: ExternalApiProviderType;
    companyId?: number;
    httpQueryAppRoleMap?: HttpQueryAppRoleMapRes[] | null;
}

/** Provides for paginated results. */
export interface HttpQueryResPage {
    /** The collection of objects belonging to this page. */
    items?: HttpQueryRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum HttpVerb {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export interface IEdmDirectValueAnnotationsManager {
}

export interface IEdmEntityContainer {
    readonly name?: string | null;
    schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | null;
    readonly elements?: IEdmEntityContainerElement[] | null;
}

export interface IEdmEntityContainerElement {
    readonly name?: string | null;
    containerElementKind?: EdmContainerElementKind;
    container?: IEdmEntityContainer;
}

export interface IEdmExpression {
    expressionKind?: EdmExpressionKind;
}

export interface IEdmModel {
    readonly schemaElements?: IEdmSchemaElement[] | null;
    readonly vocabularyAnnotations?: IEdmVocabularyAnnotation[] | null;
    readonly referencedModels?: IEdmModel[] | null;
    readonly declaredNamespaces?: string[] | null;
    directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager;
    entityContainer?: IEdmEntityContainer;
}

export interface IEdmSchemaElement {
    readonly name?: string | null;
    schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | null;
}

export interface IEdmTerm {
    readonly name?: string | null;
    schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | null;
    type?: IEdmTypeReference;
    readonly appliesTo?: string | null;
    readonly defaultValue?: string | null;
}

export interface IEdmType {
    typeKind?: EdmTypeKind;
}

export interface IEdmTypeReference {
    readonly isNullable?: boolean;
    definition?: IEdmType;
}

export interface IEdmVocabularyAnnotatable {
}

export interface IEdmVocabularyAnnotation {
    readonly qualifier?: string | null;
    term?: IEdmTerm;
    target?: IEdmVocabularyAnnotatable;
    value?: IEdmExpression;
    readonly usesDefault?: boolean;
}

export interface IdsReq {
    ids: number[];
}

export interface ImportPayrollLineItemsFromGoogleSheetToUiReq {
    payrollPeriodId?: number;
}

export interface ImportShiftFromGoogleSheetReq {
    stateId?: number;
    /** For GoogleSheets that are shared between states, use this flag to enforce usage of the selected StateId
e.g. For QNS sheet, if this is true and StateId is Id for QLD, then all the rows will be imported as QLD rows */
    enforceState?: boolean;
    /** When true, while importing shift from Googlesheet if a CSAId is missing from Trucksight, that Shift will be ignored. */
    ignoreMissingUsers?: boolean;
    /** When true, API will import Shifts from the CFC Google Sheet. */
    importCfcShift?: boolean;
    /** When true, API will import Shifts from the Metro Google Sheet. */
    importMetroShift?: boolean;
    /** The Date for which this schdeule is for (starts on) */
    startDateUtc?: string;
    /** The Date for which this schedule ends on */
    endDateUtc?: string;
    /** Instructions to be appended to existing instructions imported from Google Sheet.
They will be appended to all imported Shifts. */
    instructions?: string | null;
    /** if true then all assigned Drivers will be notified that they have been assigned a new shift */
    notifyAssignedDrivers?: boolean;
    /** When true, ShiftNr from previous day will be used to check for potential breaches before creating new shifts. */
    validatePotentialBreaches?: boolean;
}

export interface ImportShiftFromGoogleSheetToUiReq {
    stateId?: number;
    /** For GoogleSheets that are shared between states, use this flag to enforce usage of the selected StateId
e.g. For QNS sheet, if this is true and StateId is Id for QLD, then all the rows will be imported as QLD rows */
    enforceState?: boolean;
    /** When true, while importing shift from Googlesheet if a CSAId is missing from Trucksight, that Shift will be ignored. */
    ignoreMissingUsers?: boolean;
    /** When true, API will import Shifts from the CFC Google Sheet. */
    importCfcShift?: boolean;
    /** When true, API will import Shifts from the Metro Google Sheet. */
    importMetroShift?: boolean;
    /** The Date for which this schdeule is for (starts on) */
    startDateUtc?: string;
    /** The Date for which this schedule ends on */
    endDateUtc?: string;
    /** Instructions to be appended to existing instructions imported from Google Sheet.
They will be appended to all imported Shifts. */
    instructions?: string | null;
}

export interface ImportShiftFromGoogleSheetToUiShiftRes {
    scheduledShiftReq?: ScheduledShiftReq;
    shiftPotentialBreach?: ShiftPotentialBreach;
    user?: UserRes;
    vehicle?: VehicleMinRes;
}

export interface ImportStaffReq {
    firstName: string;
    middleName?: string | null;
    lastName: string;
    /** Mobile phone */
    phoneNumber: string;
    email: string;
    /** The Role of the Staff e.g. Manager or Driver etc */
    role: string;
    address: AddressReq;
    /** External Driver Id
Only applicable for Drivers */
    extDriverId?: string | null;
    abn?: string | null;
    dateOfBirthUtc?: string | null;
    payRate?: PayRateReq;
    emergencyContactFullName?: string | null;
    emergencyContactPhone?: string | null;
    drivingLicenseNumber?: string | null;
    drivingLicenseIssuedByStateId?: number | null;
    drivingLicenseRestriction?: string | null;
    drivingLicenseFirstIssuedOnUtc?: string | null;
    /** Driving License expires on this UTC date time. 
Only applicable for Drivers */
    drivingLicenseExpiresOnUTC?: string | null;
    visaType?: string | null;
    visaExpiryDateUtc?: string | null;
    rsatCertificateNumber?: string | null;
    rsatExpiryDateUtc?: string | null;
    drivingRecordEmissionDateUtc?: string | null;
    australianFederalPoliceCheckEmissionDateUtc?: string | null;
    employmentType?: EmploymentType;
    appUsagePattern?: AppUsagePattern;
    appUserLicenseClassMapReq?: AppUserLicenseClassMapReq;
    weeklyAvailability?: WeeklyAvailabilityReq;
}

export interface ImportStaffToUiReq {
    firstName: string;
    lastName: string;
    /** Mobile phone */
    phoneNumber: string;
    /** External Driver Id
Only applicable for Drivers */
    extDriverId?: string | null;
    /** Row number form excel sheet (1 based index) */
    rowNo?: number;
    rowError?: string | null;
    /** True when the Staff (Api.Poco.Dtos.Staff.ImportStaffToUiReq.ExtDriverId) already exists in the system */
    alreadyExists?: boolean;
    status?: string | null;
    csaExit?: string | null;
    refresherTrainingDate?: string | null;
}

export interface InviteStaffMinReq {
    firstName: string;
    middleName?: string | null;
    lastName?: string | null;
    /** The Role of the Staff e.g. Manager or Driver etc */
    role: string;
    /** Mobile phone */
    phoneNumber?: string | null;
    email: string;
}

export interface InviteStaffRes {
    /** Message to be displayed to the user. */
    message?: string | null;
    staffUser?: StaffRes;
}

export interface JobsiteMinRes {
    id?: number;
    name?: string | null;
    /** Name as seen in Linfox's system. */
    linfoxName?: string | null;
    /** Although numeric in Linfox system/googlesheet, we use string */
    linfoxStoreNumber?: string | null;
    address?: AddressRes;
}

export interface JobsiteODataRes {
    id?: number;
    name?: string | null;
    /** Name as seen in Linfox's system. */
    linfoxName?: string | null;
    /** Although numeric in Linfox system/googlesheet, we use string */
    linfoxStoreNumber?: string | null;
    isSoftDeleted?: boolean;
    companyId?: number;
    address?: AddressODataRes;
}

export interface JobsiteReq {
    /** Jobsites with Name present is a Permanent Jobsites. These will be shown in dropdowns */
    name?: string | null;
    /** Name as seen in Linfox's system. */
    linfoxName?: string | null;
    linfoxStoreNumber?: string | null;
    address: AddressReq;
}

export interface JobsiteRes {
    id?: number;
    name?: string | null;
    /** Name as seen in Linfox's system. */
    linfoxName?: string | null;
    /** Although numeric in Linfox system/googlesheet, we use string */
    linfoxStoreNumber?: string | null;
    isSoftDeleted?: boolean;
    companyId?: number;
    address?: AddressRes;
}

/** Provides for paginated results. */
export interface JobsiteResPage {
    /** The collection of objects belonging to this page. */
    items?: JobsiteRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface JsonNode {
    options?: JsonNodeOptions;
    parent?: JsonNode;
    root?: JsonNode;
}

export interface JsonNodeOptions {
    propertyNameCaseInsensitive?: boolean;
}

export interface MediaFileRes {
    blobName?: string | null;
    fileName?: string | null;
    description?: string | null;
    blobType?: BlobType;
    sasToken?: string | null;
    sasUrl?: string | null;
    expiresOnUtc?: string;
    createdOnUtc?: string | null;
}

/** Represents Medicare levy thresholds and rates */
export interface MedicareLevyThresholds {
    singleThreshold?: number;
    familyThreshold?: number;
    familyThresholdPerChild?: number;
    rate?: number;
    surchargeRate?: number;
    surchargeThreshold?: number;
}

/** Wraps the common properties required by most of the Response Dtos */
export interface MessageResponseDto {
    /** Represents a userfriendly message. */
    message?: string | null;
}

export interface ODataEntitySetInfo {
    typeAnnotation?: ODataTypeAnnotation;
    url?: string | null;
    name?: string | null;
    title?: string | null;
}

export interface ODataFunctionImportInfo {
    typeAnnotation?: ODataTypeAnnotation;
    url?: string | null;
    name?: string | null;
    title?: string | null;
}

export interface ODataServiceDocument {
    typeAnnotation?: ODataTypeAnnotation;
    entitySets?: ODataEntitySetInfo[] | null;
    singletons?: ODataSingletonInfo[] | null;
    functionImports?: ODataFunctionImportInfo[] | null;
}

export interface ODataSingletonInfo {
    typeAnnotation?: ODataTypeAnnotation;
    url?: string | null;
    name?: string | null;
    title?: string | null;
}

export interface ODataTypeAnnotation {
    readonly typeName?: string | null;
}

export enum OneSignalDeviceType {
    _0 = 0,
    _1 = 1,
}

export interface OneSignalRegisterReq {
    oneSignalDeviceType?: OneSignalDeviceType;
    /** This is the Device Token or Device Id or PNS Handle that the PNS will give to the device
ref: https://docs.microsoft.com/en-us/answers/questions/494160/understand-the-concept-of-instllationid-and-push-c.html
            
This is the Push Token Identifier from Google or Apple.
For Apple Push identifiers, you must strip all non alphanumeric characters.
Examples: iOS: 7abcd558f29d0b1f048083e2834ad8ea4b3d87d8ad9c088b33c132706ff445f0
Android: APA91bHbYHk7aq-Uam_2pyJ2qbZvqllyyh2wjfPRaw5gLEX2SUlQBRvOc6sck1sa7H7nGeLNlDco8lXj83HWWwzV... */
    pushNotificationToken: string;
}

/** Provides for paginated results. */
export interface PagedReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
}

export interface PayCalcWebBotTaxCalculationReq {
    grossAnnualSalary?: number;
    payFrequency?: TaxPayPeriod;
    /** Salay includes super? */
    includeSuper?: boolean;
    /** Specify if different from default */
    superRate?: number | null;
    /** High education contribution scheme e.g. student loan etc */
    hasHECS?: boolean;
    hasPrivateHealthInsurance?: boolean;
    hasMedicareExemption?: boolean;
    dependantChildren?: number | null;
}

export interface PayCalcWebBotTaxCalculationRes {
    taxableIncome?: number;
    incomeTax?: number;
    superannuation?: number;
    takeHomePay?: number;
    payFrequency?: TaxPayPeriod;
}

export interface PayRateJobsiteAddOnAppUserMapRes {
    payRateJobsiteAddOnId?: number;
    userId?: number;
    user?: UserPayrollRes;
}

export interface PayRateJobsiteAddOnReq {
    /** AddOn name */
    name?: string | null;
    /** Amount */
    payRate?: number;
    payRateKind?: PayRateKind;
    payRateType?: PayRateType;
    /** Id of Jobsite over which this AddOn is applicable */
    jobsiteId?: number;
}

export interface PayRateJobsiteAddOnRes {
    id?: number;
    /** AddOn name */
    name?: string | null;
    /** Amount */
    payRate?: number;
    payRateKind?: PayRateKind;
    payRateType?: PayRateType;
    /** Id of Jobsite over which this AddOn is applicable */
    jobsiteId?: number;
    jobsite?: JobsiteMinRes;
    payRateJobsiteAddOnAppUserMap?: PayRateJobsiteAddOnAppUserMapRes[] | null;
}

/** Provides for paginated results. */
export interface PayRateJobsiteAddOnResPage {
    /** The collection of objects belonging to this page. */
    items?: PayRateJobsiteAddOnRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum PayRateKind {
    _0 = 0,
    _1 = 1,
}

export interface PayRateReq {
    /** Absolute Rate in AUD */
    baseRate?: number;
    /** Absolute Rate in AUD */
    publicHolidayRate?: number;
    /** Absolute Rate in AUD */
    afterHoursRate?: number;
    /** Absolute Rate in AUD */
    saturdayRate?: number;
    /** Absolute Rate in AUD */
    sundayRate?: number;
}

export interface PayRateRes {
    id?: number;
    /** Absolute Rate in AUD */
    baseRate?: number;
    /** Absolute Rate in AUD */
    publicHolidayRate?: number;
    /** Absolute Rate in AUD */
    afterHoursRate?: number;
    /** Absolute Rate in AUD */
    saturdayRate?: number;
    /** Absolute Rate in AUD */
    sundayRate?: number;
}

export interface PayRateShiftDurationAddOnAppUserMapRes {
    payRateShiftDurationAddOnId?: number;
    userId?: number;
    user?: UserPayrollRes;
}

export interface PayRateShiftDurationAddOnReq {
    /** AddOn name */
    name?: string | null;
    /** Amount */
    payRate?: number;
    payRateKind?: PayRateKind;
    payRateType?: PayRateType;
    /** Apply this AddOn when Shift worked Hours are equal or above this limit
Format hh:mm */
    shiftDurationLowerLimit?: string | null;
    /** Apply this AddOn when Shift worked Hours are equal or below this limit
Format hh:mm */
    shiftDurationUpperLimit?: string | null;
}

export interface PayRateShiftDurationAddOnRes {
    id?: number;
    /** AddOn name */
    name?: string | null;
    /** Amount */
    payRate?: number;
    payRateKind?: PayRateKind;
    payRateType?: PayRateType;
    /** Apply this AddOn when Shift worked Hours are equal or above this limit
Format hh:mm */
    shiftDurationLowerLimit?: string | null;
    /** Apply this AddOn when Shift worked Hours are equal or below this limit
Format hh:mm */
    shiftDurationUpperLimit?: string | null;
    payRateShiftDurationAddOnAppUserMap?: PayRateShiftDurationAddOnAppUserMapRes[] | null;
}

/** Provides for paginated results. */
export interface PayRateShiftDurationAddOnResPage {
    /** The collection of objects belonging to this page. */
    items?: PayRateShiftDurationAddOnRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface PayRateShiftTimeAddOnAppUserMapRes {
    payRateShiftTimeAddOnId?: number;
    userId?: number;
    user?: UserPayrollRes;
}

export interface PayRateShiftTimeAddOnReq {
    /** AddOn name */
    name?: string | null;
    /** Amount */
    payRate?: number;
    payRateKind?: PayRateKind;
    payRateType?: PayRateType;
    /** Apply this AddOn when Shift start at or after this time
Format HH:mm */
    shiftStartTime?: string | null;
    /** Apply this AddOn when Shift end at or before this time
Format hh:mm */
    shiftEndTime?: string | null;
}

export interface PayRateShiftTimeAddOnRes {
    id?: number;
    /** AddOn name */
    name?: string | null;
    /** Amount */
    payRate?: number;
    payRateKind?: PayRateKind;
    payRateType?: PayRateType;
    /** Apply this AddOn when Shift start at or after this time
Format HH:mm */
    shiftStartTime?: string | null;
    /** Apply this AddOn when Shift end at or before this time
Format hh:mm */
    shiftEndTime?: string | null;
    payRateShiftTimeAddOnAppUserMap?: PayRateShiftTimeAddOnAppUserMapRes[] | null;
}

/** Provides for paginated results. */
export interface PayRateShiftTimeAddOnResPage {
    /** The collection of objects belonging to this page. */
    items?: PayRateShiftTimeAddOnRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

/** PayRateType for multiple types can be indicated in the same flag/field by bit-wise ORing ref: https://stackoverflow.com/a/9811862/1508398 */
export enum PayRateType {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
}

export enum PayRollFrequency {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface PayrollLineItemPagedReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
    /** Specify to filter by payroll period id */
    payrollPeriodId?: number | null;
}

export interface PayrollLineItemRes {
    id?: number;
    /** Date only */
    dateLocal?: string | null;
    /** Date cell as read from Payroll Excel. */
    dateLocalBeforeParsing?: string | null;
    /** AM, PM, 0 , MD, null */
    shift?: string | null;
    /** Will only be used for backward compatibility untill we no longer have data in this column 
when we have shifted to using Jobsite FK.
Note: Show as depreciated on UI */
    store?: string | null;
    /** numeric , optional */
    hours?: number;
    /** Total of hours for the day as noted in timesheets (jotform submitted)
Null indicates that hours not calculated (e.g. old payrolls) */
    timesheetHoursForDay?: number | null;
    payrollTimesheetHoursMismatchType?: PayrollTimesheetHoursMismatchType;
    comments?: string | null;
    /** numeric, optional */
    adjustments?: number;
    payDateLocal?: string | null;
    /** Local Datetinme using Jobsite's TimezoneId */
    paidStartDateTimeLocal?: string | null;
    /** Local Datetinme using Jobsite's TimezoneId */
    paidEndDateTimeLocal?: string | null;
    /** formula:
if(date is weekday, hours*25,if(date is sunday, hours*33, If(date is PH, Hours*36) */
    pay?: number;
    creditNote?: string | null;
    payCalculationLog?: string | null;
    user?: UserPayrollRes;
    jobsiteId?: number;
    jobsite?: JobsiteMinRes;
    /** Timesheets used to calculate Api.Poco.Dtos.PayrollLineItem.PayrollLineItemRes.TimesheetHoursForDay */
    shiftNrs?: ShiftNRRes[] | null;
}

/** Provides for paginated results. */
export interface PayrollLineItemResPage {
    /** The collection of objects belonging to this page. */
    items?: PayrollLineItemRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface PayrollLineItemsGroupedByUserAndDayRes {
    dateUTC?: string;
    user?: UserPayrollRes;
    payrollTimesheetHoursMismatchType?: PayrollTimesheetHoursMismatchType;
    hoursForTheDay?: number;
    timesheetHoursForTheDay?: number | null;
    payrollLineItems?: PayrollLineItemRes[] | null;
}

/** Provides for paginated results. */
export interface PayrollLineItemsGroupedByUserAndDayResPage {
    /** The collection of objects belonging to this page. */
    items?: PayrollLineItemsGroupedByUserAndDayRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface PayrollPeriodMinResA {
    id?: number;
    createdOnUtc?: string;
    startTimeUtc?: string;
    endTimeUtc?: string;
    processedOnUtc?: string | null;
    queuedOnUtc?: string | null;
    payrollPeriodStatus?: PayrollPeriodStatus;
    applicableState?: StateRes;
}

/** Provides for paginated results. */
export interface PayrollPeriodMinResAPage {
    /** The collection of objects belonging to this page. */
    items?: PayrollPeriodMinResA[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface PayrollPeriodPageRes {
    id?: number;
    createdOnUtc?: string;
    startTimeUtc?: string;
    startTimeLocal?: string | null;
    endTimeUtc?: string;
    endTimeLocal?: string | null;
    /** Total outgoing payment during this Payroll Period
Sum of Api.Poco.Dtos.PayrollSummary.PayrollSummaryRes.Total */
    total?: number | null;
    processedOnUtc?: string | null;
    processedOnLocal?: string | null;
    queuedOnUtc?: string | null;
    queuedOnLocal?: string | null;
    payrollPeriodStatus?: PayrollPeriodStatus;
    applicableState?: StateRes;
    createdByUser?: UserMinRes;
}

/** Provides for paginated results. */
export interface PayrollPeriodPageResPage {
    /** The collection of objects belonging to this page. */
    items?: PayrollPeriodPageRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface PayrollPeriodQueueRes {
    id?: number;
    createdOnUtc?: string;
    companyId?: number;
    company?: CompanyARes;
    payrollPeriodId?: number;
    payrollPeriod?: PayrollPeriodMinResA;
}

export interface PayrollPeriodReq {
    /** UI must set this field
This will be assumed to be in Company's local Timezone */
    startTimeLocal?: string;
    /** UI must set this field
This will be assumed to be in Company's local Timezone */
    endTimeLocal?: string;
    /** Id of the State for which this Payroll Period is applicable */
    applicableStateId?: number | null;
}

export interface PayrollPeriodRes {
    id?: number;
    createdOnUtc?: string;
    startTimeUtc?: string;
    startTimeLocal?: string | null;
    endTimeUtc?: string;
    endTimeLocal?: string | null;
    /** Total outgoing payment during this Payroll Period
Sum of Api.Poco.Dtos.PayrollSummary.PayrollSummaryRes.Total */
    total?: number | null;
    processedOnUtc?: string | null;
    processedOnLocal?: string | null;
    queuedOnUtc?: string | null;
    queuedOnLocal?: string | null;
    payrollPeriodStatus?: PayrollPeriodStatus;
    applicableState?: StateRes;
    createdByUser?: UserMinRes;
    payrollSummaries?: PayrollSummaryRes[] | null;
    payrollLineItems?: PayrollLineItemRes[] | null;
}

export enum PayrollPeriodStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface PayrollSummaryPagedReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
    /** Specify to filter by payroll period id */
    payrollPeriodId?: number | null;
}

export interface PayrollSummaryReportReq {
    companyId?: number;
    dateTimeIntervalUtc: DateTimeIntervalUtc;
}

export interface PayrollSummaryReportRes {
    id?: number;
    /** Report was generated for the user Api.Poco.Dtos.PayrollSummary.PayrollSummaryReportRes.User over these payroll periods */
    payrollPeriodIds?: number[] | null;
    /** Sum of Hours worked over Api.Poco.Dtos.PayrollSummary.PayrollSummaryReportRes.PayrollPeriodIds */
    hours?: number;
    /** Sum of TimesheetHours logged over Api.Poco.Dtos.PayrollSummary.PayrollSummaryReportRes.PayrollPeriodIds */
    timesheetHours?: number | null;
    /** Sum of Subtotals over Api.Poco.Dtos.PayrollSummary.PayrollSummaryReportRes.PayrollPeriodIds */
    subtotal?: number;
    /** Sum of Adjustments over Api.Poco.Dtos.PayrollSummary.PayrollSummaryReportRes.PayrollPeriodIds */
    adjustments?: number;
    /** Sum of Gst over Api.Poco.Dtos.PayrollSummary.PayrollSummaryReportRes.PayrollPeriodIds */
    gst?: number;
    /** Sum of Total over Api.Poco.Dtos.PayrollSummary.PayrollSummaryReportRes.PayrollPeriodIds */
    total?: number;
    user?: UserPayrollDetailedRes;
}

export interface PayrollSummaryRes {
    id?: number;
    /** numeric , sum of all Api.Poco.Dtos.PayrollLineItem.PayrollLineItemRes.Hours */
    hours?: number;
    /** numeric , sum of hours worked by the user as indicated in Timesheet (ShiftNR)
null indicates that this was not calculated e.g. for old payrolls */
    timesheetHours?: number | null;
    payrollTimesheetHoursMismatchType?: PayrollTimesheetHoursMismatchType;
    /** numeric , sum of all Api.Poco.Dtos.PayrollLineItem.PayrollLineItemRes.Pay */
    subtotal?: number;
    /** numeric , sum of all Api.Poco.Dtos.PayrollLineItem.PayrollLineItemRes.Adjustments */
    adjustments?: number;
    /** numeric, Api.Poco.Dtos.PayrollSummary.PayrollSummaryRes.Subtotal / 11 */
    gst?: number;
    /** numeric, Api.Poco.Dtos.PayrollSummary.PayrollSummaryRes.Subtotal + Api.Poco.Dtos.PayrollSummary.PayrollSummaryRes.Adjustments + Api.Poco.Dtos.PayrollSummary.PayrollSummaryRes.GST */
    total?: number;
    /** Indicates if this CSA ID (User) was emailed the invoice. 
If this is false, it means that the CSA Id does not exist or is not assigned to a User in our DB */
    invoiceEmailed?: boolean;
    user?: UserPayrollRes;
}

/** Provides for paginated results. */
export interface PayrollSummaryResPage {
    /** The collection of objects belonging to this page. */
    items?: PayrollSummaryRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

/** Used to indicate the kind of mismatch between Timsheet hours (for a day) and payroll hours (for a day) */
export enum PayrollTimesheetHoursMismatchType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** The types of coverters available for Pdf services */
export enum PdfServiceType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface PreCheckAnswerODataRes {
    id?: number;
    /** Answered On */
    createdOnUtc?: string;
    answer?: boolean | null;
    /** Indicates that this question must have a positive answer for the shift to be started */
    isBlocker?: boolean;
    /** Indicates that a Photo must be supplied with the answer */
    requiresPhoto?: boolean;
    /** Blob path/name for the Photo. UI can ignore this. */
    photoBlobName?: string | null;
    /** Url for the Photo */
    photoBlobUrl?: string | null;
    preCheckQuestionId?: number;
    preCheckQuestion?: PreCheckQuestionODataRes;
}

export interface PreCheckAnswerReq {
    answer?: boolean | null;
    photo?: string | null;
    geoLocation?: GeoLocationReq;
    /** Indicates that a Photo must be supplied with the answer */
    requiresPhoto?: boolean;
    preCheckQuestionId?: number;
}

export interface PreCheckAnswerRes {
    id?: number;
    /** Answered On */
    createdOnUtc?: string;
    answer?: boolean | null;
    /** Indicates that this question must have a positive answer for the shift to be started */
    isBlocker?: boolean;
    /** Indicates that a Photo must be supplied with the answer */
    requiresPhoto?: boolean;
    /** Blob path/name for the Photo. UI can ignore this. */
    photoBlobName?: string | null;
    /** Url for the Photo */
    photoBlobUrl?: string | null;
    preCheckQuestion?: PreCheckQuestionRes;
}

export interface PreCheckQuestionODataRes {
    id?: number;
    question?: string | null;
    /** Indicates that this question must have a positive answer for the shift to be started */
    isBlocker?: boolean;
    /** Indicates that a Photo must be supplied with the answer */
    requiresPhoto?: boolean;
    isSoftDeleted?: boolean;
    /** The page on which this question must be display in UI */
    pageNumber?: number;
    companyId?: number;
}

export interface PreCheckQuestionReq {
    question: string;
    /** Indicates that this question must have a positive answer for the shift to be started */
    isBlocker?: boolean;
    /** Indicates that a Photo must be supplied with the answer */
    requiresPhoto?: boolean;
    /** The page on which this question must be display in UI */
    pageNumber?: number;
}

export interface PreCheckQuestionRes {
    id?: number;
    question?: string | null;
    /** Indicates that this question must have a positive answer for the shift to be started */
    isBlocker?: boolean;
    /** Indicates that a Photo must be supplied with the answer */
    requiresPhoto?: boolean;
    isSoftDeleted?: boolean;
    /** The page on which this question must be display in UI */
    pageNumber?: number;
    companyId?: number;
}

/** Provides for paginated results. */
export interface PreCheckQuestionResPage {
    /** The collection of objects belonging to this page. */
    items?: PreCheckQuestionRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface PredefinedShiftCommentReq {
    comment: string;
}

export interface PredefinedShiftCommentRes {
    id?: number;
    companyId?: number;
    comment?: string | null;
}

/** Provides for paginated results. */
export interface PredefinedShiftCommentResPage {
    /** The collection of objects belonging to this page. */
    items?: PredefinedShiftCommentRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface ProcessPayrollPeriodAReq {
    companyId?: number;
    /** Id of the PayrollPeriod */
    id?: number;
}

export interface PublicHolidayReq {
    description?: string | null;
    /** local Date in the State converted to UTC, on which this holiday begins. */
    dateUTC?: string;
    /** State ID (use Enums) */
    stateId?: number;
}

export interface PublicHolidayRes {
    id?: number;
    description?: string | null;
    /** Date on which this holiday begins.
Note: This must be specified as UTC but not actually converted to UTC
      e.g. if date is '2021-05-24' then client must end '2021-05-24T00:00:00Z' */
    dateUTC?: string;
    /** State ID (use EnumsRes) */
    stateId?: number;
}

/** We dont need jobsite here since there is no independant API tp create/update this. Create happens as part of QuickShift creation API, hence timezone calculations are part of that API itself. */
export interface QuickShiftBreakReq {
    /** Format YYYY-MM-DDTHH:mm:ss */
    startTimeLocal?: string;
    /** Foramt YYYY-MM-DDTHH:mm:ss
Must be greater than Api.Poco.Dtos.ShiftBreak.QuickShiftBreakReq.StartTimeLocal */
    endTimeLocal?: string;
    startGeoLocation?: GeoLocationReq;
}

export interface QuickShiftReq {
    /** Actual Start Time
Format YYYY-MM-DDTHH:mm:ss */
    startTimeLocal?: string;
    /** Actual End Time
Format YYYY-MM-DDTHH:mm:ss
Must be greater than Api.Poco.Dtos.Shift.QuickShiftReq.StartTimeLocal */
    endTimeLocal?: string;
    /** Odometer reading at Shift End */
    endOdometerKms?: number | null;
    /** Breaks taken, if any */
    shiftBreaks?: QuickShiftBreakReq[] | null;
    /** Shift Comments, if any */
    shiftComments?: CreateShiftCommentReq[] | null;
}

export interface ReadResponse {
    range?: string | null;
    majorDimension?: string | null;
    values?: any[][] | null;
}

export interface RefreshTokenReq {
    access_Token: string;
    refresh_Token: string;
    client_Id: string;
}

export interface RegisterCompanyOwnerUserReq {
    email: string;
    password: string;
    /** Must be a mobile phone number */
    phoneNumber: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
}

export interface RegisterCompanyReqA {
    name?: string | null;
    /** Australian Business Number */
    abn: string;
    /** Email Id to which notifications such as Shift Start will be sent.
In case this is not available, email will be sent to the Owner's email id */
    notificationEmail?: string | null;
    /** Email Id from which we will receive Linfox Timesheet emails
e.g. this is populated as Contractor email in jotform */
    timesheetSourceEmail?: string | null;
    timesheetSourceEmailNsw?: string | null;
    timesheetSourceEmailVic?: string | null;
    timesheetSourceEmailQld?: string | null;
    timesheetSourceEmailTas?: string | null;
    timesheetSourceEmailAct?: string | null;
    timesheetSourceEmailNt?: string | null;
    timesheetSourceEmailSa?: string | null;
    timesheetSourceEmailWa?: string | null;
    /** Upper limit for maximum number of staff/employes that this company can have with currrent subscription/package
Note: This will be moved to subscription related table when they are implemented. */
    maximumEmployees?: number;
    /** e.g. If this is 200. No SMS sent for this Company should exceed 200 characters.
0 indicates no SMS is to be sent. */
    smsCharacterLimit?: number;
    /** e.g. If this is 500. Only 500 SMS of the type Automated can be sent for this Company. */
    automatedSmsLimit?: number;
    /** e.g. If this is 100. Only 100 SMS of the type Manual can be sent for this Company. */
    manualSmsLimit?: number;
    /** Maximum number of FormsSubmissions that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formSubmissionsLimit?: number;
    /** Maximum number of Forms that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formsLimit?: number;
    /** Maximum number of questions a Api.Poco.Dtos.Forms.FormReq can have */
    formsMaxQuestionsPerFormLimit?: number;
    /** Maximum number of Files (media, photo, document etc) a Api.Poco.Dtos.Forms.FormReq can have */
    formsMaxFilesPerFormLimit?: number;
    /** Maximum number of Files a question (Api.Poco.Dtos.FormQuestion.JsonModels.FormQuestionMedia) can have */
    formsMaxFilesPerQuestionLimit?: number;
    defaultOwner: RegisterCompanyOwnerUserReq;
    address: AddressReq;
    payPeriodStartDay?: DayOfWeek;
    payRollFrequency?: PayRollFrequency;
    /** Details of External Company such as LinFox */
    extCompanies?: CreateExtCompanyReq[] | null;
}

export interface RegisterUserReq {
    email: string;
    password: string;
}

export interface RegularExpressionAReq {
    /** Displayed on UI */
    name?: string | null;
    /** RegEx */
    expression?: string | null;
    description?: string | null;
}

export interface RegularExpressionRes {
    id?: number;
    /** Displayed on UI */
    name?: string | null;
    companyId?: number | null;
    /** RegEx */
    expression?: string | null;
    description?: string | null;
}

export interface ResetPasswordReq {
    /** The Email Id(Url encoded)
Note: The API sends url encoded email id; as a part of the confirm reset password token message. 
This should be sent as the url encoded string. */
    email: string;
    newPassword: string;
    /** The password reset token received in the email. (Url encoded)
Note: The API sends url encoded email id; as a part of the reset password token message. 
This should be sent as the url encoded string. */
    passwordResetToken: string;
}

export interface ScheduleBulkReq {
    scheduledShiftReqs?: ScheduledShiftReq[] | null;
    /** When true, drivers will be notified about the shift assignment */
    notifyDriver?: boolean;
    /** When true, ShiftNr from previous day will be used to check for potential breanches before creating new shifts */
    validatePotentialBreaches?: boolean;
}

export interface ScheduledShiftReq {
    /** If specified then the Driver must reach the Jobsite at this time. */
    driverArrivalTimeLocal?: string | null;
    /** Scheduled Start Time Local
Format YYYY-MM-DDTHH:mm:ss */
    startTimeLocal?: string | null;
    scheduledStartUTC?: string | null;
    /** Scheduled End Time Local
Format YYYY-MM-DDTHH:mm:ss
Must be greater than Api.Poco.Dtos.Shift.ScheduledShiftReq.StartTimeLocal */
    endTimeLocal?: string | null;
    scheduledEndUTC?: string | null;
    /** Driver assigned to this Shift */
    userId?: number | null;
    routeId?: string | null;
    /** Rego, if vehicle has not been listed in Vehicles table */
    unlistedVehicleRego?: string | null;
    scheduledWeight?: number | null;
    scheduledKms?: number | null;
    scheduledDrops?: number | null;
    scheduledDifficulty?: number | null;
    scheduledTotalWorkHours?: number | null;
    hasReload?: boolean | null;
    maxSegmentWeight?: number | null;
    maxTruckWeight?: number | null;
    maxPayload?: number | null;
    /** Instructions for Driver or assigned user */
    instructions?: string | null;
    breachCalculatedUsing?: BreachCalculationType;
    dock?: string | null;
    /** Populated during Google Sheet import only.
Since AM or PM is decided by Linfox there and may not be actual AM or PM */
    amOrPm?: string | null;
    shiftSupervisorName?: string | null;
    shiftSupervisorPhone?: string | null;
    /** Listed vehicle used for this Shift */
    vehicleId?: number | null;
    /** If existing jobsite then UI must set this */
    jobsiteId?: number;
    /** The Company for whos work this Shift was executed.
If null, it means this Shift was for Owner's Cmpany itself */
    extCompanyId?: number | null;
}

export interface SendConfirmEmailTokenReq {
    email: string;
}

export interface ShiftBlob {
    id?: number;
    /** Driver/User undergoing this shift */
    userId?: number;
    startedOnUTC?: string;
    endedOnUTC?: string | null;
}

export interface ShiftBreachBlob {
    createdOnUtc?: string;
    description?: string | null;
    breachingUser?: AppUserBlob;
    /** Shifts, if any, during which this breach recorded.
Not available before starting a new Shift */
    shifts?: ShiftBlob[] | null;
}

export interface ShiftBreachReq {
    companyId?: number;
    /** Day for which the breaches are to be computed */
    onUtc?: string;
}

export interface ShiftBreakODataRes {
    id?: number;
    startedOnLocal?: string | null;
    endedOnLocal?: string | null;
    startedOnUTC?: string | null;
    endedOnUTC?: string | null;
}

export interface ShiftBreakRes {
    id?: number;
    startedOnLocal?: string | null;
    endedOnLocal?: string | null;
    startedOnUTC?: string | null;
    endedOnUTC?: string | null;
}

export interface ShiftCheckinReq {
    /** Shift associated with this Checkin */
    shiftId?: number;
    geoLocation?: GeoLocationReq;
}

/** Combined ShiftComment and JobComment response */
export interface ShiftCommentODataRes {
    id?: number;
    createdOnUtc?: string;
    /** 4000 char comment */
    text?: string | null;
    /** Id of Shift for which this comment was added */
    shiftId?: number;
    createdByUser?: UserODataRes;
    shiftCommentTypeId?: number;
}

export interface ShiftCommentReq {
    /** 4000 char comment */
    text: string;
    shiftCommentTypeId?: number;
    shiftId?: number;
    geoLocation?: GeoLocationReq;
}

/** Combined ShiftComment and JobComment response */
export interface ShiftCommentRes {
    id?: number;
    createdOnUtc?: string;
    /** 4000 char comment */
    text?: string | null;
    /** Id of Shift for which this comment was added */
    shiftId?: number;
    createdByUser?: UserMinRes;
    shiftCommentTypeId?: number;
}

export interface ShiftFleetIoFormSubmissionReq {
    /** Although numeric in FleetIo, we use string here */
    fleetIoFormSubmissionId: string;
    /** The title of the form for which this submission was made */
    fleetIoFormTitle?: string | null;
    fleetIoFormType?: FleetIoFormType;
    /** Date when this was submitted on FleetIo. */
    submittedToFleetIoOnUtc?: string | null;
    shiftId?: number;
}

export interface ShiftFleetIoFormSubmissionRes {
    /** Although numeric in FleetIo, we use string here */
    fleetIoFormSubmissionId: string;
    /** The title of the form for which this submission was made */
    fleetIoFormTitle?: string | null;
    fleetIoFormType?: FleetIoFormType;
    /** Date when this was submitted on FleetIo. */
    submittedToFleetIoOnUtc?: string | null;
    shiftId?: number;
    id?: number;
    createdOnUtc?: string;
    updatedOnUtc?: string;
}

export interface ShiftMediaFileRes {
    blobName?: string | null;
    fileName?: string | null;
    description?: string | null;
    blobType?: BlobType;
    sasToken?: string | null;
    sasUrl?: string | null;
    expiresOnUtc?: string;
    createdOnUtc?: string | null;
    id?: number;
    shiftId?: number;
    shiftMediaType?: ShiftMediaType;
}

export enum ShiftMediaType {
    _0 = 0,
}

export interface ShiftMinRes {
    id?: number;
    startedOnLocal?: string | null;
    endedOnLocal?: string | null;
    routeId?: string | null;
    otdTotalLateWindows?: number | null;
    /** On time delivery percentage */
    otdPercentage?: number | null;
    otdLateArrivalMinutes?: number | null;
    otdLateDepartureMinutes?: number | null;
    /** e.g. August 10, 2025 */
    routePerformanceWeekEnding?: string | null;
    routePerformanceOnTimeOrders?: number | null;
    routePerformanceOrders?: number | null;
    routePerformancePlannedReload?: boolean | null;
    /** On time delivery percentage */
    routePerformanceOtdPercentage?: number | null;
    /** Overage percentage */
    routePerformanceOveragePercentage?: number | null;
    /** e.g. 16.72 */
    routePerformanceLateArrivalMinsPerRoute?: number | null;
    /** e.g. 11.68 */
    routePerformanceDwellPerRoute?: number | null;
    /** e.g. 22.68 */
    routePerformanceUnloadingPerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceWGOIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseCustomerIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseEnrouteIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseIgnitionOffOutsideGeofence?: number | null;
    /** e.g. 4.02 */
    routePerformanceTotalIdleTimePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceCheckoutOutsideGeofencePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceServiceAndUnknownOveragePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceDriveAndUnknownOveragePerRoute?: number | null;
    /** Rego, if vehicle has not been listed in Vehicles table */
    unlistedVehicleRego?: string | null;
    /** Estimated time of vehicle return as specified by the Driver.
Manager can request this from Driver. */
    estimatedVehicleReturnLocal?: string | null;
    /** Utc when the Vehicle is due for usage in the next Shift */
    nextShiftVehicleDueByLocal?: string | null;
    /** Phone number of the Driver who had the vehicle in the previous Shift */
    previousShiftDriverPhone?: string | null;
    /** Odometer reading at Shift Start */
    startOdometerKms?: number;
    /** Odometer reading at Shift End */
    endOdometerKms?: number | null;
    /** Prefilled Jot Form URL, only availble until user says he has submitted the jotform.
If shift has ended and the field is null, it means user (manager on his behalf) has submitted the jotform */
    jotFormUrl?: string | null;
    /** This is populated when user submits a jotform.
If this is null, it means user has not submitted the jotform yet.
This can be used to edit a submission if needed.
Although numeric in Jotform's system, we save as string.
This overrides the Api.Poco.Dtos.Shift.ShiftMinRes.JotFormUrl */
    jotformSubmissionId?: string | null;
    /** If this is null, it means user has not submitted the jotform yet.
This overrides the Api.Poco.Dtos.Shift.ShiftMinRes.JotFormUrl */
    jotformSubmittedOnUtc?: string | null;
    /** If specified then the Driver must reach the Jobsite at this time. */
    driverArrivalTimeLocal?: string | null;
    scheduledStartLocal?: string | null;
    scheduledEndLocal?: string | null;
    scheduledWeight?: number | null;
    scheduledKms?: number | null;
    scheduledDrops?: number | null;
    scheduledDifficulty?: number | null;
    scheduledTotalWorkHours?: number | null;
    /** Instructions for Driver or assigned user */
    instructions?: string | null;
    breachCalculatedUsing?: BreachCalculationType;
    shiftStatus?: ShiftStatus;
    dock?: string | null;
    /** Populated during Google Sheet import only.
Since AM or PM is decided by Linfox there and may not be actual AM or PM */
    amOrPm?: string | null;
    shiftSupervisorName?: string | null;
    shiftSupervisorPhone?: string | null;
    user?: UserRes;
    /** User assigned to this shift has accepted it */
    userHasAccepted?: boolean | null;
    vehicle?: VehicleRes;
    estimatedVehicleReturnUtcRequestedByUser?: UserRes;
    jobsite?: JobsiteRes;
    extCompany?: ExtCompanyRes;
}

export interface ShiftNRAPagedReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
    dateTimeInterval: DateTimeInterval370Days;
    hasBreach?: boolean | null;
}

export interface ShiftNRDownloadReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
    dateTimeInterval: DateTimeInterval15Days;
}

export interface ShiftNREmailReq {
    /** Sample available in !:Samples.HtmlEmail */
    htmlEmailBody: string;
    companyId: number;
}

export interface ShiftNRODataRes {
    id?: number;
    /** e.g. NSW */
    stateCode?: string | null;
    /** Shift Date */
    date?: string | null;
    /** Computed Shift Date from Api.Poco.Dtos.ShiftNR.ShiftNRODataRes.Date */
    dateUtc?: string;
    dateLocal?: string | null;
    /** Driver's name */
    name?: string | null;
    email?: string | null;
    /** e.g Yes or No */
    loginByScanner?: string | null;
    /** Reason if Api.Poco.Dtos.ShiftNR.ShiftNRODataRes.LoginByScanner is No */
    reasonForNoLoginByScanner?: string | null;
    store?: string | null;
    comments?: string | null;
    /** AKA CSA ID */
    extDriverId?: string | null;
    /** Vehicle Rego */
    rego?: string | null;
    /** AM or PM Shift */
    amOrPM?: string | null;
    /** Shift's start time e.g. 14:33 */
    startTime?: string | null;
    /** Computed Shift Start Time from Api.Poco.Dtos.ShiftNR.ShiftNRODataRes.StartTime */
    startTimeUtc?: string;
    startTimeLocal?: string | null;
    /** Shift's end time e.g. 14:33 */
    endTime?: string | null;
    /** Computed Shift End Time from Api.Poco.Dtos.ShiftNR.ShiftNRODataRes.EndTime */
    endTimeUtc?: string;
    endTimeLocal?: string | null;
    totalWorkingHours?: string | null;
    actualWorkingHours?: number;
    shiftNrType?: ShiftNrType;
    contractOwnerEmail?: string | null;
    contractOwnerName?: string | null;
    fleetIoNumber?: string | null;
    adhocType?: string | null;
    kilometersDriven?: string | null;
    activityType?: string | null;
    /** e.g. Yes - single rest */
    restTaken?: string | null;
    /** e.g. 14:33 */
    rest1StartTime?: string | null;
    /** Computed Rest1 Start Time from Api.Poco.Dtos.ShiftNR.ShiftNRODataRes.Rest1StartTime */
    rest1StartTimeUtc?: string | null;
    rest1StartTimeLocal?: string | null;
    /** e.g. 14:33 */
    rest1EndTime?: string | null;
    /** Computed Rest1 End Time from Api.Poco.Dtos.ShiftNR.ShiftNRODataRes.Rest1EndTime */
    rest1EndTimeUtc?: string | null;
    rest1EndTimeLocal?: string | null;
    /** e.g. 14:33 */
    rest2StartTime?: string | null;
    /** Computed Rest2 Start Time from Api.Poco.Dtos.ShiftNR.ShiftNRODataRes.Rest2StartTime */
    rest2StartTimeUtc?: string | null;
    rest2StartTimeLocal?: string | null;
    /** e.g. 14:33 */
    rest2EndTime?: string | null;
    /** Computed Rest2 End Time from Api.Poco.Dtos.ShiftNR.ShiftNRODataRes.Rest2EndTime */
    rest2EndTimeUtc?: string | null;
    rest2EndTimeLocal?: string | null;
    segment1WorkedForHours?: number;
    segment2WorkedForHours?: number;
    segment3WorkedForHours?: number;
    hasWorkedOver12Hours?: boolean;
    hasWorkedOver5HoursInAnySegment?: boolean;
    hasBreach?: boolean;
    /** Upto 7 */
    pastConsecutiveDaysWorked?: number;
    /** Has worked for 6 or more consecutive days */
    hasWorkedOver6PastConsecutiveDays?: boolean;
    /** Owner's or Manager's remark on this ShiftNR. e.g. incorrect data entry by Driver */
    remark?: string | null;
    companyId?: number;
    /** Only available if User exists as a Staff in our system */
    userId?: number | null;
    /** Id of the shift associated with this ShiftNR */
    shiftId?: number | null;
    shiftNRWarnings?: ShiftNRWarningODataRes[] | null;
}

export interface ShiftNRPagedReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
    dateTimeInterval: DateTimeInterval15Days;
}

export interface ShiftNRRecomputePropertiesReq {
    /** ShiftNR Ids that need to be updated for Computed properties */
    ids: number[];
}

export interface ShiftNRRemarkReq {
    /** Shift NR Id */
    id?: number;
    /** Owner's or Manager's remark on this ShiftNR. e.g. incorrect data entry by Driver */
    remark?: string | null;
}

export interface ShiftNRReq {
    /** e.g. NSW */
    stateCode?: string | null;
    /** Shift Date */
    date?: string | null;
    /** Driver's name */
    name?: string | null;
    email?: string | null;
    /** e.g Yes or No */
    loginByScanner?: string | null;
    /** Reason if Api.Poco.Dtos.ShiftNR.ShiftNRReq.LoginByScanner is No */
    reasonForNoLoginByScanner?: string | null;
    store?: string | null;
    comments?: string | null;
    /** AKA CSA ID */
    extDriverId?: string | null;
    /** Vehicle Rego */
    rego?: string | null;
    /** AM or PM Shift */
    amOrPM?: string | null;
    /** Shift's start time e.g. 14:33 */
    startTime?: string | null;
    /** Shift's end time e.g. 14:33 */
    endTime?: string | null;
    totalWorkingHours?: string | null;
    shiftNrType?: ShiftNrType;
    contractOwnerEmail?: string | null;
    contractOwnerName?: string | null;
    fleetIoNumber?: string | null;
    adhocType?: string | null;
    kilometersDriven?: string | null;
    activityType?: string | null;
    /** e.g. Yes - single rest */
    restTaken?: string | null;
    /** e.g. 14:33 */
    rest1StartTime?: string | null;
    /** e.g. 14:33 */
    rest1EndTime?: string | null;
    /** e.g. 14:33 */
    rest2StartTime?: string | null;
    /** e.g. 14:33 */
    rest2EndTime?: string | null;
    stateId?: number;
}

export interface ShiftNRRes {
    id?: number;
    /** e.g. NSW */
    stateCode?: string | null;
    /** Shift Date */
    date?: string | null;
    /** Computed Shift Date from Api.Poco.Dtos.ShiftNR.ShiftNRRes.Date */
    dateUtc?: string;
    dateLocal?: string | null;
    /** Driver's name */
    name?: string | null;
    email?: string | null;
    /** e.g Yes or No */
    loginByScanner?: string | null;
    /** Reason if Api.Poco.Dtos.ShiftNR.ShiftNRRes.LoginByScanner is No */
    reasonForNoLoginByScanner?: string | null;
    store?: string | null;
    comments?: string | null;
    /** AKA CSA ID */
    extDriverId?: string | null;
    /** Vehicle Rego */
    rego?: string | null;
    /** AM or PM Shift */
    amOrPM?: string | null;
    /** Shift's start time e.g. 14:33 */
    startTime?: string | null;
    /** Computed Shift Start Time from Api.Poco.Dtos.ShiftNR.ShiftNRRes.StartTime */
    startTimeUtc?: string;
    startTimeLocal?: string | null;
    /** Shift's end time e.g. 14:33 */
    endTime?: string | null;
    /** Computed Shift End Time from Api.Poco.Dtos.ShiftNR.ShiftNRRes.EndTime */
    endTimeUtc?: string;
    endTimeLocal?: string | null;
    totalWorkingHours?: string | null;
    actualWorkingHours?: number;
    shiftNrType?: ShiftNrType;
    contractOwnerEmail?: string | null;
    contractOwnerName?: string | null;
    fleetIoNumber?: string | null;
    adhocType?: string | null;
    kilometersDriven?: string | null;
    activityType?: string | null;
    /** e.g. Yes - single rest */
    restTaken?: string | null;
    /** e.g. 14:33 */
    rest1StartTime?: string | null;
    /** Computed Rest1 Start Time from Api.Poco.Dtos.ShiftNR.ShiftNRRes.Rest1StartTime */
    rest1StartTimeUtc?: string | null;
    rest1StartTimeLocal?: string | null;
    /** e.g. 14:33 */
    rest1EndTime?: string | null;
    /** Computed Rest1 End Time from Api.Poco.Dtos.ShiftNR.ShiftNRRes.Rest1EndTime */
    rest1EndTimeUtc?: string | null;
    rest1EndTimeLocal?: string | null;
    /** e.g. 14:33 */
    rest2StartTime?: string | null;
    /** Computed Rest2 Start Time from Api.Poco.Dtos.ShiftNR.ShiftNRRes.Rest2StartTime */
    rest2StartTimeUtc?: string | null;
    rest2StartTimeLocal?: string | null;
    /** e.g. 14:33 */
    rest2EndTime?: string | null;
    /** Computed Rest2 End Time from Api.Poco.Dtos.ShiftNR.ShiftNRRes.Rest2EndTime */
    rest2EndTimeUtc?: string | null;
    rest2EndTimeLocal?: string | null;
    segment1WorkedForHours?: number;
    segment2WorkedForHours?: number;
    segment3WorkedForHours?: number;
    hasWorkedOver12Hours?: boolean;
    hasWorkedOver5HoursInAnySegment?: boolean;
    hasBreach?: boolean;
    /** Upto 7 */
    pastConsecutiveDaysWorked?: number;
    /** Has worked for 6 or more consecutive days */
    hasWorkedOver6PastConsecutiveDays?: boolean;
    /** Owner's or Manager's remark on this ShiftNR. e.g. incorrect data entry by Driver */
    remark?: string | null;
    companyId?: number;
    /** Only available if User exists as a Staff in our system */
    userId?: number | null;
    /** Id of the shift associated with this ShiftNR */
    shiftId?: number | null;
    shiftNRWarnings?: ShiftNRWarningRes[] | null;
}

/** Provides for paginated results. */
export interface ShiftNRResPage {
    /** The collection of objects belonging to this page. */
    items?: ShiftNRRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface ShiftNRWarningODataRes {
    id?: number;
    /** Warning message for the Driver */
    message?: string | null;
    createdOnUtc?: string;
    updatedOnUtc?: string;
    shiftNrId?: number;
    createdByUserId?: number;
    acknowledgedOnUtc?: string | null;
    acknowledgedByUserId?: number | null;
}

export interface ShiftNRWarningReq {
    /** Warning message for the Driver */
    message: string;
    shiftNrId?: number;
}

export interface ShiftNRWarningRes {
    id?: number;
    /** Warning message for the Driver */
    message?: string | null;
    createdOnUtc?: string;
    updatedOnUtc?: string;
    shiftNrId?: number;
    createdByUser?: UserMinRes;
    acknowledgedOnUtc?: string | null;
    acknowledgedByUser?: UserMinRes;
}

export enum ShiftNrType {
    _0 = 0,
    _1 = 1,
}

export interface ShiftODataRes {
    id?: number;
    /** Actual start time */
    startedOnUTC?: string | null;
    startedOnLocal?: string | null;
    /** Actual end time */
    endedOnUTC?: string | null;
    endedOnLocal?: string | null;
    routeId?: string | null;
    otdTotalLateWindows?: number | null;
    /** On time delivery percentage */
    otdPercentage?: number | null;
    otdLateArrivalMinutes?: number | null;
    otdLateDepartureMinutes?: number | null;
    /** e.g. August 10, 2025 */
    routePerformanceWeekEnding?: string | null;
    routePerformanceOnTimeOrders?: number | null;
    routePerformanceOrders?: number | null;
    routePerformancePlannedReload?: boolean | null;
    /** On time delivery percentage */
    routePerformanceOtdPercentage?: number | null;
    /** Overage percentage */
    routePerformanceOveragePercentage?: number | null;
    /** e.g. 16.72 */
    routePerformanceLateArrivalMinsPerRoute?: number | null;
    /** e.g. 11.68 */
    routePerformanceDwellPerRoute?: number | null;
    /** e.g. 22.68 */
    routePerformanceUnloadingPerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceWGOIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseCustomerIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseEnrouteIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseIgnitionOffOutsideGeofence?: number | null;
    /** e.g. 4.02 */
    routePerformanceTotalIdleTimePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceCheckoutOutsideGeofencePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceServiceAndUnknownOveragePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceDriveAndUnknownOveragePerRoute?: number | null;
    /** Rego, if vehicle has not been listed in Vehicles table */
    unlistedVehicleRego?: string | null;
    /** Estimated time of vehicle return by the Driver.
Manager can request this from Driver. */
    estimatedVehicleReturnUtc?: string | null;
    /** Estimated time of vehicle return as specified by the Driver.
Manager can request this from Driver. */
    estimatedVehicleReturnLocal?: string | null;
    /** Utc when the Vehicle is due for usage in the next Shift */
    nextShiftVehicleDueByLocal?: string | null;
    /** Phone number of the Driver who had the vehicle in the previous Shift */
    previousShiftDriverPhone?: string | null;
    /** Odometer reading at Shift Start */
    startOdometerKms?: number;
    /** Odometer reading at Shift End */
    endOdometerKms?: number | null;
    /** Prefilled Jot Form URL, only availble until user says he has submitted the jotform.
If shift has ended and the field is null, it means user (manager on his behalf) has submitted the jotform */
    jotFormUrl?: string | null;
    /** This is populated when user submits a jotform.
If this is null, it means user has not submitted the jotform yet.
This can be used to edit a submission if needed.
Although numeric in Jotform's system, we save as string.
This overrides the Api.Poco.Dtos.Shift.ShiftODataRes.JotFormUrl */
    jotformSubmissionId?: string | null;
    /** If this is null, it means user has not submitted the jotform yet.
This overrides the Api.Poco.Dtos.Shift.ShiftODataRes.JotFormUrl */
    jotformSubmittedOnUtc?: string | null;
    /** If specified then the Driver must reach the Jobsite at this time. */
    driverArrivalTimeUtc?: string | null;
    driverArrivalTimeLocal?: string | null;
    scheduledStartUTC?: string | null;
    scheduledStartLocal?: string | null;
    scheduledEndLocal?: string | null;
    scheduledWeight?: number | null;
    scheduledKms?: number | null;
    scheduledDrops?: number | null;
    scheduledDifficulty?: number | null;
    scheduledTotalWorkHours?: number | null;
    hasReload?: boolean | null;
    maxSegmentWeight?: number | null;
    maxTruckWeight?: number | null;
    maxPayload?: number | null;
    /** Instructions for Driver or assigned user */
    instructions?: string | null;
    breachCalculatedUsing?: BreachCalculationType;
    shiftStatus?: ShiftStatus;
    dock?: string | null;
    /** Populated during Google Sheet import only.
Since AM or PM is decided by Linfox there and may not be actual AM or PM */
    amOrPm?: string | null;
    shiftSupervisorName?: string | null;
    shiftSupervisorPhone?: string | null;
    userId?: number;
    user?: UserODataRes;
    companyId?: number;
    /** User assigned to this shift has accepted it */
    userHasAccepted?: boolean | null;
    vehicleId?: number | null;
    vehicle?: VehicleODataRes;
    estimatedVehicleReturnUtcRequestedByUserId?: number | null;
    estimatedVehicleReturnUtcRequestedByUser?: UserODataRes;
    jobsiteId?: number | null;
    jobsite?: JobsiteODataRes;
    shiftBreaks?: ShiftBreakODataRes[] | null;
    shiftComments?: ShiftCommentODataRes[] | null;
    preCheckAnswers?: PreCheckAnswerODataRes[] | null;
    checkins?: CheckinODataRes[] | null;
    shiftNRs?: ShiftNRODataRes[] | null;
}

export interface ShiftOtdReq {
    otdTotalLateWindows?: number | null;
    /** On time delivery percentage */
    otdPercentage?: number | null;
    otdLateArrivalMinutes?: number | null;
    otdLateDepartureMinutes?: number | null;
    /** e.g. August 10, 2025 */
    routePerformanceWeekEnding?: string | null;
    routePerformanceOnTimeOrders?: number | null;
    routePerformanceOrders?: number | null;
    routePerformancePlannedReload?: boolean | null;
    /** On time delivery percentage */
    routePerformanceOtdPercentage?: number | null;
    /** Overage percentage */
    routePerformanceOveragePercentage?: number | null;
    /** e.g. 16.72 */
    routePerformanceLateArrivalMinsPerRoute?: number | null;
    /** e.g. 11.68 */
    routePerformanceDwellPerRoute?: number | null;
    /** e.g. 22.68 */
    routePerformanceUnloadingPerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceWGOIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseCustomerIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseEnrouteIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseIgnitionOffOutsideGeofence?: number | null;
    /** e.g. 4.02 */
    routePerformanceTotalIdleTimePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceCheckoutOutsideGeofencePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceServiceAndUnknownOveragePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceDriveAndUnknownOveragePerRoute?: number | null;
}

export interface ShiftOtdSyncReq {
    companyId?: number;
    dateTimeIntervalUtc: DateTimeIntervalUtc;
}

export interface ShiftPageRes {
    id?: number;
    /** Actual start time */
    startedOnUTC?: string | null;
    /** Actual end time */
    endedOnUTC?: string | null;
    startedOnLocal?: string | null;
    endedOnLocal?: string | null;
    scheduledStartUTC?: string | null;
    scheduledEndUTC?: string | null;
    routeId?: string | null;
    otdTotalLateWindows?: number | null;
    /** On time delivery percentage */
    otdPercentage?: number | null;
    otdLateArrivalMinutes?: number | null;
    otdLateDepartureMinutes?: number | null;
    /** e.g. August 10, 2025 */
    routePerformanceWeekEnding?: string | null;
    routePerformanceOnTimeOrders?: number | null;
    routePerformanceOrders?: number | null;
    routePerformancePlannedReload?: boolean | null;
    /** On time delivery percentage */
    routePerformanceOtdPercentage?: number | null;
    /** Overage percentage */
    routePerformanceOveragePercentage?: number | null;
    /** e.g. 16.72 */
    routePerformanceLateArrivalMinsPerRoute?: number | null;
    /** e.g. 11.68 */
    routePerformanceDwellPerRoute?: number | null;
    /** e.g. 22.68 */
    routePerformanceUnloadingPerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceWGOIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseCustomerIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseEnrouteIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseIgnitionOffOutsideGeofence?: number | null;
    /** e.g. 4.02 */
    routePerformanceTotalIdleTimePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceCheckoutOutsideGeofencePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceServiceAndUnknownOveragePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceDriveAndUnknownOveragePerRoute?: number | null;
    /** Rego, if vehicle has not been listed in Vehicles table */
    unlistedVehicleRego?: string | null;
    /** Estimated time of vehicle return as specified by the Driver.
Manager can request this from Driver. */
    estimatedVehicleReturnLocal?: string | null;
    /** Utc when the Vehicle is due for usage in the next Shift */
    nextShiftVehicleDueByLocal?: string | null;
    /** Phone number of the Driver who had the vehicle in the previous Shift */
    previousShiftDriverPhone?: string | null;
    /** Odometer reading at Shift Start */
    startOdometerKms?: number;
    /** Odometer reading at Shift End */
    endOdometerKms?: number | null;
    /** Prefilled Jot Form URL, only availble until user says he has submitted the jotform.
If shift has ended and the field is null, it means user (manager on his behalf) has submitted the jotform */
    jotFormUrl?: string | null;
    /** This is populated when user submits a jotform.
If this is null, it means user has not submitted the jotform yet.
This can be used to edit a submission if needed.
Although numeric in Jotform's system, we save as string.
This overrides the Api.Poco.Dtos.Shift.ShiftPageRes.JotFormUrl */
    jotformSubmissionId?: string | null;
    /** If this is null, it means user has not submitted the jotform yet.
This overrides the Api.Poco.Dtos.Shift.ShiftPageRes.JotFormUrl */
    jotformSubmittedOnUtc?: string | null;
    /** If specified then the Driver must reach the Jobsite at this time. */
    driverArrivalTimeLocal?: string | null;
    scheduledStartLocal?: string | null;
    scheduledEndLocal?: string | null;
    scheduledWeight?: number | null;
    scheduledKms?: number | null;
    scheduledDrops?: number | null;
    scheduledDifficulty?: number | null;
    scheduledTotalWorkHours?: number | null;
    hasReload?: boolean | null;
    maxSegmentWeight?: number | null;
    maxTruckWeight?: number | null;
    maxPayload?: number | null;
    /** Instructions for Driver or assigned user */
    instructions?: string | null;
    breachCalculatedUsing?: BreachCalculationType;
    shiftStatus?: ShiftStatus;
    dock?: string | null;
    /** Populated during Google Sheet import only.
Since AM or PM is decided by Linfox there and may not be actual AM or PM */
    amOrPm?: string | null;
    shiftSupervisorName?: string | null;
    shiftSupervisorPhone?: string | null;
    user?: UserRes;
    /** User assigned to this shift has accepted it */
    userHasAccepted?: boolean | null;
    vehicle?: VehicleRes;
    estimatedVehicleReturnUtcRequestedByUser?: UserRes;
    jobsite?: JobsiteRes;
    extCompany?: ExtCompanyRes;
    shiftBreaks?: ShiftBreakRes[] | null;
    shiftNRs?: ShiftNRRes[] | null;
    checkins?: CheckinMinRes[] | null;
    shiftWarnings?: ShiftWarningRes[] | null;
    shiftFleetIoFormSubmissions?: ShiftFleetIoFormSubmissionRes[] | null;
    shiftVoiceOfCustomerComments?: ShiftVoiceOfCustomerCommentRes[] | null;
}

/** Provides for paginated results. */
export interface ShiftPageResPage {
    /** The collection of objects belonging to this page. */
    items?: ShiftPageRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface ShiftPagedReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
    dateTimeInterval: DateTimeInterval8Days;
}

export interface ShiftPotentialBreach {
    /** Potential breaches in the shift req, if any */
    breachMessages?: string[] | null;
}

export interface ShiftRes {
    id?: number;
    startedOnLocal?: string | null;
    endedOnLocal?: string | null;
    routeId?: string | null;
    otdTotalLateWindows?: number | null;
    /** On time delivery percentage */
    otdPercentage?: number | null;
    otdLateArrivalMinutes?: number | null;
    otdLateDepartureMinutes?: number | null;
    /** e.g. August 10, 2025 */
    routePerformanceWeekEnding?: string | null;
    routePerformanceOnTimeOrders?: number | null;
    routePerformanceOrders?: number | null;
    routePerformancePlannedReload?: boolean | null;
    /** On time delivery percentage */
    routePerformanceOtdPercentage?: number | null;
    /** Overage percentage */
    routePerformanceOveragePercentage?: number | null;
    /** e.g. 16.72 */
    routePerformanceLateArrivalMinsPerRoute?: number | null;
    /** e.g. 11.68 */
    routePerformanceDwellPerRoute?: number | null;
    /** e.g. 22.68 */
    routePerformanceUnloadingPerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceWGOIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseCustomerIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseEnrouteIdlePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceMicroliseIgnitionOffOutsideGeofence?: number | null;
    /** e.g. 4.02 */
    routePerformanceTotalIdleTimePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceCheckoutOutsideGeofencePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceServiceAndUnknownOveragePerRoute?: number | null;
    /** e.g. 4.02 */
    routePerformanceDriveAndUnknownOveragePerRoute?: number | null;
    /** Rego, if vehicle has not been listed in Vehicles table */
    unlistedVehicleRego?: string | null;
    /** Estimated time of vehicle return as specified by the Driver.
Manager can request this from Driver. */
    estimatedVehicleReturnLocal?: string | null;
    /** Utc when the Vehicle is due for usage in the next Shift */
    nextShiftVehicleDueByLocal?: string | null;
    /** Phone number of the Driver who had the vehicle in the previous Shift */
    previousShiftDriverPhone?: string | null;
    /** Odometer reading at Shift Start */
    startOdometerKms?: number;
    /** Odometer reading at Shift End */
    endOdometerKms?: number | null;
    /** Prefilled Jot Form URL, only availble until user says he has submitted the jotform.
If shift has ended and the field is null, it means user (manager on his behalf) has submitted the jotform */
    jotFormUrl?: string | null;
    /** This is populated when user submits a jotform.
If this is null, it means user has not submitted the jotform yet.
This can be used to edit a submission if needed.
Although numeric in Jotform's system, we save as string.
This overrides the Api.Poco.Dtos.Shift.ShiftRes.JotFormUrl */
    jotformSubmissionId?: string | null;
    /** If this is null, it means user has not submitted the jotform yet.
This overrides the Api.Poco.Dtos.Shift.ShiftRes.JotFormUrl */
    jotformSubmittedOnUtc?: string | null;
    /** If specified then the Driver must reach the Jobsite at this time. */
    driverArrivalTimeLocal?: string | null;
    scheduledStartLocal?: string | null;
    scheduledEndLocal?: string | null;
    scheduledWeight?: number | null;
    scheduledKms?: number | null;
    scheduledDrops?: number | null;
    scheduledDifficulty?: number | null;
    scheduledTotalWorkHours?: number | null;
    hasReload?: boolean | null;
    maxSegmentWeight?: number | null;
    maxTruckWeight?: number | null;
    maxPayload?: number | null;
    /** Instructions for Driver or assigned user */
    instructions?: string | null;
    breachCalculatedUsing?: BreachCalculationType;
    shiftStatus?: ShiftStatus;
    dock?: string | null;
    /** Populated during Google Sheet import only.
Since AM or PM is decided by Linfox there and may not be actual AM or PM */
    amOrPm?: string | null;
    shiftSupervisorName?: string | null;
    shiftSupervisorPhone?: string | null;
    user?: UserRes;
    /** User assigned to this shift has accepted it */
    userHasAccepted?: boolean | null;
    vehicle?: VehicleRes;
    estimatedVehicleReturnUtcRequestedByUser?: UserRes;
    jobsite?: JobsiteRes;
    extCompany?: ExtCompanyRes;
    shiftBreaks?: ShiftBreakRes[] | null;
    shiftComments?: ShiftCommentRes[] | null;
    preCheckAnswers?: PreCheckAnswerRes[] | null;
    checkins?: CheckinMinRes[] | null;
    shiftNRs?: ShiftNRRes[] | null;
    shiftMediaFiles?: ShiftMediaFileRes[] | null;
    formSubmissions?: FormSubmissionRes[] | null;
    shiftWarnings?: ShiftWarningRes[] | null;
    shiftFleetIoFormSubmissions?: ShiftFleetIoFormSubmissionRes[] | null;
    shiftVoiceOfCustomerComments?: ShiftVoiceOfCustomerCommentRes[] | null;
}

export enum ShiftStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export interface ShiftVoiceOfCustomerCommentAReq {
    /** Numeric but we save as string */
    orderNumber?: string | null;
    routeId?: string | null;
    deliveryComment?: string | null;
    careComment?: string | null;
    /** Numeric but we save as string */
    friendliness?: string | null;
    /** Numeric but we save as string */
    presentation?: string | null;
    correctiveFormUrl?: string | null;
    /** Also CommentDate */
    deliveryDate?: string | null;
    deliveryWindow?: string | null;
}

export interface ShiftVoiceOfCustomerCommentRes {
    id?: number;
    /** Numeric but we save as string */
    orderNumber?: string | null;
    routeId?: string | null;
    deliveryComment?: string | null;
    careComment?: string | null;
    /** Numeric but we save as string */
    friendliness?: string | null;
    /** Numeric but we save as string */
    presentation?: string | null;
    correctiveFormUrl?: string | null;
    /** Also CommentDate */
    deliveryDate?: string | null;
    deliveryWindow?: string | null;
    createdOnUtc?: string;
    updatedOnUtc?: string;
    shiftId?: number;
}

export interface ShiftWarningReq {
    /** Warning message for the Driver */
    message: string;
    shiftId?: number;
}

export interface ShiftWarningRes {
    id?: number;
    /** Warning message for the Driver */
    message?: string | null;
    createdOnUtc?: string;
    updatedOnUtc?: string;
    shiftId?: number;
    createdByUser?: UserMinRes;
    acknowledgedOnUtc?: string | null;
    acknowledgedByUser?: UserMinRes;
}

export enum SmsDeliveryStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface SmsHistoryARes {
    id?: number;
    companyId: number;
    from?: string | null;
    toPhoneNumber?: string | null;
    textBody?: string | null;
    /** Inicated the timestamp when this entry was created in SmsHistory table.
Hence this can be interpreted as SentOnUtc or FailedToSendOnUtc depending on SmsDeliveryStatus */
    createdOnUtc?: string;
    smsType?: SmsType;
    /** Number of retry attempts that were made to send the SMS. */
    retrysAttemptedToSend?: number;
    smsDeliveryStatus?: SmsDeliveryStatus;
    /** Used to store log of failure to send etc. */
    log?: string | null;
    company?: CompanyMinARes;
    recipientUserId?: number;
    recipientUser?: UserMinRes;
}

/** Provides for paginated results. */
export interface SmsHistoryAResPage {
    /** The collection of objects belonging to this page. */
    items?: SmsHistoryARes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface SmsQueueARes {
    id?: number;
    companyId: number;
    from?: string | null;
    textBody?: string | null;
    createdOnUtc?: string;
    failedOnUtc?: string | null;
    sendDeniedAtUtc?: string | null;
    sentOnUtc?: string | null;
    smsType?: SmsType;
    /** Number of retry attempts made to send the SMS.
This should be incremented with every attempt to send the SMS. */
    retrysAttemptedToSend?: number;
    smsDeliveryStatus?: SmsDeliveryStatus;
    /** Used to store log of failure to send etc. */
    log?: string | null;
    company?: CompanyMinARes;
    recipientUserId?: number;
    recipientUser?: UserMinRes;
}

/** Provides for paginated results. */
export interface SmsQueueAResPage {
    /** The collection of objects belonging to this page. */
    items?: SmsQueueARes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum SmsType {
    _0 = 0,
    _1 = 1,
}

export interface StaffReq {
    firstName: string;
    middleName?: string | null;
    lastName: string;
    /** Mobile phone */
    phoneNumber: string;
    email: string;
    /** The Role of the Staff e.g. Manager or Driver etc */
    role: string;
    address: AddressReq;
    /** External Driver Id
Only applicable for Drivers */
    extDriverId?: string | null;
    /** RCTI
Payroll invoices will be sent only when this is true. */
    recepientCreatedTaxInvoice?: boolean;
    abn?: string | null;
    dateOfBirthUtc?: string | null;
    emergencyContactFullName?: string | null;
    emergencyContactPhone?: string | null;
    drivingLicenseNumber?: string | null;
    drivingLicenseIssuedByStateId?: number | null;
    drivingLicenseRestriction?: string | null;
    drivingLicenseFirstIssuedOnUtc?: string | null;
    /** Driving License expires on this UTC date time. 
Only applicable for Drivers */
    drivingLicenseExpiresOnUTC?: string | null;
    visaType?: string | null;
    visaExpiryDateUtc?: string | null;
    rsatCertificateNumber?: string | null;
    rsatExpiryDateUtc?: string | null;
    drivingRecordEmissionDateUtc?: string | null;
    australianFederalPoliceCheckEmissionDateUtc?: string | null;
    employmentType?: EmploymentType;
    appUsagePattern?: AppUsagePattern;
    appUserLicenseClassMapReq?: AppUserLicenseClassMapReq;
    weeklyAvailability?: WeeklyAvailabilityReq;
}

export interface StaffRes {
    id?: number;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    /** True if the email address has been confirmed by the user/staff, otherwise false. */
    emailConfirmed?: boolean;
    role?: string | null;
    /** External Driver Id
Only applicable for Drivers */
    extDriverId?: string | null;
    /** Indicates if the User/Staff was Soft Deleted */
    isDeleted?: boolean;
    isRegisteredForGST?: boolean;
    /** RCTI
Payroll invoices will be sent only when this is true. */
    recepientCreatedTaxInvoice?: boolean;
    abn?: string | null;
    dateOfBirthUtc?: string | null;
    address?: AddressRes;
    payRate?: PayRateRes;
    emergencyContactFullName?: string | null;
    emergencyContactPhone?: string | null;
    drivingLicenseNumber?: string | null;
    drivingLicenseIssuedByStateId?: number | null;
    drivingLicenseRestriction?: string | null;
    drivingLicenseFirstIssuedOnUtc?: string | null;
    /** Driving License expires on this UTC date time. 
Only applicable for Drivers */
    drivingLicenseExpiresOnUTC?: string | null;
    visaType?: string | null;
    visaExpiryDateUtc?: string | null;
    rsatCertificateNumber?: string | null;
    rsatExpiryDateUtc?: string | null;
    drivingRecordEmissionDateUtc?: string | null;
    australianFederalPoliceCheckEmissionDateUtc?: string | null;
    employmentType?: EmploymentType;
    weeklyAvailability?: WeeklyAvailabilityRes;
    appUsagePattern?: AppUsagePattern;
    appUserLicenseClassMap?: AppUserLicenseClassMapRes[] | null;
}

export interface StartScheduledShiftReq {
    /** Odometer reading at Shift Start */
    startOdometerKms?: number;
    geoLocation?: GeoLocationReq;
    preCheckAnswers: PreCheckAnswerReq[];
}

export interface StartShiftBreakReq {
    shiftId?: number;
    geoLocation?: GeoLocationReq;
}

export interface StateODataRes {
    id?: number;
    value?: string | null;
    /** The Time Zone local to this State
e.g. AUS Eastern Standard Time */
    timeZoneId?: string | null;
}

export interface StateRes {
    id?: number;
    value?: string | null;
    /** The Time Zone local to this State
e.g. AUS Eastern Standard Time */
    timeZoneId?: string | null;
}

export interface StopShiftBreakReq {
    shiftId?: number;
    geoLocation?: GeoLocationReq;
}

export interface StopShiftReq {
    /** Odometer reading at Shift End */
    endOdometerKms?: number;
    shiftComment: CreateShiftCommentReq;
    geoLocation?: GeoLocationReq;
}

export interface TaxAnnualReq {
    grossAnnualIncome: number;
    fiscalYear?: TaxFiscalYear;
    hasPrivateHealthInsurance?: boolean;
    dependents?: number;
    workRelatedDeductions?: number;
}

export interface TaxAnnualRes {
    calcultionLog?: string | null;
    grossAnnualIncome?: number;
    taxableIncome?: number;
    incomeTax?: number;
    medicareLevy?: number;
    medicareLevySurcharge?: number;
    totalTax?: number;
    netAnnualIncome?: number;
    netMonthlyIncome?: number;
    netFortnightlyIncome?: number;
    netWeeklyIncome?: number;
    superannuationContribution?: number;
    effectiveTaxRate?: number;
    marginalTaxRate?: number;
}

/** Represents a tax bracket with threshold and rate */
export interface TaxBracket {
    minIncome?: number;
    maxIncome?: number;
    rate?: number;
    cumulativeTax?: number;
}

export interface TaxByPayPeriodReq {
    grossAnnualIncome: number;
    fiscalYear?: TaxFiscalYear;
    hasPrivateHealthInsurance?: boolean;
    dependents?: number;
    workRelatedDeductions?: number;
    payPeriod: TaxPayPeriod;
}

export interface TaxByPayPeriodRes {
    calcultionLog?: string | null;
    grossPay?: number;
    tax?: number;
    netPay?: number;
    superannuation?: number;
    payPeriod?: TaxPayPeriod;
    fiscalYear?: TaxFiscalYear;
}

export enum TaxFiscalYear {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum TaxPayPeriod {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Tax year configuration containing all tax rates and thresholds */
export interface TaxYearConfig {
    fiscalYear?: TaxFiscalYear;
    taxBrackets?: TaxBracket[] | null;
    medicareLevyThresholds?: MedicareLevyThresholds;
    superannuationRate?: number;
}

export interface TimeZoneInfo {
    readonly id?: string | null;
    readonly hasIanaId?: boolean;
    readonly displayName?: string | null;
    readonly standardName?: string | null;
    readonly daylightName?: string | null;
    readonly baseUtcOffset?: string;
    readonly supportsDaylightSavingTime?: boolean;
}

export interface TokenCompanyRes {
    id?: number;
    name?: string | null;
    /** Public Url with readonly SAS of company Logo */
    logoBlobUrl?: string | null;
    /** Upper limit for maximum number of staff/employes that this company can have with currrent subscription/package
Note: This will be moved to subscription related table when they are implemented. */
    maximumEmployees?: number;
    /** e.g. If this is 200. No SMS sent for this Company should exceed 200 characters.
0 indicates no SMS is to be sent. */
    smsCharacterLimit?: number;
    /** e.g. If this is 500. Only 500 SMS of the type Automated can be sent for this Company. */
    automatedSmsLimit?: number;
    /** Number of Automated SMSes remaining.
This will be set to Api.Poco.Dtos.Company.TokenCompanyRes.AutomatedSmsLimit every time a new invoice is generated. */
    automatedSmsRemaining?: number;
    /** e.g. If this is 100. Only 100 SMS of the type Manual can be sent for this Company. */
    manualSmsLimit?: number;
    /** Number of Manual SMSes remaining.
This will be set to Api.Poco.Dtos.Company.TokenCompanyRes.ManualSmsLimit every time a new invoice is generated. */
    manualSmsRemaining?: number;
    /** Maximum number of FormsSubmissions that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formSubmissionsLimit?: number;
    /** Maximum number of Forms that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formsLimit?: number;
}

export interface TokenReq {
    userName: string;
    password: string;
    client_Id: string;
    /** Specify this as true to generate Refresh Token */
    rememberMe?: boolean | null;
}

export interface TokenRes {
    access_token?: string | null;
    token_type?: string | null;
    expires_in?: number;
    refresh_token?: string | null;
    client_id?: string | null;
    username?: string | null;
    user?: TokenUserRes;
    company?: TokenCompanyRes;
}

export interface TokenUserRes {
    id?: number;
    email?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    roles?: string[] | null;
}

export interface UpdateCompanyAReq {
    /** CompanyName */
    name?: string | null;
    /** Australian Business Number */
    abn?: string | null;
    /** Email Id to which notifications such as Shift Start will be sent.
In case this is not available, email the Owner's email id */
    notificationEmail?: string | null;
    /** Email Id from which we will receive Linfox Timesheet emails
e.g. this is populated as Contractor email in jotform */
    timesheetSourceEmail?: string | null;
    timesheetSourceEmailNsw?: string | null;
    timesheetSourceEmailVic?: string | null;
    timesheetSourceEmailQld?: string | null;
    timesheetSourceEmailTas?: string | null;
    timesheetSourceEmailAct?: string | null;
    timesheetSourceEmailNt?: string | null;
    timesheetSourceEmailSa?: string | null;
    timesheetSourceEmailWa?: string | null;
    /** Upper limit for maximum number of staff/employes that this company can have with currrent subscription/package
Note: This will be moved to subscription related table when they are implemented. */
    maximumEmployees?: number;
    /** e.g. If this is 200. No SMS sent for this Company should exceed 200 characters.
0 indicates no SMS is to be sent. */
    smsCharacterLimit?: number;
    /** e.g. If this is 500. Only 500 SMS of the type Automated can be sent for this Company. */
    automatedSmsLimit?: number;
    /** Number of Automated SMSes remaining.
This will be set to Api.Poco.Dtos.Company.UpdateCompanyAReq.AutomatedSmsLimit every time a new invoice is generated. */
    automatedSmsRemaining?: number;
    /** e.g. If this is 100. Only 100 SMS of the type Manual can be sent for this Company. */
    manualSmsLimit?: number;
    /** Number of Manual SMSes remaining.
This will be set to Api.Poco.Dtos.Company.UpdateCompanyAReq.ManualSmsLimit every time a new invoice is generated. */
    manualSmsRemaining?: number;
    /** Maximum number of FormsSubmissions that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formSubmissionsLimit?: number;
    /** Maximum number of Forms that this Company can have.
If the FormSubmissions reach this limit then error is thrown if more submissions occur. */
    formsLimit?: number;
    /** Maximum number of questions a Api.Poco.Dtos.Forms.FormReq can have */
    formsMaxQuestionsPerFormLimit?: number;
    /** Maximum number of Files (media, photo, document etc) a Api.Poco.Dtos.Forms.FormReq can have */
    formsMaxFilesPerFormLimit?: number;
    /** Maximum number of Files a question (Api.Poco.Dtos.FormQuestion.JsonModels.FormQuestionMedia) can have */
    formsMaxFilesPerQuestionLimit?: number;
}

export interface UpdateExtCompanyReq {
    /** Name of the external Company e.g. Linfox */
    name?: string | null;
    /** Name of a Company in our system, used in external systems such as JotForm */
    extCompanyJotformName?: string | null;
    /** EmailId to send notifications such as ShiftStart Precheck questions to Linfox
Note: Keep this empty/null to avoid sending email notifications to ExtCompany */
    notificationEmail?: string | null;
}

export interface UpdatePayRatesReq {
    staffIds: number[];
    payRateReq: PayRateReq;
}

export interface UpdatePayrollLineItemReq {
    userId?: number;
    /** Date on which the Shift happened (time should be 00:00:00) */
    dateLocal: string;
    /** Date cell as read from Payroll Excel. */
    dateLocalBeforeParsing?: string | null;
    jobsiteId?: number;
    /** AM, PM, 0 , MD, null */
    shift?: string | null;
    /** numeric , optional */
    hours?: number;
    comments?: string | null;
    /** numeric, optional */
    adjustments?: number;
    paidStartDateTimeLocal?: string | null;
    paidEndDateTimeLocal?: string | null;
    creditNote?: string | null;
    /** Unique ID used for updating an existing entity */
    id?: number;
}

export interface UpdateScheduledShiftForDriver {
    /** Rego, if vehicle has not been listed in Vehicles table */
    unlistedVehicleRego?: string | null;
    /** Listed vehicle used for this Shift */
    vehicleId?: number | null;
}

export interface UpdateUserToPayRateJobsiteAddOnMapReq {
    userIds: number[];
    payRateJobsiteAddOnId?: number;
}

export interface UpdateUserToPayRateShiftDurationAddOnMapReq {
    userIds: number[];
    payRateShiftDurationAddOnId?: number;
}

export interface UpdateUserToPayRateShiftTimeAddOnMapReq {
    userIds: number[];
    payRateShiftTimeAddOnId?: number;
}

export interface UserDetailedRes {
    id?: number;
    userName?: string | null;
    email?: string | null;
    emailConfirmed?: boolean;
    phoneNumber?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    role?: string | null;
    company?: CompanyMinARes;
    /** Indicates if the User/Staff was Soft Deleted */
    isSoftDeleted?: boolean;
    lockoutEnd?: string | null;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    employmentType?: EmploymentType;
    appUsagePattern?: AppUsagePattern;
}

/** Provides for paginated results. */
export interface UserDetailedResPage {
    /** The collection of objects belonging to this page. */
    items?: UserDetailedRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export interface UserMinRes {
    id?: number;
    email?: string | null;
    phoneNumber?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
}

export interface UserODataRes {
    id?: number;
    email?: string | null;
    emailConfirmed?: boolean;
    phoneNumber?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    /** External Driver Id
AKA CSA Id */
    extDriverId?: string | null;
    appUsagePattern?: AppUsagePattern;
}

export interface UserPayMonthlySummaryReq {
    /** API will ignore the Day. It will assume 1st day of the required month and year. */
    startTimeUtc?: string;
    /** API will ignore the Day. It will assume last day of the required month and year. */
    endTimeUtc?: string;
}

export interface UserPayMonthlySummaryRes {
    id?: number;
    /** Pay during the Month.
Update this only after succesfuly processing the N:Api.Poco.Dtos.PayrollPeriod */
    payAggregated?: number;
    /** Adjustments during the Month.
Update this only after succesfuly processing the N:Api.Poco.Dtos.PayrollPeriod */
    adjustmentsAggregated?: number;
    /** Number of hours worked during the Month
Update this only after succesfuly processing the N:Api.Poco.Dtos.PayrollPeriod */
    hoursAggregated?: number;
    /** Total of hours for the day as noted in timesheets (jotform submitted)
Null indicates that hours not calculated (e.g. old payrolls) */
    timesheetHoursForDayAggregated?: number | null;
    /** DateTime with Month and Year being used.
Day is to be ignored and set to 1st of every month for calculation purposes. */
    monthYearUtc?: string;
    user?: UserMinRes;
}

export interface UserPayrollDetailedRes {
    id?: number;
    userName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    /** Indicates if the User/Staff was Soft Deleted */
    isSoftDeleted?: boolean;
    /** External Driver Id
Only applicable for Drivers */
    extDriverId?: string | null;
    isRegisteredForGST?: boolean;
    abn?: string | null;
    employmentType?: EmploymentType;
}

export interface UserPayrollRes {
    id?: number;
    email?: string | null;
    phoneNumber?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    abn?: string | null;
    /** External Driver Id
AKA CSA Id */
    extDriverId?: string | null;
    employmentType?: EmploymentType;
}

export interface UserProfileReq {
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    /** External Driver Id
Only applicable for Drivers */
    extDriverId?: string | null;
    abn?: string | null;
    dateOfBirthUtc?: string | null;
    address: AddressReq;
    emergencyContactFullName?: string | null;
    emergencyContactPhone?: string | null;
    drivingLicenseNumber?: string | null;
    drivingLicenseIssuedByStateId?: number | null;
    drivingLicenseRestriction?: string | null;
    drivingLicenseFirstIssuedOnUtc?: string | null;
    /** Driving License expires on this UTC date time. 
Only applicable for Drivers */
    drivingLicenseExpiresOnUTC?: string | null;
    visaType?: string | null;
    visaExpiryDateUtc?: string | null;
    rsatCertificateNumber?: string | null;
    rsatExpiryDateUtc?: string | null;
    drivingRecordEmissionDateUtc?: string | null;
    australianFederalPoliceCheckEmissionDateUtc?: string | null;
    appUserLicenseClassMapReq?: AppUserLicenseClassMapReq;
}

export interface UserProfileRes {
    id?: number;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    role?: string | null;
    /** External Driver Id
Only applicable for Drivers */
    extDriverId?: string | null;
    isRegisteredForGST?: boolean;
    abn?: string | null;
    dateOfBirthUtc?: string | null;
    address?: AddressRes;
    emergencyContactFullName?: string | null;
    emergencyContactPhone?: string | null;
    drivingLicenseNumber?: string | null;
    drivingLicenseIssuedByStateId?: number | null;
    drivingLicenseRestriction?: string | null;
    drivingLicenseFirstIssuedOnUtc?: string | null;
    /** Driving License expires on this UTC date time. 
Only applicable for Drivers */
    drivingLicenseExpiresOnUTC?: string | null;
    visaType?: string | null;
    visaExpiryDateUtc?: string | null;
    rsatCertificateNumber?: string | null;
    rsatExpiryDateUtc?: string | null;
    drivingRecordEmissionDateUtc?: string | null;
    australianFederalPoliceCheckEmissionDateUtc?: string | null;
    employmentType?: EmploymentType;
    weeklyAvailability?: WeeklyAvailabilityRes;
    appUsagePattern?: AppUsagePattern;
    appUserLicenseClassMap?: AppUserLicenseClassMapRes[] | null;
}

export interface UserRes {
    id?: number;
    email?: string | null;
    emailConfirmed?: boolean;
    phoneNumber?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    /** External Driver Id
AKA CSA Id */
    extDriverId?: string | null;
    appUsagePattern?: AppUsagePattern;
}

export interface VehicleIssuePagedReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
    dateTimeInterval?: DateTimeInterval31Days;
}

export interface VehicleIssueReq {
    /** Short summary */
    summary: string;
    /** Description of the issue */
    description?: string | null;
    /** Action taken to address the Issue */
    actionTaken?: string | null;
    vehicleIssueStatus?: VehicleIssueStatus;
    vehicleId?: number;
    /** Shift, if any associated with this issue */
    shiftId?: number | null;
}

export interface VehicleIssueRes {
    id?: number;
    createdOnUtc?: string;
    updatedOnUtc?: string;
    /** Short summary */
    summary?: string | null;
    /** Description of the issue */
    description?: string | null;
    /** Action taken to address the Issue */
    actionTaken?: string | null;
    actionTakenOnUtc?: string | null;
    vehicleIssueStatus?: VehicleIssueStatus;
    vehicle?: VehicleRes;
    createdByUser?: UserMinRes;
    shift?: ShiftMinRes;
    /** Id in FleetIO */
    fleetIoId?: number | null;
}

/** Provides for paginated results. */
export interface VehicleIssueResPage {
    /** The collection of objects belonging to this page. */
    items?: VehicleIssueRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum VehicleIssueStatus {
    _0 = 0,
    _1 = 1,
}

export interface VehicleMinRes {
    id?: number;
    registrationNumber?: string | null;
    vehicleTypeId?: number;
    vehicleStatus?: VehicleStatus;
    vin?: string | null;
    /** The State in which the vehicle is operational
Null indicates any state(s) */
    stateId?: number | null;
}

export interface VehicleODataRes {
    id?: number;
    registrationNumber?: string | null;
    registrationExpiryDateUTC?: string;
    insuranceExpiryDateUTC?: string;
    vehicleTypeId?: number;
    vehicleStatus?: VehicleStatus;
    vin?: string | null;
    /** Last recorded Odometer reading of KMs */
    odometerKms?: number;
    nextServiceDueKms?: number | null;
    nextServiceDueDateUTC?: string | null;
    nextFridgeServiceDueDateUTC?: string | null;
    isSoftDeleted?: boolean;
    /** Pickup or last known location of the vehicle */
    location?: string | null;
    /** Maximum capacity of this vehicle */
    maxCapacityInKgs?: number | null;
    companyId?: number;
    /** The State in which the vehicle is operational
Null indicates any state(s) */
    stateId?: number | null;
    /** Id of the vehicle in FleetIO */
    fleetIoId?: number | null;
}

export interface VehiclePagedReq {
    /** The page number. */
    pageNumber: number;
    /** The number of entities expected on a page. */
    pageSize: number;
    /** Applies State Id filter over the paginated results. */
    stateIds?: number[] | null;
}

export interface VehicleReq {
    registrationNumber: string;
    registrationExpiryDateUTC?: string;
    insuranceExpiryDateUTC?: string;
    vehicleTypeId?: number;
    vehicleStatus?: VehicleStatus;
    vin?: string | null;
    /** Last recorded Odometer reading of KMs */
    odometerKms?: number;
    nextServiceDueKms?: number | null;
    nextServiceDueDateUTC?: string | null;
    nextFridgeServiceDueDateUTC?: string | null;
    /** Pickup or last known location of the vehicle */
    location?: string | null;
    /** Maximum capacity of this vehicle */
    maxCapacityInKgs?: number | null;
    /** The State in which the vehicle is operational. */
    stateId?: number;
}

export interface VehicleRes {
    id?: number;
    registrationNumber?: string | null;
    registrationExpiryDateUTC?: string;
    insuranceExpiryDateUTC?: string;
    vehicleTypeId?: number;
    vehicleStatus?: VehicleStatus;
    vin?: string | null;
    /** Last recorded Odometer reading of KMs */
    odometerKms?: number;
    nextServiceDueKms?: number | null;
    nextServiceDueDateUTC?: string | null;
    nextFridgeServiceDueDateUTC?: string | null;
    isSoftDeleted?: boolean;
    /** Pickup or last known location of the vehicle */
    location?: string | null;
    /** Maximum capacity of this vehicle */
    maxCapacityInKgs?: number | null;
    companyId?: number;
    /** The State in which the vehicle is operational
Null indicates any state(s) */
    stateId?: number | null;
    /** Id of the vehicle in FleetIO */
    fleetIoId?: number | null;
}

/** Provides for paginated results. */
export interface VehicleResPage {
    /** The collection of objects belonging to this page. */
    items?: VehicleRes[] | null;
    /** The total number of objects in the database. */
    totalCount?: number;
    /** The current page number. */
    pageNumber?: number;
    /** The current page size. */
    pageSize?: number;
}

export enum VehicleStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface VehicleTypeReq {
    value: string;
    maxLengthInMeters?: number | null;
    maxHeightInMeters?: number | null;
    maxWidthInMeters?: number | null;
    totalKgs?: number | null;
    /** Volume */
    cubicCapacityInMeters?: number | null;
    pallets?: string | null;
    vehicleClearanceInMeters?: number | null;
}

export interface VehicleTypeRes {
    id?: number;
    value?: string | null;
    maxLengthInMeters?: number | null;
    maxHeightInMeters?: number | null;
    maxWidthInMeters?: number | null;
    totalKgs?: number | null;
    /** Volume */
    cubicCapacityInMeters?: number | null;
    pallets?: string | null;
    vehicleClearanceInMeters?: number | null;
}

export interface WeeklyAvailabilityReq {
    sunday?: WeeklyAvailabilityType;
    monday?: WeeklyAvailabilityType;
    tuesday?: WeeklyAvailabilityType;
    wednesday?: WeeklyAvailabilityType;
    thrusday?: WeeklyAvailabilityType;
    friday?: WeeklyAvailabilityType;
    saturday?: WeeklyAvailabilityType;
}

export interface WeeklyAvailabilityRes {
    sunday?: WeeklyAvailabilityType;
    monday?: WeeklyAvailabilityType;
    tuesday?: WeeklyAvailabilityType;
    wednesday?: WeeklyAvailabilityType;
    thrusday?: WeeklyAvailabilityType;
    friday?: WeeklyAvailabilityType;
    saturday?: WeeklyAvailabilityType;
    id?: number;
    createdOnUtc?: string;
    updatedOnUtc?: string;
}

export enum WeeklyAvailabilityType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}